(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash"], factory);
	else if(typeof exports === 'object')
		exports["offeringListWidgetController"] = factory(require("lodash"));
	else
		root["offeringListWidgetController"] = factory(root["_"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__4__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://static.parastorage.com/services/bookings-widget/1.575.0/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1350);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/*!****************************************!*\
  !*** ./Shared/appKeys/SettingsKeys.ts ***!
  \****************************************/
/*! exports provided: SettingsKeys, MobileSettingsKeys, AllFontsInTheApp, AlignmentOptions, ImageResizeOptions, ImageShapeOptions, ImagePositionOptions, OfferingLayoutOptions, ImageAndTextRatioOptions, ButtonStyleOptions, DockLocationOptions, OfferingListLayoutOptions */
/*! exports used: AlignmentOptions, AllFontsInTheApp, ButtonStyleOptions, DockLocationOptions, ImageAndTextRatioOptions, ImagePositionOptions, ImageResizeOptions, ImageShapeOptions, MobileSettingsKeys, OfferingLayoutOptions, OfferingListLayoutOptions, SettingsKeys */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SettingsKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MobileSettingsKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AllFontsInTheApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlignmentOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ImageResizeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ImageShapeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ImagePositionOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return OfferingLayoutOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ImageAndTextRatioOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ButtonStyleOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DockLocationOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return OfferingListLayoutOptions; });
var SettingsKeys;
(function (SettingsKeys) {
    SettingsKeys["BOOK_FLOW_ACTION_TEXT"] = "BOOK_FLOW_ACTION_TEXT";
    SettingsKeys["NO_BOOK_FLOW_ACTION_TEXT"] = "NO_BOOK_FLOW_ACTION_TEXT";
    SettingsKeys["DISPLAY_IMAGE"] = "DISPLAY_IMAGE";
    SettingsKeys["DISPLAY_TAG_LINE"] = "DISPLAY_TAG_LINE";
    SettingsKeys["DISPLAY_DIVIDER"] = "DISPLAY_DIVIDER";
    SettingsKeys["DISPLAY_PRICE"] = "DISPLAY_PRICE";
    SettingsKeys["DISPLAY_DURATION"] = "DISPLAY_DURATION";
    SettingsKeys["DISPLAY_START_DATE"] = "DISPLAY_START_DATE";
    SettingsKeys["DISPLAY_DAYS_OFFERED"] = "DISPLAY_DAYS_OFFERED";
    SettingsKeys["DISPLAY_BUTTON"] = "DISPLAY_BUTTON";
    SettingsKeys["DISPLAY_MULTI_OFFERINGS_TITLE"] = "DISPLAY_MULTI_OFFERINGS_TITLE";
    SettingsKeys["DISPLAY_CATEGORIES"] = "DISPLAY_CATEGORIES";
    SettingsKeys["DISPLAY_SERVICE_DIVIDER"] = "DISPLAY_SERVICE_DIVIDER";
    SettingsKeys["TEXT_ALIGNMENT"] = "TEXT_ALIGNMENT";
    SettingsKeys["IMAGE_RESIZE_OPTION"] = "IMAGE_RESIZE_OPTION";
    SettingsKeys["IMAGE_POSITION_OPTION"] = "IMAGE_POSITION_OPTION";
    SettingsKeys["IMAGE_SHAPE_OPTION"] = "IMAGE_SHAPE_OPTION";
    SettingsKeys["PIN_LOCATION"] = "PIN_LOCATION";
    SettingsKeys["IMAGE_AND_TEXT_POSITION"] = "IMAGE_AND_TEXT_POSITION";
    SettingsKeys["IMAGE_AND_TEXT_RATIO"] = "IMAGE_AND_TEXT_RATIO";
    SettingsKeys["IMAGE_AND_TEXT_RATIO_IS_FLIPED"] = "IMAGE_AND_TEXT_RATIO_IS_FLIPED";
    SettingsKeys["SELECTED_RESOURCES"] = "SELECTED_RESOURCES";
    SettingsKeys["OFFERING_NAME_FONT"] = "OFFERING_NAME_FONT";
    SettingsKeys["OFFERING_NAME_COLOR"] = "OFFERING_NAME_COLOR";
    SettingsKeys["OFFERING_TAGLINE_FONT"] = "OFFERING_TAGLINE_FONT";
    SettingsKeys["OFFERING_TAGLINE_COLOR"] = "OFFERING_TAGLINE_COLOR";
    SettingsKeys["OFFERING_DETAILS_FONT"] = "OFFERING_DETAILS_FONT";
    SettingsKeys["OFFERING_DETAILS_COLOR"] = "OFFERING_DETAILS_COLOR";
    SettingsKeys["BACKGROUND_COLOR"] = "BACKGROUND_COLOR";
    SettingsKeys["BORDER_COLOR"] = "BORDER_COLOR";
    SettingsKeys["IMAGE_BACKGROUND_COLOR"] = "IMAGE_BACKGROUND_COLOR";
    SettingsKeys["DIVIDER_COLOR"] = "DIVIDER_COLOR";
    SettingsKeys["SERVICE_DIVIDER_COLOR"] = "SERVICE_DIVIDER_COLOR";
    SettingsKeys["BORDER_WIDTH"] = "BORDER_WIDTH";
    SettingsKeys["STRIP_BORDER_WIDTH"] = "STRIP_BORDER_WIDTH";
    SettingsKeys["DIVIDER_WIDTH"] = "DIVIDER_WIDTH";
    SettingsKeys["SERVICE_DIVIDER_WIDTH"] = "SERVICE_DIVIDER_WIDTH";
    SettingsKeys["BUTTON_STYLE"] = "BUTTON_STYLE";
    SettingsKeys["BUTTON_TEXT_FONT"] = "BUTTON_TEXT_FONT";
    SettingsKeys["BUTTON_TEXT_COLOR_FILL"] = "BUTTON_TEXT_COLOR_FILL";
    SettingsKeys["BUTTON_TEXT_COLOR_HOLE"] = "BUTTON_TEXT_COLOR_HOLE";
    SettingsKeys["BUTTON_BORDER_COLOR"] = "BUTTON_BORDER_COLOR";
    SettingsKeys["BUTTON_BACKGROUND_COLOR"] = "BUTTON_BACKGROUND_COLOR";
    SettingsKeys["BUTTON_CORNER_RADIUS"] = "BUTTON_CORNER_RADIUS";
    SettingsKeys["BUTTON_BORDER_WIDTH"] = "BUTTON_BORDER_WIDTH";
    SettingsKeys["MULTI_OFFERINGS_TITLE_TEXT"] = "MULTI_OFFERINGS_TITLE_TEXT";
    SettingsKeys["OFFERING_LIST_LAYOUT"] = "OFFERINGS_LIST_LAYOUT";
    SettingsKeys["CATEGORY_NAME_FONT"] = "CATEGORY_NAME_FONT";
    SettingsKeys["CATEGORY_NAME_COLOR"] = "CATEGORY_NAME_COLOR";
    SettingsKeys["CATEGORY_DIVIDER_COLOR"] = "CATEGORY_DIVIDER_COLOR";
    SettingsKeys["CATEGORY_SELECTED_UNDERLINE_COLOR"] = "CATEGORY_SELECTED_UNDERLINE_COLOR";
    SettingsKeys["CATEGORY_ALIGNMENT"] = "CATEGORY_ALIGNMENT";
    SettingsKeys["MULTI_OFFERINGS_TITLE_ALIGNMENT"] = "MULTI_OFFERINGS_TITLE_ALIGNMENT";
    SettingsKeys["MULTI_OFFERINGS_TITLE_COLOR"] = "MULTI_OFFERINGS_TITLE_COLOR";
    SettingsKeys["MULTI_OFFERINGS_TITLE_FONT"] = "MULTI_OFFERINGS_TITLE_FONT";
    SettingsKeys["FIT_CATEGORY_WIDTH"] = "FIT_CATEGORY_WIDTH";
    SettingsKeys["MULTI_OFFERINGS_BACKGROUND_COLOR"] = "MULTI_OFFERINGS_BACKGROUND_COLOR";
    SettingsKeys["SPACE_BETWEEN_OFFERINGS"] = "SPACE_BETWEEN_OFFERINGS";
    SettingsKeys["STRIP_SPACE_BETWEEN_OFFERINGS"] = "STRIP_SPACE_BETWEEN_OFFERINGS";
    SettingsKeys["LAYOUT_CARDS_PER_ROW"] = "LAYOUT_CARDS_PER_ROW";
    SettingsKeys["CARDS_SPACING"] = "CARDS_SPACING";
    SettingsKeys["STRIP_SIDE_PADDING"] = "LAYOUT_SIDE_PADDING";
    SettingsKeys["GRID_SIDE_PADDING"] = "INFO_SIDE_PADDING";
    SettingsKeys["CLASSIC_SIDE_PADDING"] = "CLASSIC_SIDE_PADDING";
    SettingsKeys["OVERLAPPING_SIDE_PADDING"] = "OVERLAPPING_SIDE_PADDING";
    SettingsKeys["STRIP_VERTICAL_PADDING"] = "LAYOUT_VERTICAL_PADDING";
    SettingsKeys["GRID_VERTICAL_PADDING"] = "INFO_VERTICAL_PADDING";
    SettingsKeys["CLASSIC_VERTICAL_PADDING"] = "CLASSIC_VERTICAL_PADDING";
    SettingsKeys["OVERLAPPING_VERTICAL_PADDING"] = "OVERLAPPING_VERTICAL_PADDING";
})(SettingsKeys || (SettingsKeys = {}));
var MobileSettingsKeys;
(function (MobileSettingsKeys) {
    MobileSettingsKeys["MOBILE_CARDS_SPACING"] = "MOBILE_CARDS_SPACING";
    MobileSettingsKeys["MOBILE_IMAGE_SHAPE_OPTION"] = "MOBILE_IMAGE_SHAPE_OPTION";
    MobileSettingsKeys["MOBILE_TEXT_ALIGNMENT"] = "MOBILE_TEXT_ALIGNMENT";
    MobileSettingsKeys["MOBILE_DISPLAY_IMAGE"] = "MOBILE_DISPLAY_IMAGE";
    MobileSettingsKeys["MOBILE_DISPLAY_TAG_LINE"] = "MOBILE_DISPLAY_TAG_LINE";
    MobileSettingsKeys["MOBILE_DISPLAY_DIVIDER"] = "MOBILE_DISPLAY_DIVIDER";
    MobileSettingsKeys["MOBILE_DISPLAY_PRICE"] = "MOBILE_DISPLAY_PRICE";
    MobileSettingsKeys["MOBILE_DISPLAY_DURATION"] = "MOBILE_DISPLAY_DURATION";
    MobileSettingsKeys["MOBILE_DISPLAY_START_DATE"] = "MOBILE_DISPLAY_START_DATE";
    MobileSettingsKeys["MOBILE_DISPLAY_DAYS_OFFERED"] = "MOBILE_DISPLAY_DAYS_OFFERED";
    MobileSettingsKeys["MOBILE_DISPLAY_BUTTON"] = "MOBILE_DISPLAY_BUTTON";
    MobileSettingsKeys["MOBILE_DIVIDER_WIDTH"] = "MOBILE_DIVIDER_WIDTH";
    MobileSettingsKeys["MOBILE_BORDER_WIDTH"] = "MOBILE_BORDER_WIDTH";
})(MobileSettingsKeys || (MobileSettingsKeys = {}));
/*
important please add all the font keys into this list fix for #SCHED-9559
*/
var AllFontsInTheApp = [
    SettingsKeys.OFFERING_NAME_FONT,
    SettingsKeys.OFFERING_TAGLINE_FONT,
    SettingsKeys.OFFERING_DETAILS_FONT,
    SettingsKeys.BUTTON_TEXT_FONT,
    SettingsKeys.CATEGORY_NAME_FONT,
    SettingsKeys.MULTI_OFFERINGS_TITLE_FONT,
];
var AlignmentOptions;
(function (AlignmentOptions) {
    AlignmentOptions["LEFT"] = "left";
    AlignmentOptions["RIGHT"] = "right";
    AlignmentOptions["CENTER"] = "center";
})(AlignmentOptions || (AlignmentOptions = {}));
var ImageResizeOptions;
(function (ImageResizeOptions) {
    ImageResizeOptions["CROP"] = "crop";
    ImageResizeOptions["FIT"] = "fit";
})(ImageResizeOptions || (ImageResizeOptions = {}));
var ImageShapeOptions;
(function (ImageShapeOptions) {
    ImageShapeOptions["SQUARE"] = "square";
    ImageShapeOptions["ROUND"] = "round";
    ImageShapeOptions["RECTANGLE"] = "rectangle";
})(ImageShapeOptions || (ImageShapeOptions = {}));
var ImagePositionOptions;
(function (ImagePositionOptions) {
    ImagePositionOptions["LEFT"] = "left";
    ImagePositionOptions["RIGHT"] = "right";
})(ImagePositionOptions || (ImagePositionOptions = {}));
var OfferingLayoutOptions;
(function (OfferingLayoutOptions) {
    OfferingLayoutOptions["SIDE_BY_SIDE"] = "SIDE_BY_SIDE";
    OfferingLayoutOptions["OVERLAPPING"] = "OVERLAPPING";
})(OfferingLayoutOptions || (OfferingLayoutOptions = {}));
var ImageAndTextRatioOptions;
(function (ImageAndTextRatioOptions) {
    ImageAndTextRatioOptions["RATIO_50_50"] = "50";
    ImageAndTextRatioOptions["RATIO_40_60"] = "40";
    ImageAndTextRatioOptions["RATIO_30_70"] = "30";
})(ImageAndTextRatioOptions || (ImageAndTextRatioOptions = {}));
var ButtonStyleOptions;
(function (ButtonStyleOptions) {
    ButtonStyleOptions["SQUARE_HOLE"] = "SQUARE_HOLE";
    ButtonStyleOptions["SQUARE_FILL"] = "SQUARE_FILL";
    ButtonStyleOptions["CIRCLE_HOLE"] = "CIRCLE_HOLE";
    ButtonStyleOptions["CIRCLE_FILL"] = "CIRCLE_FILL";
})(ButtonStyleOptions || (ButtonStyleOptions = {}));
var DockLocationOptions;
(function (DockLocationOptions) {
    DockLocationOptions["MIDDLE"] = "MIDDLE";
    DockLocationOptions["RIGHT"] = "RIGHT";
    DockLocationOptions["LEFT"] = "LEFT";
    DockLocationOptions["BOTTOM"] = "BOTTOM";
    DockLocationOptions["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
    DockLocationOptions["BOTTOM_LEFT"] = "BOTTOM_LEFT";
    DockLocationOptions["TOP_RIGHT"] = "TOP_RIGHT";
    DockLocationOptions["TOP_LEFT"] = "TOP_LEFT";
    DockLocationOptions["TOP"] = "TOP";
})(DockLocationOptions || (DockLocationOptions = {}));
var OfferingListLayoutOptions;
(function (OfferingListLayoutOptions) {
    OfferingListLayoutOptions["CLASSIC"] = "CLASSIC";
    OfferingListLayoutOptions["OVERLAPPING"] = "OVERLAPPING";
    OfferingListLayoutOptions["STRIP"] = "STRIP";
    OfferingListLayoutOptions["GRID"] = "GRID";
})(OfferingListLayoutOptions || (OfferingListLayoutOptions = {}));


/***/ }),

/***/ 108:
/*!***************************************************************!*\
  !*** ../node_modules/@wix/wix-bi-logger-client/dist/index.js ***!
  \***************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BiLoggerClientFactory = __webpack_require__(/*! ./bi-logger-factory */ 209);
var BiLogger = __webpack_require__(/*! ./bi-logger */ 110);

module.exports.BiLoggerFactory = BiLoggerClientFactory;
module.exports.BiLogger = BiLogger;

module.exports.factory = function () {
  return new BiLoggerClientFactory();
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 109:
/*!****************************************************************!*\
  !*** ../node_modules/@wix/wix-bi-logger-client/dist/assert.js ***!
  \****************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssertionError = function (_Error) {
  _inherits(AssertionError, _Error);

  function AssertionError(message) {
    _classCallCheck(this, AssertionError);

    var _this = _possibleConstructorReturn(this, (AssertionError.__proto__ || Object.getPrototypeOf(AssertionError)).call(this, message));

    _this.name = _this.constructor.name;
    return _this;
  }

  return AssertionError;
}(Error);

function assertDefined(target, message) {
  if (target === undefined) {
    throw new AssertionError(message);
  }
}

function assertObject(target, message) {
  if (target !== undefined && ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object' || Array.isArray(target) || target === null)) {
    throw new AssertionError(message);
  }
}

function assertOk(target, message) {
  if (!target) {
    throw new AssertionError(message);
  }
}

module.exports.defined = assertDefined;
module.exports.object = assertObject;
module.exports.ok = assertOk;
module.exports.AssertionError = AssertionError;
//# sourceMappingURL=assert.js.map

/***/ }),

/***/ 110:
/*!*******************************************************************!*\
  !*** ../node_modules/@wix/wix-bi-logger-client/dist/bi-logger.js ***!
  \*******************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = __webpack_require__(/*! ./assert */ 109);

var _require = __webpack_require__(/*! ./utils/collections */ 210),
    mapValues = _require.mapValues,
    filterValues = _require.filterValues;

var promise = __webpack_require__(/*! ./utils/promise */ 211);
var log = __webpack_require__(/*! ./utils/log */ 212);
var EventBuffer = __webpack_require__(/*! ./utils/event-buffer */ 213);

var BiLogger = function () {
  //TODO: validate args
  function BiLogger(options, context) {
    _classCallCheck(this, BiLogger);

    this._publishers = options.publishers;
    this._validators = options.validators || [];
    this._defaults = options.defaults;
    this._events = options.events || {};
    this._context = context || {};
    this._defaultValueTimeout = options.defaultValueTimeout || 5000;
    this._defaultContinueOnFail = options.defaultContinueOnFail || false;
    this._onPublisherFailHandler = options.onPublisherFailHandler || BiLogger._defaultPublisherFailHandler;
  }

  _createClass(BiLogger, [{
    key: 'log',
    value: function log(eventOrKey, eventOrContextOrUndefined, contextOrUndefined) {
      var _this = this;

      assert.defined(eventOrKey, 'Event object or event key must be provided.');

      var _extractEventAndConte = this._extractEventAndContext(eventOrKey, eventOrContextOrUndefined, contextOrUndefined),
          event = _extractEventAndConte.event,
          context = _extractEventAndConte.context;

      var useBatch = typeof context.useBatch !== 'undefined' ? context.useBatch : this._context.useBatch;

      if (useBatch) {
        var buffer = this._initBuffer(useBatch);

        var dynamicDefaults = filterValues(this._defaults, function (v) {
          return typeof v === 'function';
        });
        var resolvedDefaults = mapValues(dynamicDefaults, function (v) {
          return v();
        });

        return buffer.feed(Object.assign({}, event, resolvedDefaults));
      }

      return this._getDefaults().then(function (defaults) {
        var fullEvent = Object.assign({}, defaults, event);

        var validatorsResult = _this._validators.length === 0 ? true : _this._validators.some(function (validator) {
          return validator.match(fullEvent) && (validator.execute(fullEvent) || true);
        });

        if (!validatorsResult) {
          throw new Error('No validator accepted the event. Source: ' + fullEvent.src + ' Evid: ' + (fullEvent.evid || fullEvent.evtId));
        }

        return _this._send(fullEvent, context);
      });
    }
  }, {
    key: '_send',
    value: function _send(payload) {
      var _this2 = this;

      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return Promise.all(this._publishers.map(function (publisher) {
        var cloned = Object.assign({}, payload);

        return Promise.resolve().then(function () {
          return publisher(cloned, Object.assign({}, _this2._context, context));
        }).catch(function (error) {
          return _this2._onPublisherFailHandler(error, { publisherName: publisher.name });
        });
      })).then(function () {
        return undefined;
      });
    }
  }, {
    key: '_extractEventAndContext',
    value: function _extractEventAndContext(eventOrKey, eventOrContextOrUndefined, contextOrUndefined) {
      var event = void 0;
      var context = {};

      if (typeof eventOrKey !== 'string') {
        event = eventOrKey;
        context = eventOrContextOrUndefined || context;
      } else {
        event = this._events[eventOrKey];

        if (!event) {
          throw new assert.AssertionError('Event with key \'' + eventOrKey + '\' not found in event map.');
        }

        if (eventOrContextOrUndefined) {
          event = Object.assign({}, event, eventOrContextOrUndefined);
          context = contextOrUndefined || context;
        }
      }

      return { event: event, context: context };
    }
  }, {
    key: '_initBuffer',
    value: function _initBuffer(useBatch) {
      var _this3 = this;

      var debounceMs = useBatch === true ? 300 : useBatch;

      return this._buffer || (this._buffer = new EventBuffer(debounceMs).onFlush(function (batchPayload) {
        var staticDefaults = filterValues(_this3._defaults, function (v) {
          return typeof v !== 'function';
        });
        batchPayload.g = staticDefaults;

        return _this3._send(batchPayload, { useBatch: useBatch });
      }));
    }
  }, {
    key: '_handleDefaultsError',
    value: function _handleDefaultsError(err) {
      if (this._defaultContinueOnFail) {
        log.error(err);
        return null;
      }
      return Promise.reject(err);
    }
  }, {
    key: '_getDefaults',
    value: function _getDefaults() {
      var _this4 = this;

      if (!this._defaults) {
        return Promise.resolve({});
      }

      var promises = mapValues(this._defaults, function (value, key) {
        if (typeof value === 'function') {
          try {
            value = value();
          } catch (err) {
            return _this4._handleDefaultsError(err);
          }
        }
        if (value && typeof value.then !== 'function') {
          return value;
        }
        return promise.timedPromise(value, {
          message: 'Cannot get default value \'' + key + ' for BI Event\'',
          timeout: _this4._defaultValueTimeout
        }).catch(function (err) {
          return _this4._handleDefaultsError(err);
        });
      });

      return promise.allAsObject(promises);
    }
  }], [{
    key: '_defaultPublisherFailHandler',
    value: function _defaultPublisherFailHandler(error, _ref) {
      var publisherName = _ref.publisherName;

      return publisherName; // do nothing
    }
  }]);

  return BiLogger;
}();

module.exports = BiLogger;
//# sourceMappingURL=bi-logger.js.map

/***/ }),

/***/ 111:
/*!****************************************************************!*\
  !*** ../node_modules/@wix/web-bi-logger/dist/src/lib/utils.js ***!
  \****************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookieParams = getCookieParams;
exports.buildUrl = buildUrl;
exports.guid = guid;

var _browser = __webpack_require__(/*! ./browser */ 74);

var _env = __webpack_require__(/*! ./env */ 39);

var cacheKillerCounter = 0;

function addParam(url, key, value) {
  var separator = url.indexOf('?') === -1 ? '?' : '&';
  return '' + url + separator + encodeURIComponent(key) + '=' + encodeURIComponent(value);
}

function getCookieParams(params) {
  return Object.keys(params).reduce(function (res, param) {
    var _params$param = params[param],
        name = _params$param.name,
        _params$param$transfo = _params$param.transform,
        transform = _params$param$transfo === undefined ? function (x) {
      return x;
    } : _params$param$transfo;

    var value = transform((0, _browser.readCookie)(name));

    if (value) {
      res[param] = value;
    }

    return res;
  }, {});
}

function buildUrl(_ref, params) {
  var host = _ref.host,
      _ref$endpoint = _ref.endpoint,
      endpoint = _ref$endpoint === undefined ? '' : _ref$endpoint;
  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  host = host || (0, _env.getHost)();
  endpoint = context.endpoint || endpoint;

  params._ = '' + new Date().getTime() + cacheKillerCounter++;
  params.ms = Math.round((0, _browser.now)());

  var prefix = '//' + host + '/' + endpoint;
  return Object.keys(params).reduce(function (url, key) {
    return addParam(url, key, params[key]);
  }, prefix);
}

function guid() {
  /*eslint-disable */
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
  /*eslint-enable */
}

/***/ }),

/***/ 112:
/*!*************************************************!*\
  !*** ../node_modules/axios/lib/helpers/bind.js ***!
  \*************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 113:
/*!*****************************************************!*\
  !*** ../node_modules/axios/lib/helpers/buildURL.js ***!
  \*****************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 15);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 114:
/*!****************************************************!*\
  !*** ../node_modules/axios/lib/cancel/isCancel.js ***!
  \****************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 115:
/*!*********************************************!*\
  !*** ../node_modules/axios/lib/defaults.js ***!
  \*********************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(/*! ./utils */ 15);
var normalizeHeaderName = __webpack_require__(/*! ./helpers/normalizeHeaderName */ 237);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  // Only Node.JS has a process variable that is of [[Class]] process
  if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(/*! ./adapters/http */ 116);
  } else if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(/*! ./adapters/xhr */ 116);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../process/browser.js */ 68)))

/***/ }),

/***/ 116:
/*!*************************************************!*\
  !*** ../node_modules/axios/lib/adapters/xhr.js ***!
  \*************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 15);
var settle = __webpack_require__(/*! ./../core/settle */ 238);
var buildURL = __webpack_require__(/*! ./../helpers/buildURL */ 113);
var parseHeaders = __webpack_require__(/*! ./../helpers/parseHeaders */ 240);
var isURLSameOrigin = __webpack_require__(/*! ./../helpers/isURLSameOrigin */ 241);
var createError = __webpack_require__(/*! ../core/createError */ 117);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(/*! ./../helpers/cookies */ 242);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 117:
/*!*****************************************************!*\
  !*** ../node_modules/axios/lib/core/createError.js ***!
  \*****************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(/*! ./enhanceError */ 239);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 118:
/*!*****************************************************!*\
  !*** ../node_modules/axios/lib/core/mergeConfig.js ***!
  \*****************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ../utils */ 15);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  utils.forEach(['url', 'method', 'params', 'data'], function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(['headers', 'auth', 'proxy'], function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach([
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'maxContentLength',
    'validateStatus', 'maxRedirects', 'httpAgent', 'httpsAgent', 'cancelToken',
    'socketPath'
  ], function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),

/***/ 119:
/*!**************************************************!*\
  !*** ../node_modules/axios/lib/cancel/Cancel.js ***!
  \**************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 126:
/*!*********************************************!*\
  !*** ../node_modules/query-string/index.js ***!
  \*********************************************/
/*! no static exports found */
/*! exports used: parse */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(/*! strict-uri-encode */ 224);
var objectAssign = __webpack_require__(/*! object-assign */ 172);
var decodeComponent = __webpack_require__(/*! decode-uri-component */ 225);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),

/***/ 127:
/*!******************************************************************************!*\
  !*** ../node_modules/@wix/js-sdk-wrapper/dist/src/create-wix-sdk-wrapper.js ***!
  \******************************************************************************/
/*! no static exports found */
/*! exports used: wixSdk */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(/*! tslib */ 2);
var utils_1 = __webpack_require__(/*! ./utils */ 228);
function wixSdk(Wix) {
    var errorLogger = function (ex) {
        if (global.console && typeof global.console.error === 'function') {
            console.error(ex); //tslint:disable-line:no-console
        }
    };
    if (!Wix) {
        errorLogger(new Error('Wix Sdk is missing'));
        return null;
    }
    var safeCall = utils_1.createSafeCall(function (ex) {
        errorLogger(ex);
    });
    var WixSdkWrapper = {
        valid: false,
        config: {
            setErrorLogger: function (handler) {
                errorLogger = handler;
            },
        },
        Activities: {
            Type: Wix.Activities.Type,
            Error: Wix.Activities.Error,
            postActivity: function (activity) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Activities.postActivity(activity, resolve, reject);
                }));
            },
            getActivities: function (query) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Activities.getActivities(resolve, reject, query);
                }));
            },
            getActivityById: function (id) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Activities.getActivityById(id, resolve, reject);
                }));
            },
            getUserSessionToken: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Activities.getUserSessionToken(resolve);
                }));
            },
        },
        Analytics: {
            PixelType: Wix.Analytics.PixelType,
            PixelEventType: Wix.Analytics.PixelEventType,
            registerCampaignPixel: Wix.Analytics.registerCampaignPixel,
            reportCampaignEvent: Wix.Analytics.reportCampaignEvent,
        },
        Billing: {
            Cycle: Wix.Billing.Cycle,
            openBillingPageForProduct: function (vendorProductId, cycle) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Billing.openBillingPageForProduct(vendorProductId, cycle, reject);
                }));
            },
            getBillingPageForProduct: function (vendorProductId, cycle) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Billing.getBillingPageForProduct(vendorProductId, cycle, resolve, reject);
                }));
            },
            getBillingPackages: function (vendorProductIds) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Billing.getBillingPackages(vendorProductIds, resolve, reject);
                }));
            },
            getProducts: function (options) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Billing.getProducts(options, resolve, reject);
                }));
            },
        },
        Contacts: {
            getContacts: function (options) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Contacts.getContacts(options, resolve, reject);
                }));
            },
            getContactById: function (id) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Contacts.getContactById(id, resolve, reject);
                }));
            },
            reconcileContact: function (contactInfo) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Contacts.reconcileContact(contactInfo, resolve, reject);
                }));
            },
        },
        Dashboard: {
            PremiumIntent: Wix.Dashboard.PremiumIntent,
            setHeight: Wix.Dashboard.setHeight,
            openMediaDialog: function (mediaType, multipleSelection, onCancel) {
                return new Promise(function (resolve) {
                    Wix.Dashboard.openMediaDialog(mediaType, multipleSelection, resolve, onCancel);
                });
            },
            openBillingPage: Wix.Dashboard.openBillingPage,
            openModal: function (url, width, height) {
                return new Promise(function (resolve) {
                    Wix.Dashboard.openModal(url, width, height, resolve);
                });
            },
            closeWindow: Wix.Dashboard.closeWindow,
            scrollTo: Wix.Dashboard.scrollTo,
            getEditorUrl: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Dashboard.getEditorUrl(resolve);
                }));
            },
            pushState: Wix.Dashboard.pushState,
            resizeWindow: Wix.Dashboard.resizeWindow,
            revalidateSession: function () {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Dashboard.revalidateSession(resolve, reject);
                }));
            },
            getProducts: function () {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Dashboard.getProducts(resolve, reject);
                }));
            },
            getSiteViewUrl: function (options) {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Dashboard.getSiteViewUrl(options, resolve);
                }));
            },
            appEngaged: Wix.Dashboard.appEngaged,
        },
        Error: Wix.Error,
        Events: Wix.Events,
        Features: {
            Types: Wix.Features.Types,
            isSupported: function (featureName) {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Features.isSupported(featureName, resolve);
                }));
            },
        },
        Media: {
            AudioType: Wix.Media.AudioType,
            getImageUrl: Wix.Media.getImageUrl,
            getResizedImageUrl: Wix.Media.getResizedImageUrl,
            getAudioUrl: Wix.Media.getAudioUrl,
            getDocumentUrl: Wix.Media.getDocumentUrl,
            getSwfUrl: Wix.Media.getSwfUrl,
            getPreviewSecureMusicUrl: Wix.Media.getPreviewSecureMusicUrl,
        },
        PubSub: {
            unsubscribe: Wix.PubSub.unsubscribe,
            subscribe: Wix.PubSub.subscribe,
            publish: Wix.PubSub.publish,
        },
        Preview: {
            openSettingsDialog: Wix.Preview.openSettingsDialog,
        },
        Settings: {
            MediaType: Wix.Settings.MediaType,
            PremiumIntent: Wix.Settings.PremiumIntent,
            getColorByreference: Wix.Settings.getColorByreference,
            setBooleanParam: Wix.Settings.setBooleanParam,
            setColorParam: Wix.Settings.setColorParam,
            setNumberParam: Wix.Settings.setNumberParam,
            getSiteColors: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getSiteColors(resolve);
                }));
            },
            getStyleColorByKey: Wix.Settings.getStyleColorByKey,
            getWindowPlacement: function (compId) {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getWindowPlacement(compId, resolve);
                }));
            },
            getDashboardAppUrl: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getDashboardAppUrl(resolve);
                }));
            },
            getSiteInfo: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getSiteInfo(resolve);
                }));
            },
            getSitePages: function (options) {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getSitePages(options, resolve);
                }));
            },
            getSiteMap: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getSiteMap(resolve);
                }));
            },
            getStyleParams: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getStyleParams(resolve);
                }));
            },
            openBillingPage: Wix.Settings.openBillingPage,
            appEngaged: Wix.Settings.appEngaged,
            openMediaDialog: function (mediaType, multipleSelection, onCancel) {
                return new Promise(function (resolve) {
                    Wix.Settings.openMediaDialog(mediaType, multipleSelection, resolve, onCancel);
                });
            },
            openSiteMembersSettingsDialog: Wix.Settings.openSiteMembersSettingsDialog,
            refreshApp: Wix.Settings.refreshApp,
            refreshAppByCompIds: Wix.Settings.refreshAppByCompIds,
            setWindowPlacement: Wix.Settings.setWindowPlacement,
            triggerSettingsUpdatedEvent: Wix.Settings.triggerSettingsUpdatedEvent,
            openModal: function (url, width, height, title, bareUI) {
                return new Promise(function (resolve) {
                    Wix.Settings.openModal(url, width, height, title, resolve, bareUI);
                });
            },
            closeWindow: Wix.Settings.closeWindow,
            addComponent: function (options) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Settings.addComponent(options, resolve, reject);
                }));
            },
            resizeComponent: function (options) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Settings.resizeComponent(options, resolve, reject);
                }));
            },
            setExternalId: function (guid) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Settings.setExternalId(guid, resolve, reject);
                }));
            },
            revalidateSession: function () {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Settings.revalidateSession(resolve, reject);
                }));
            },
            getCurrentPageAnchors: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getCurrentPageAnchors(resolve);
                }));
            },
            setFullWidth: function (shouldBeFullWidth, options) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Settings.setFullWidth(shouldBeFullWidth, options, resolve, reject);
                }));
            },
            isFullWidth: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.isFullWidth(resolve);
                }));
            },
            openReviewInfo: Wix.Settings.openReviewInfo,
            getStateUrl: function (sectionId, state) {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.getStateUrl(sectionId, state, resolve);
                }));
            },
            isComponentInstalled: function (componentId) {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Settings.isComponentInstalled(componentId, resolve);
                }));
            },
            openLinkPanel: function (options, onCacnel) {
                return new Promise(function (resolve) {
                    Wix.Settings.openLinkPanel(options, resolve, onCacnel);
                });
            },
        },
        Styles: {
            getStyleParams: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Styles.getStyleParams(resolve);
                }));
            },
            setStyleParams: function (styleObjArr) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Styles.setStyleParams(styleObjArr, resolve, reject);
                }));
            },
            setFontParam: function (key, value) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Styles.setFontParam(key, value, resolve, reject);
                }));
            },
            getEditorFonts: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Styles.getEditorFonts(resolve);
                }));
            },
            getSiteTextPresets: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Styles.getSiteTextPresets(resolve);
                }));
            },
            getFontsSpriteUrl: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Styles.getFontsSpriteUrl(resolve);
                }));
            },
            getStyleFontByKey: Wix.Styles.getStyleFontByKey,
            getStyleFontByReference: Wix.Styles.getStyleFontByReference,
            getSiteColors: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Styles.getSiteColors(resolve);
                }));
            },
            getStyleColorByKey: Wix.Styles.getStyleColorByKey,
            getColorByreference: Wix.Styles.getColorByreference,
            setColorParam: function (key, value) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Styles.setColorParam(key, value, resolve, reject);
                }));
            },
            setNumberParam: function (key, value) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Styles.setNumberParam(key, value, resolve, reject);
                }));
            },
            setBooleanParam: function (key, value) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Styles.setBooleanParam(key, value, resolve, reject);
                }));
            },
            openColorPicker: function (params) {
                return new Promise(function (resolve) {
                    Wix.Styles.openColorPicker(params, resolve);
                });
            },
            openFontPicker: function (params) {
                return new Promise(function (resolve) {
                    Wix.Styles.openFontPicker(params, resolve);
                });
            },
            setUILIBParamValue: Wix.Styles.setUILIBParamValue,
            getStyleId: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Styles.getStyleId(resolve);
                }));
            },
            getStyleParamsByStyleId: function (styleId) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.Styles.getStyleParamsByStyleId(styleId, resolve, reject);
                }));
            },
        },
        Theme: Wix.Theme,
        Utils: {
            getViewMode: safeCall(Wix.Utils.getViewMode),
            toWixDate: safeCall(Wix.Utils.toWixDate),
            getCompId: safeCall(Wix.Utils.getCompId),
            getOrigCompId: safeCall(Wix.Utils.getOrigCompId),
            getWidth: safeCall(Wix.Utils.getWidth),
            getLocale: safeCall(Wix.Utils.getLocale),
            getCacheKiller: safeCall(Wix.Utils.getCacheKiller),
            getTarget: safeCall(Wix.Utils.getTarget),
            getSectionUrl: function (sectionIdentifier) {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.Utils.getSectionUrl(sectionIdentifier, resolve);
                }));
            },
            getInstanceId: safeCall(Wix.Utils.getInstanceId),
            getSignDate: safeCall(Wix.Utils.getSignDate),
            getUid: safeCall(Wix.Utils.getUid),
            getPermissions: safeCall(Wix.Utils.getPermissions),
            getIpAndPort: safeCall(Wix.Utils.getIpAndPort),
            getDemoMode: safeCall(Wix.Utils.getDemoMode),
            getDeviceType: safeCall(Wix.Utils.getDeviceType),
            getInstanceValue: safeCall(Wix.Utils.getInstanceValue),
            navigateToSection: safeCall(Wix.Utils.navigateToSection),
            getSiteOwnerId: safeCall(Wix.Utils.getSiteOwnerId),
            Media: {
                AudioType: Wix.Utils.Media.AudioType,
                getImageUrl: Wix.Utils.Media.getImageUrl,
                getResizedImageUrl: Wix.Utils.Media.getResizedImageUrl,
                getAudioUrl: Wix.Utils.Media.getAudioUrl,
                getDocumentUrl: Wix.Utils.Media.getDocumentUrl,
                getSwfUrl: Wix.Utils.Media.getSwfUrl,
                getPreviewSecureMusicUrl: Wix.Utils.Media.getPreviewSecureMusicUrl,
            },
        },
        Data: {
            SCOPE: Wix.Data.SCOPE,
            Public: {
                set: function (key, value, options) {
                    return utils_1.addTimeout(new Promise(function (resolve, reject) {
                        Wix.Data.Public.set(key, value, options, resolve, reject);
                    }));
                },
                get: function (key, value, options) {
                    return utils_1.addTimeout(new Promise(function (resolve, reject) {
                        Wix.Data.Public.get(key, options, resolve, reject);
                    }));
                },
                remove: function (key, value, options) {
                    return utils_1.addTimeout(new Promise(function (resolve, reject) {
                        Wix.Data.Public.remove(key, options, resolve, reject);
                    }));
                },
            },
        },
        Performance: {
            applicationLoaded: Wix.Performance.applicationLoaded,
            applicationLoadingStep: Wix.Performance.applicationLoadingStep,
        },
        WindowOrigin: Wix.WindowOrigin,
        WindowPlacement: Wix.WindowPlacement,
        openModal: function (url, width, height, theme) {
            return new Promise(function (resolve) {
                Wix.openModal(url, width, height, resolve, theme);
            });
        },
        openPopup: function (url, width, height, position, theme) {
            return new Promise(function (resolve) {
                Wix.openPopup(url, width, height, position, resolve, theme);
            });
        },
        setHeight: Wix.setHeight,
        closeWindow: Wix.closeWindow,
        scrollTo: Wix.scrollTo,
        scrollBy: Wix.scrollBy,
        getSiteInfo: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getSiteInfo(resolve);
            }));
        },
        getSitePages: function (options) {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getSitePages(options, resolve);
            }));
        },
        getSiteMap: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getSiteMap(resolve);
            }));
        },
        getBoundingRectAndOffsets: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getBoundingRectAndOffsets(resolve);
            }));
        },
        removeEventListener: Wix.removeEventListener,
        addEventListener: Wix.addEventListener,
        resizeWindow: Wix.resizeWindow,
        requestLogin: function (options, onCancel) {
            return new Promise(function (resolve) {
                Wix.requestLogin(options, resolve, onCancel);
            });
        },
        logOutCurrentMember: function (options) {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.logOutCurrentMember(options, reject);
            }));
        },
        currentMember: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.currentMember(resolve);
            }));
        },
        navigateTo: function (linkData) {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.navigateTo(linkData, reject);
            }));
        },
        navigateToPage: function (pageId, options) {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.navigateToPage(pageId, options, reject);
            }));
        },
        getCurrentPageId: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getCurrentPageId(resolve);
            }));
        },
        pushState: Wix.pushState,
        reportHeightChange: Wix.reportHeightChange,
        getStyleParams: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getStyleParams(resolve);
            }));
        },
        getExternalId: function () {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.getExternalId(resolve, reject);
            }));
        },
        navigateToComponent: function (compId, options) {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.navigateToComponent(compId, options, reject);
            }));
        },
        resizeComponent: function (options) {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.resizeComponent(options, resolve, reject);
            }));
        },
        revalidateSession: function () {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.revalidateSession(resolve, reject);
            }));
        },
        getCurrentPageAnchors: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getCurrentPageAnchors(resolve);
            }));
        },
        navigateToAnchor: function (anchorId) {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.navigateToAnchor(anchorId, reject);
            }));
        },
        getComponentInfo: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getComponentInfo(resolve);
            }));
        },
        replaceSectionState: Wix.replaceSectionState,
        setPageMetadata: Wix.setPageMetadata,
        getStateUrl: function (sectionId, state) {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getStateUrl(sectionId, state, resolve);
            }));
        },
        getAdsOnPage: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getAdsOnPage(resolve);
            }));
        },
    };
    if (!Wix.SuperApps) {
        return WixSdkWrapper;
    }
    return tslib_1.__assign({}, WixSdkWrapper, { SuperApps: {
            Settings: {
                MediaType: Wix.SuperApps.Settings.MediaType,
                openBillingPage: Wix.SuperApps.Settings.openBillingPage,
                getInstalledInstance: function (appDefinitionId) {
                    return utils_1.addTimeout(new Promise(function (resolve, reject) {
                        Wix.SuperApps.Settings.getInstalledInstance(appDefinitionId, resolve, reject);
                    }));
                },
                openMediaDialog: function (mediaType, multipleSelection, onCancel) {
                    return new Promise(function (resolve) {
                        Wix.SuperApps.Settings.openMediaDialog(mediaType, multipleSelection, resolve, onCancel);
                    });
                },
                openModal: function (url, width, height, title, bareUI, options) {
                    return new Promise(function (resolve) {
                        Wix.SuperApps.Settings.openModal(url, width, height, title, resolve, bareUI, options);
                    });
                },
                setHelpArticle: Wix.SuperApps.Settings.setHelpArticle,
            },
            Dashboard: {
                showHeader: Wix.SuperApps.Dashboard.showHeader,
                hideHeader: Wix.SuperApps.Dashboard.hideHeader,
                setHelpArticle: Wix.SuperApps.Dashboard.setHelpArticle,
                getProducts: function (options) {
                    return utils_1.addTimeout(new Promise(function (resolve, reject) {
                        Wix.SuperApps.Dashboard.getProducts(options, resolve, reject);
                    }));
                },
                openMediaDialog: function (mediaType, multipleSelection, onCancel) {
                    return new Promise(function (resolve) {
                        Wix.SuperApps.Dashboard.openMediaDialog(mediaType, multipleSelection, resolve, onCancel);
                    });
                },
            },
            getInstalledInstance: function (appDefinitionId) {
                return utils_1.addTimeout(new Promise(function (resolve, reject) {
                    Wix.SuperApps.getInstalledInstance(appDefinitionId, resolve, reject);
                }));
            },
            OnBoarding: {
                Settings: {
                    getStyleByCompId: function (compId) {
                        return utils_1.addTimeout(new Promise(function (resolve) {
                            Wix.SuperApps.OnBoarding.Settings.getStyleByCompId(compId, resolve);
                        }));
                    },
                },
            },
            Billing: {
                getProducts: function (options) {
                    return utils_1.addTimeout(new Promise(function (resolve, reject) {
                        Wix.SuperApps.Billing.getProducts(options, resolve, reject);
                    }));
                },
            },
            getCtToken: function () {
                return utils_1.addTimeout(new Promise(function (resolve) {
                    Wix.SuperApps.getCtToken(resolve);
                }));
            },
        }, getInstalledInstance: function (appDefinitionId) {
            return utils_1.addTimeout(new Promise(function (resolve, reject) {
                Wix.getInstalledInstance(appDefinitionId, resolve, reject);
            }));
        }, OnBoarding: {
            Settings: {
                getStyleByCompId: function (compId) {
                    return utils_1.addTimeout(new Promise(function (resolve) {
                        Wix.OnBoarding.Settings.getStyleByCompId(compId, resolve);
                    }));
                },
            },
        }, getCtToken: function () {
            return utils_1.addTimeout(new Promise(function (resolve) {
                Wix.getCtToken(resolve);
            }));
        } });
}
exports.wixSdk = wixSdk;
//# sourceMappingURL=create-wix-sdk-wrapper.js.map
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/global.js */ 21)))

/***/ }),

/***/ 128:
/*!******************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-adapters-reporting/dist/src/sentry/sentry-adapter.js ***!
  \******************************************************************************************/
/*! no static exports found */
/*! exports used: getRavenSessionIdForApp, initRaven */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var sentry_const_1 = __webpack_require__(/*! ./sentry.const */ 354);
exports.isRunningInIframe = function () {
    return !(typeof WorkerGlobalScope !== 'undefined' &&
        self instanceof WorkerGlobalScope);
};
exports.getRavenSessionIdForApp = function (initParams) {
    return initParams.instanceId;
};
exports.initRaven = function (platformServices, initParams) {
    if (!exports.isRunningInIframe()) {
        var viewerScriptRaven = platformServices.monitoring.createMonitor(sentry_const_1.SENTRY_BOOKINGS_VIEWER_SCRIPT_DNS, function (data) {
            data.environment = sentry_const_1.SENTRY_BOOKINGS_RUNNING_ENVIRONMENT;
            return data;
        });
        viewerScriptRaven.setUserContext({
            id: exports.getRavenSessionIdForApp(initParams),
        });
    }
    return null;
};
//# sourceMappingURL=sentry-adapter.js.map

/***/ }),

/***/ 130:
/*!*************************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/node_modules/@wix/web-bi-logger/dist/src/lib/errors.js ***!
  \*************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AssertionError = /** @class */ (function (_super) {
    __extends(AssertionError, _super);
    function AssertionError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = _this.constructor.name;
        return _this;
    }
    return AssertionError;
}(Error));
exports.AssertionError = AssertionError;
var APINotSupportedError = /** @class */ (function (_super) {
    __extends(APINotSupportedError, _super);
    function APINotSupportedError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = _this.constructor.name;
        return _this;
    }
    return APINotSupportedError;
}(Error));
exports.APINotSupportedError = APINotSupportedError;
//# sourceMappingURL=errors.js.map

/***/ }),

/***/ 131:
/*!**************************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/node_modules/@wix/web-bi-logger/dist/src/lib/browser.js ***!
  \**************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function now() {
    return typeof performance !== 'undefined' && performance && performance.now
        ? performance.now()
        : -1;
}
exports.now = now;
function getDesktopSize(window) {
    var width = (window.screen && window.screen.width) || 0;
    var height = (window.screen && window.screen.height) || 0;
    return width + "x" + height;
}
exports.getDesktopSize = getDesktopSize;
function getWindowSize(window) {
    var width = 0;
    var height = 0;
    if (window.innerWidth) {
        width = window.innerWidth;
        height = window.innerHeight;
    }
    else if (window.document) {
        if (window.document.documentElement &&
            window.document.documentElement.clientWidth) {
            width = window.document.documentElement.clientWidth;
            height = window.document.documentElement.clientHeight;
        }
        else if (window.document.body && window.document.body.clientWidth) {
            width = window.document.body.clientWidth;
            height = window.document.body.clientHeight;
        }
    }
    return width + "x" + height;
}
exports.getWindowSize = getWindowSize;
function sendBeacon(url, data) {
    if (typeof navigator === 'undefined' || !navigator || !navigator.sendBeacon) {
        return false;
    }
    return navigator.sendBeacon(url, data);
}
exports.sendBeacon = sendBeacon;
function readCookie(cookieName) {
    if (typeof document === 'undefined') {
        return null;
    }
    var cookies = document.cookie.split(';');
    for (var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++) {
        var cookie = cookies_1[_i];
        var pair = cookie.split('=');
        var name_1 = pair[0];
        var value = pair[1];
        while (name_1[0] === ' ') {
            name_1 = name_1.substr(1);
        }
        if (name_1 === cookieName) {
            return value;
        }
    }
    return '';
}
exports.readCookie = readCookie;
//# sourceMappingURL=browser.js.map

/***/ }),

/***/ 132:
/*!**********************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/node_modules/@wix/web-bi-logger/dist/src/lib/env.js ***!
  \**********************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(/*! ../constants */ 95);
var host = constants_1.Host;
function setHost(_host) {
    host = _host;
}
exports.setHost = setHost;
function getHost() {
    return host;
}
exports.getHost = getHost;
function isWebWorker() {
    /* global WorkerGlobalScope */
    //At the moment, this is the most reliable way of detecting if current code is run in a worker
    //Taken from here: https://stackoverflow.com/a/18002694
    return (typeof WorkerGlobalScope !== 'undefined' &&
        self instanceof WorkerGlobalScope);
}
exports.isWebWorker = isWebWorker;
/**
 * Provides a window object to the callback iff current window is the topmost one
 * Otherwise returns null
 */
function requestWindow(cb) {
    if (typeof window !== 'undefined' && window) {
        try {
            return window.top === window.self ? (cb ? cb(window) : window) : null;
        }
        catch (e) {
            return null;
        }
    }
    return null;
}
exports.requestWindow = requestWindow;
//# sourceMappingURL=env.js.map

/***/ }),

/***/ 133:
/*!***************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/app-data/app-data.js ***!
  \***************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.initializeFedops = initializeFedops;
exports.initializeApp = initializeApp;
exports.initializeGlobal = initializeGlobal;
exports.getStartLoadTime = getStartLoadTime;
exports.setStartLoadTime = setStartLoadTime;

var _env = __webpack_require__(/*! ../env */ 48);

function getAppData(appName) {
  return (((0, _env.env)().fedops || {}).apps || {})[appName];
}

function initializeFedops() {
  (0, _env.env)().fedops = (0, _env.env)().fedops || {};
  (0, _env.env)().fedops.apps = (0, _env.env)().fedops.apps || {};
}

function initializeApp(appName) {
  (0, _env.env)().fedops.apps[appName] = (0, _env.env)().fedops.apps[appName] || {};
}

function initializeGlobal(appName) {
  initializeFedops();
  initializeApp(appName);
}

function getStartLoadTime(appName) {
  return (getAppData(appName) || {}).startLoadTime || 0;
}

function setStartLoadTime(appName, startLoadTime) {
  return getAppData(appName).startLoadTime = startLoadTime;
}

/***/ }),

/***/ 134:
/*!*************************************************************!*\
  !*** ../node_modules/message-channel/dist/src/constants.js ***!
  \*************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var connectionRequestMsg = exports.connectionRequestMsg = 'req_con';
var connectionSuccessMsg = exports.connectionSuccessMsg = 'connection_success';
var messageDelimiter = exports.messageDelimiter = '|';
var deafultConnectionMaxTimeout = exports.deafultConnectionMaxTimeout = 200;
var deafultMessageMaxTimeout = exports.deafultMessageMaxTimeout = 5000;

/***/ }),

/***/ 135:
/*!*************************************************************************!*\
  !*** ../node_modules/data-capsule/dist/src/strategies/local-storage.js ***!
  \*************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global localStorage */


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStorage = __webpack_require__(/*! ../base-storage */ 40);
var localStorageCleaner = __webpack_require__(/*! ../utils/local-storage-cleaner */ 383);

var _require = __webpack_require__(/*! ../utils/constants */ 51),
    STORAGE_PREFIX = _require.STORAGE_PREFIX,
    PREFIX_SEPARATOR = _require.PREFIX_SEPARATOR,
    KEY_SEPARATOR = _require.KEY_SEPARATOR,
    NOT_FOUND = _require.NOT_FOUND;

var _require2 = __webpack_require__(/*! ../utils/record-utils */ 230),
    getCacheRecords = _require2.getCacheRecords,
    deserializeData = _require2.deserializeData,
    isExpired = _require2.isExpired;

function getCacheKey(key, options) {
  return getCachePrefix(options) + key;
}

function stringify(obj) {
  return typeof obj === 'string' ? obj : JSON.stringify(obj);
}

function getCachePrefix(options) {
  return [STORAGE_PREFIX, options.namespace, stringify(options.scope)].filter(function (x) {
    return x;
  }).join(PREFIX_SEPARATOR) + KEY_SEPARATOR;
}

function serializeData(value, options) {
  return JSON.stringify({
    lastUsed: Date.now(),
    createdAt: options.createdAt || Date.now(),
    expiration: options.expiration,
    value: value
  });
}

function updateAccessTime(fullKey, data) {
  var expiration = data.expiration,
      createdAt = data.createdAt;

  localStorage.setItem(fullKey, serializeData(data.value, { expiration: expiration, createdAt: createdAt }));
}

var LocalStorageStrategy = function (_BaseStorage) {
  _inherits(LocalStorageStrategy, _BaseStorage);

  function LocalStorageStrategy() {
    _classCallCheck(this, LocalStorageStrategy);

    return _possibleConstructorReturn(this, (LocalStorageStrategy.__proto__ || Object.getPrototypeOf(LocalStorageStrategy)).apply(this, arguments));
  }

  _createClass(LocalStorageStrategy, [{
    key: 'setItem',
    value: function setItem(key, value, options) {
      key = getCacheKey(key, options);
      value = serializeData(value, options);
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        localStorageCleaner(key.length + value.length);
        localStorage.setItem(key, value);
      }
      return Promise.resolve();
    }
  }, {
    key: 'getItem',
    value: function getItem(key, options) {
      var fullKey = getCacheKey(key, options);
      var data = localStorage.getItem(fullKey);
      data = data && deserializeData(data);
      if (data && !isExpired(data)) {
        updateAccessTime(fullKey, data);
        return Promise.resolve(data.value);
      } else {
        return Promise.reject(NOT_FOUND);
      }
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key, options) {
      key = getCacheKey(key, options);
      localStorage.removeItem(key);
      return Promise.resolve();
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems(options) {
      var prefix = getCachePrefix(options);
      var items = {};
      getCacheRecords(prefix).forEach(function (record) {
        if (!isExpired(record)) {
          items[record.key] = record.value;
        }
      });
      return Promise.resolve(items);
    }
  }]);

  return LocalStorageStrategy;
}(BaseStorage);

module.exports = LocalStorageStrategy;

/***/ }),

/***/ 1350:
/*!***************************************************!*\
  !*** ./WidgetApp/viewerScriptController.entry.js ***!
  \***************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var controller = __webpack_require__(/*! ./platform/offering-list-widget-controller */ 80); // The viewer worker only supports js files in the "require" syntax


module.exports = {
  createOfferingListWidgetController: controller.createOfferingListWidgetController,
  createMainPageController: controller.createMainPageController
};

/***/ }),

/***/ 148:
/*!******************************************************!*\
  !*** ../node_modules/data-capsule/dist/src/index.js ***!
  \******************************************************/
/*! no static exports found */
/*! exports used: DataCapsule, FrameStorageStrategy */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var FrameStorageListener = __webpack_require__(/*! ./utils/frame-storage-listener */ 379);
var LocalStorageStrategy = __webpack_require__(/*! ./strategies/local-storage */ 135);
var FrameStorageStrategy = __webpack_require__(/*! ./strategies/frame-storage */ 384);
var WixStorageStrategy = __webpack_require__(/*! ./strategies/wix-storage */ 388);
var CachedStorageStrategy = __webpack_require__(/*! ./strategies/cached-storage */ 389);
var InMemoryStorageStrategy = __webpack_require__(/*! ./strategies/in-memory-storage */ 390);

var _require = __webpack_require__(/*! ./utils/constants */ 51),
    NOT_FOUND = _require.NOT_FOUND;

var BaseStorage = __webpack_require__(/*! ./base-storage */ 40);
var DataCapsule = __webpack_require__(/*! ./data-capsule */ 391);

function LocalStorageCapsule(options) {
  return new DataCapsule(Object.assign({}, options, { strategy: new LocalStorageStrategy() }));
}

function InMemoryStorageCapsule(options) {
  return new DataCapsule(Object.assign({}, options, { strategy: new InMemoryStorageStrategy() }));
}

function LocalStorageCachedCapsule(options) {
  return new DataCapsule(Object.assign({}, options, {
    strategy: new CachedStorageStrategy({ remoteStrategy: options.remoteStrategy })
  }));
}

module.exports = {
  NOT_FOUND: NOT_FOUND,
  BaseStorage: BaseStorage,
  DataCapsule: DataCapsule,
  FrameStorageListener: FrameStorageListener,
  FrameStorageStrategy: FrameStorageStrategy,
  LocalStorageStrategy: LocalStorageStrategy,
  LocalStorageCapsule: LocalStorageCapsule,
  WixStorageStrategy: WixStorageStrategy,
  CachedStorageStrategy: CachedStorageStrategy,
  LocalStorageCachedCapsule: LocalStorageCachedCapsule,
  InMemoryStorageStrategy: InMemoryStorageStrategy,
  InMemoryStorageCapsule: InMemoryStorageCapsule
};

/***/ }),

/***/ 15:
/*!******************************************!*\
  !*** ../node_modules/axios/lib/utils.js ***!
  \******************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(/*! ./helpers/bind */ 112);
var isBuffer = __webpack_require__(/*! is-buffer */ 232);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ 157:
/*!************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/bi-logger-adapter.js ***!
  \************************************************************************************************/
/*! no static exports found */
/*! exports used: BiLoggerAdapterBuilder */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var WebLogger_1 = __webpack_require__(/*! ./web-logger/WebLogger */ 326);
var platform_logger_1 = __webpack_require__(/*! ./platform-logger/platform-logger */ 328);
var SSRLogger_1 = __webpack_require__(/*! ./ssr-logger/SSRLogger */ 329);
var bi_logger_const_1 = __webpack_require__(/*! ./bi-logger.const */ 160);
var BiLoggerAdapterBuilder = /** @class */ (function () {
    function BiLoggerAdapterBuilder() {
    }
    BiLoggerAdapterBuilder.prototype.withLogger = function (_a) {
        var _b = _a.biLoggerDefaultConfigurations, biLoggerDefaultConfigurations = _b === void 0 ? null : _b, _c = _a.biLoggerEndPoint, biLoggerEndPoint = _c === void 0 ? bi_logger_const_1.BI_BOOKINGS_USER_OF_USER_END_POINT : _c, wixSdkAdapter = _a.wixSdkAdapter, _d = _a.experiments, experiments = _d === void 0 ? {} : _d;
        if (experiments['specs.BookingsNewFedopsIntegretionSpecs'] === 'true' &&
            !wixSdkAdapter.isRunningInIframe()) {
            var platformAPIs = wixSdkAdapter.getPlatformAPIs();
            this.logger = new platform_logger_1.PlatformLogger({
                platformAPIs: platformAPIs,
                biLoggerDefaultConfigurations: biLoggerDefaultConfigurations,
                biLoggerEndPoint: biLoggerEndPoint,
            });
        }
        else {
            this.logger = new WebLogger_1.WebLogger({
                biLoggerEndPoint: biLoggerEndPoint,
                biLoggerDefaults: biLoggerDefaultConfigurations,
            });
        }
        return this;
    };
    BiLoggerAdapterBuilder.prototype.withWebLogger = function (_a) {
        var _b = _a.biLoggerDefaults, biLoggerDefaults = _b === void 0 ? null : _b, _c = _a.Wix, Wix = _c === void 0 ? window.Wix : _c, _d = _a.biLoggerEndPoint, biLoggerEndPoint = _d === void 0 ? bi_logger_const_1.BI_BOOKINGS_USER_OF_USER_END_POINT : _d;
        this.logger = new WebLogger_1.WebLogger({
            biLoggerDefaults: biLoggerDefaults,
            biLoggerEndPoint: biLoggerEndPoint,
            Wix: Wix,
        });
        return this;
    };
    BiLoggerAdapterBuilder.prototype.setSSRMode = function () {
        this.logger = new SSRLogger_1.SSRLogger();
        return this;
    };
    BiLoggerAdapterBuilder.prototype.build = function () {
        return this.logger;
    };
    return BiLoggerAdapterBuilder;
}());
exports.BiLoggerAdapterBuilder = BiLoggerAdapterBuilder;
var BiLoggerAdapter = /** @class */ (function () {
    function BiLoggerAdapter(_a) {
        var biLoggerDefaultConfigurations = _a.biLoggerDefaultConfigurations, biLoggerEndPoint = _a.biLoggerEndPoint, wixSdkAdapter = _a.wixSdkAdapter, _b = _a.experiments, experiments = _b === void 0 ? {} : _b;
        var isSSR = wixSdkAdapter.isSSR();
        if (isSSR) {
            this.logger = new BiLoggerAdapterBuilder().setSSRMode().build();
        }
        else {
            this.logger = new BiLoggerAdapterBuilder()
                .withLogger({
                biLoggerDefaultConfigurations: biLoggerDefaultConfigurations,
                biLoggerEndPoint: biLoggerEndPoint,
                wixSdkAdapter: wixSdkAdapter,
                experiments: experiments,
            })
                .build();
        }
    }
    BiLoggerAdapter.prototype.log = function (logData) {
        return this.logger.log(logData);
    };
    return BiLoggerAdapter;
}());
exports.BiLoggerAdapter = BiLoggerAdapter;
//# sourceMappingURL=bi-logger-adapter.js.map

/***/ }),

/***/ 159:
/*!********************************************************************!*\
  !*** ../node_modules/@wix/iframe-app-bi-context/dist/src/index.js ***!
  \********************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ENRICHERS = {
    _msid: function (SDK) { return SDK.Utils.getInstanceValue('metaSiteId'); },
    _appId: function (SDK) { return SDK.Utils.getInstanceValue('appDefId'); },
    _instanceId: function (SDK) { return SDK.Utils.getInstanceId(); },
    _siteOwnerId: function (SDK) { return SDK.Utils.getSiteOwnerId(); },
    _siteMemberId: function (SDK) { return SDK.Utils.getUid() || ''; },
    _visitorId: function (SDK) { return SDK.Utils.getInstanceValue('aid'); },
    _viewMode: function (SDK) { return SDK.Utils.getViewMode(); }
};
function getBiContext(SDK) {
    return Object.keys(ENRICHERS).reduce(function (res, field) {
        res[field] = ENRICHERS[field](SDK);
        return res;
    }, {});
}
exports.getBiContext = getBiContext;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 16:
/*!***********************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/offerings/offering.dto.js ***!
  \***********************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OfferingType;
(function (OfferingType) {
    OfferingType["INDIVIDUAL"] = "INDIVIDUAL";
    OfferingType["GROUP"] = "GROUP";
    OfferingType["TOUR"] = "TOUR";
    OfferingType["COURSE"] = "COURSE";
    OfferingType["DUMMY"] = "DUMMY";
})(OfferingType = exports.OfferingType || (exports.OfferingType = {}));
var OfferedAsType;
(function (OfferedAsType) {
    OfferedAsType["ONE_TIME"] = "ONE_TIME";
    OfferedAsType["PRICING_PLAN"] = "PRICING_PLAN";
})(OfferedAsType = exports.OfferedAsType || (exports.OfferedAsType = {}));
//# sourceMappingURL=offering.dto.js.map

/***/ }),

/***/ 160:
/*!**********************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/bi-logger.const.js ***!
  \**********************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BI_BOOKINGS_SRC = 16;
exports.BI_BOOKINGS_USER_OF_USER_END_POINT = 'wixboost-ugc';
//# sourceMappingURL=bi-logger.const.js.map

/***/ }),

/***/ 161:
/*!*******************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/offerings/category.dto.builder.js ***!
  \*******************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OfferingCategoryDtoBuilder = /** @class */ (function () {
    function OfferingCategoryDtoBuilder() {
        this.category = {
            id: 'category-id',
            name: '',
            order: 0,
        };
    }
    OfferingCategoryDtoBuilder.prototype.withCategoryId = function (id) {
        this.category.id = id;
        return this;
    };
    OfferingCategoryDtoBuilder.prototype.withName = function (name) {
        this.category.name = name;
        return this;
    };
    OfferingCategoryDtoBuilder.prototype.withOrder = function (order) {
        this.category.order = order;
        return this;
    };
    OfferingCategoryDtoBuilder.prototype.build = function () {
        return this.category;
    };
    return OfferingCategoryDtoBuilder;
}());
exports.OfferingCategoryDtoBuilder = OfferingCategoryDtoBuilder;
//# sourceMappingURL=category.dto.builder.js.map

/***/ }),

/***/ 162:
/*!**************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/offerings/course-offering.dto.builder.js ***!
  \**************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var date_time_1 = __webpack_require__(/*! ../constants/date-time */ 42);
var base_offering_dto_builder_1 = __webpack_require__(/*! ./base-offering.dto.builder */ 35);
var offering_dto_1 = __webpack_require__(/*! ./offering.dto */ 16);
var moment = __webpack_require__(/*! moment */ 30);
var CourseOfferingDtoBuilder = /** @class */ (function (_super) {
    __extends(CourseOfferingDtoBuilder, _super);
    function CourseOfferingDtoBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CourseOfferingDtoBuilder.prototype.getOfferingType = function () {
        return offering_dto_1.OfferingType.COURSE;
    };
    CourseOfferingDtoBuilder.prototype.withRepeatEveryXWeeks = function (value) {
        this.offering.schedule.repeatEveryXWeeks = value;
        return this;
    };
    CourseOfferingDtoBuilder.prototype.validOfferingDto = function () {
        var baseOfferingDto = _super.prototype.validOfferingDto.call(this);
        return __assign({}, baseOfferingDto, { schedule: __assign({}, baseOfferingDto.schedule, { classHours: this.validWeekHours(), repeatEveryXWeeks: 1 }) });
    };
    CourseOfferingDtoBuilder.prototype.withStaffMembers = function (staff) {
        var courseOffering = this.offering;
        var days = Object.keys(courseOffering.schedule.classHours);
        var staffCounter = 0;
        days
            .map(function (dayName) { return courseOffering.schedule.classHours[dayName]; })
            .forEach(function (day) {
            return day &&
                day.workingHours &&
                day.workingHours.forEach(function (workingHour) {
                    return (workingHour.staffId = staff[staffCounter++ % staff.length].id);
                });
        });
        return this;
    };
    CourseOfferingDtoBuilder.prototype.build = function () {
        return _super.prototype.build.call(this);
    };
    return CourseOfferingDtoBuilder;
}(base_offering_dto_builder_1.BaseOfferingDtoBuilder));
exports.CourseOfferingDtoBuilder = CourseOfferingDtoBuilder;
var CourseOfferingDetailsDtoBuilder = /** @class */ (function (_super) {
    __extends(CourseOfferingDetailsDtoBuilder, _super);
    function CourseOfferingDetailsDtoBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CourseOfferingDetailsDtoBuilder.prototype.withTotalNumberOfSessions = function (value) {
        this.offering.schedule.totalNumberOfSessions = value;
        return this;
    };
    CourseOfferingDetailsDtoBuilder.prototype.withStartTime = function (momentDate) {
        this.offering.schedule.startTime = momentDate
            .clone()
            .format(new date_time_1.DateDefaultsConst().TIME_FORMAT);
        return this;
    };
    CourseOfferingDetailsDtoBuilder.prototype.withEndDate = function (momentDate) {
        this.offering.schedule.endDate = momentDate
            .clone()
            .format(new date_time_1.DateDefaultsConst().DATE_FORMAT);
        return this;
    };
    CourseOfferingDetailsDtoBuilder.prototype.validOfferingDto = function () {
        var courseOfferingDto = _super.prototype.validOfferingDto.call(this);
        var schedule = __assign({}, courseOfferingDto.schedule, { totalNumberOfSessions: 12, startTime: moment().format(new date_time_1.DateDefaultsConst().TIME_FORMAT) });
        return __assign({}, courseOfferingDto, { schedule: schedule });
    };
    CourseOfferingDetailsDtoBuilder.prototype.withSessions = function (sessions, exceptionSessions) {
        this.offering.schedule.sessions = sessions;
        this.offering.schedule.exceptionSessions = exceptionSessions;
        return this;
    };
    CourseOfferingDetailsDtoBuilder.prototype.build = function () {
        return _super.prototype.build.call(this);
    };
    return CourseOfferingDetailsDtoBuilder;
}(CourseOfferingDtoBuilder));
exports.CourseOfferingDetailsDtoBuilder = CourseOfferingDetailsDtoBuilder;
//# sourceMappingURL=course-offering.dto.builder.js.map

/***/ }),

/***/ 163:
/*!*************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/offerings/group-offering.dto.builder.js ***!
  \*************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var base_offering_dto_builder_1 = __webpack_require__(/*! ./base-offering.dto.builder */ 35);
var offering_dto_1 = __webpack_require__(/*! ./offering.dto */ 16);
var GroupOfferingDtoBuilder = /** @class */ (function (_super) {
    __extends(GroupOfferingDtoBuilder, _super);
    function GroupOfferingDtoBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupOfferingDtoBuilder.prototype.getOfferingType = function () {
        return offering_dto_1.OfferingType.GROUP;
    };
    GroupOfferingDtoBuilder.prototype.validOfferingDto = function () {
        var baseOfferingDto = _super.prototype.validOfferingDto.call(this);
        return __assign({}, baseOfferingDto, { schedule: __assign({}, baseOfferingDto.schedule, { classHours: this.validWeekHours(), durationInMinutes: 10 }) });
    };
    GroupOfferingDtoBuilder.prototype.withDuration = function (durationInMinutes) {
        this.offering.schedule.durationInMinutes = durationInMinutes;
        return this;
    };
    GroupOfferingDtoBuilder.prototype.withStaffMembers = function (staff) {
        var groupOffering = this.offering;
        var days = Object.keys(groupOffering.schedule.classHours);
        var staffCounter = 0;
        days
            .map(function (dayName) { return groupOffering.schedule.classHours[dayName]; })
            .forEach(function (day) {
            return day &&
                day.workingHours &&
                day.workingHours.forEach(function (workingHour) {
                    return (workingHour.staffId = staff[staffCounter++ % staff.length].id);
                });
        });
        return this;
    };
    GroupOfferingDtoBuilder.prototype.withMaxParticipants = function (maxParticipantsPerOrder) {
        this.offering.schedulePolicy.maxParticipantsPerOrder = maxParticipantsPerOrder;
        return this;
    };
    GroupOfferingDtoBuilder.prototype.withClassHours = function (classWeek) {
        this.offering.schedule.classHours = classWeek;
        return this;
    };
    GroupOfferingDtoBuilder.prototype.build = function () {
        return _super.prototype.build.call(this);
    };
    return GroupOfferingDtoBuilder;
}(base_offering_dto_builder_1.BaseOfferingDtoBuilder));
exports.GroupOfferingDtoBuilder = GroupOfferingDtoBuilder;
//# sourceMappingURL=group-offering.dto.builder.js.map

/***/ }),

/***/ 164:
/*!******************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/offerings/individual-offering.dto.builder.js ***!
  \******************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var base_offering_dto_builder_1 = __webpack_require__(/*! ./base-offering.dto.builder */ 35);
var offering_dto_1 = __webpack_require__(/*! ./offering.dto */ 16);
var IndividualOfferingDtoBuilder = /** @class */ (function (_super) {
    __extends(IndividualOfferingDtoBuilder, _super);
    function IndividualOfferingDtoBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IndividualOfferingDtoBuilder.prototype.getOfferingType = function () {
        return offering_dto_1.OfferingType.INDIVIDUAL;
    };
    IndividualOfferingDtoBuilder.prototype.withDuration = function (durationInMinutes) {
        this.offering.schedule.durationInMinutes = durationInMinutes;
        return this;
    };
    IndividualOfferingDtoBuilder.prototype.validOfferingDto = function () {
        var baseOfferingDto = _super.prototype.validOfferingDto.call(this);
        return __assign({}, baseOfferingDto, { schedule: __assign({}, baseOfferingDto.schedule, { durationInMinutes: 10 }), schedulePolicy: __assign({}, baseOfferingDto.schedulePolicy, { staffMembersIds: [] }) });
    };
    IndividualOfferingDtoBuilder.prototype.withStaffMembers = function (staff) {
        this
            .offering.schedulePolicy.staffMembersIds = staff.map(function (staffMember) { return staffMember.id; });
        return this;
    };
    IndividualOfferingDtoBuilder.prototype.build = function () {
        return _super.prototype.build.call(this);
    };
    return IndividualOfferingDtoBuilder;
}(base_offering_dto_builder_1.BaseOfferingDtoBuilder));
exports.IndividualOfferingDtoBuilder = IndividualOfferingDtoBuilder;
//# sourceMappingURL=individual-offering.dto.builder.js.map

/***/ }),

/***/ 165:
/*!************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/offerings/tour-offering.dto.builder.js ***!
  \************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var base_offering_dto_builder_1 = __webpack_require__(/*! ./base-offering.dto.builder */ 35);
var offering_dto_1 = __webpack_require__(/*! ./offering.dto */ 16);
var TourOfferingDtoBuilder = /** @class */ (function (_super) {
    __extends(TourOfferingDtoBuilder, _super);
    function TourOfferingDtoBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TourOfferingDtoBuilder.prototype.getOfferingType = function () {
        return offering_dto_1.OfferingType.TOUR;
    };
    TourOfferingDtoBuilder.prototype.validOfferingDto = function () {
        var baseOfferingDto = _super.prototype.validOfferingDto.call(this);
        return __assign({}, baseOfferingDto);
    };
    TourOfferingDtoBuilder.prototype.withStaffMembers = function (staff) {
        return this;
    };
    TourOfferingDtoBuilder.prototype.build = function () {
        return _super.prototype.build.call(this);
    };
    return TourOfferingDtoBuilder;
}(base_offering_dto_builder_1.BaseOfferingDtoBuilder));
exports.TourOfferingDtoBuilder = TourOfferingDtoBuilder;
//# sourceMappingURL=tour-offering.dto.builder.js.map

/***/ }),

/***/ 166:
/*!************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/staff/staff.dto.builder.js ***!
  \************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StaffMemberListDtoBuilder = /** @class */ (function () {
    function StaffMemberListDtoBuilder() {
        this.staffList = [];
    }
    StaffMemberListDtoBuilder.prototype.withStaffList = function (staffList) {
        this.staffList = staffList;
        return this;
    };
    StaffMemberListDtoBuilder.prototype.build = function () {
        return { staff: this.staffList };
    };
    return StaffMemberListDtoBuilder;
}());
exports.StaffMemberListDtoBuilder = StaffMemberListDtoBuilder;
var StaffMemberDtoBuilder = /** @class */ (function () {
    function StaffMemberDtoBuilder() {
        this.staffMember = {
            id: 'staffMember-id',
            fullName: 'staffMember name',
        };
    }
    StaffMemberDtoBuilder.prototype.withName = function (name) {
        this.staffMember.fullName = name;
        return this;
    };
    StaffMemberDtoBuilder.prototype.withId = function (id) {
        this.staffMember.id = id;
        return this;
    };
    StaffMemberDtoBuilder.prototype.build = function () {
        return this.staffMember;
    };
    return StaffMemberDtoBuilder;
}());
exports.StaffMemberDtoBuilder = StaffMemberDtoBuilder;
//# sourceMappingURL=staff.dto.builder.js.map

/***/ }),

/***/ 167:
/*!**************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/offerings/offering.domain.js ***!
  \**************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var offering_dto_1 = __webpack_require__(/*! ./offering.dto */ 16);
exports.OfferedAsType = offering_dto_1.OfferedAsType;
var simpleStaffMembersExtractor = function (dto) {
    return dto.schedulePolicy.staffMembersIds;
};
var classHoursStaffMembersExtractor = function (dto) {
    var classHours = dto.schedule.classHours;
    var relevantStaffIds = Object.keys(classHours)
        .map(function (dayOfWeek) { return classHours[dayOfWeek]; })
        .reduce(function (map, dayIntervals) {
        if (dayIntervals && dayIntervals.workingHours) {
            dayIntervals.workingHours.forEach(function (workingHour) {
                if (workingHour.staffId) {
                    map[workingHour.staffId] = true;
                }
            });
        }
        return map;
    }, {});
    return Object.keys(relevantStaffIds);
};
var StaffMembersExtractorFactory = /** @class */ (function () {
    function StaffMembersExtractorFactory() {
    }
    StaffMembersExtractorFactory.fromDto = function (dto) {
        switch (dto.type) {
            case offering_dto_1.OfferingType.INDIVIDUAL:
                return simpleStaffMembersExtractor;
            case offering_dto_1.OfferingType.COURSE:
            case offering_dto_1.OfferingType.GROUP:
                return classHoursStaffMembersExtractor;
            default:
                return function () { return null; };
        }
    };
    return StaffMembersExtractorFactory;
}());
var OfferingFactory = /** @class */ (function () {
    function OfferingFactory() {
    }
    OfferingFactory.fromDto = function (dto) {
        return dto
            ? new Offering(dto, StaffMembersExtractorFactory.fromDto(dto))
            : null;
    };
    return OfferingFactory;
}());
exports.OfferingFactory = OfferingFactory;
var Offering = /** @class */ (function () {
    function Offering(dto, staffMembersExtractor) {
        this.dto = dto;
        this.staffMembersExtractor = staffMembersExtractor;
        //
    }
    Offering.prototype.toDto = function () {
        return this.dto;
    };
    Object.defineProperty(Offering.prototype, "staffMemberIds", {
        get: function () {
            return this.staffMembersExtractor(this.dto);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "id", {
        get: function () {
            return this.dto.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "type", {
        get: function () {
            return this.dto.type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "categoryId", {
        get: function () {
            return this.dto.categoryId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "order", {
        get: function () {
            return this.dto.order;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "name", {
        get: function () {
            return this.dto.info.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "description", {
        get: function () {
            return this.dto.info.description;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "tagLine", {
        get: function () {
            return this.dto.info.tagLine;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "images", {
        get: function () {
            return this.dto.info.images;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "urlName", {
        get: function () {
            return this.dto.urlName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "capacity", {
        get: function () {
            return this.dto.schedulePolicy.capacity;
        },
        enumerable: true,
        configurable: true
    });
    Offering.prototype.hasDuration = function () {
        return 'durationInMinutes' in this.dto.schedule;
    };
    Offering.prototype.hasRepeatEveryXWeeks = function () {
        return 'repeatEveryXWeeks' in this.dto.schedule;
    };
    Object.defineProperty(Offering.prototype, "duration", {
        get: function () {
            return this.hasDuration()
                ? this.dto.schedule.durationInMinutes
                : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "currency", {
        get: function () {
            return this.dto.payment.currency;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "startDate", {
        get: function () {
            return this.dto.schedule.startDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "endDate", {
        get: function () {
            return this.dto.schedule.endDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "price", {
        get: function () {
            return this.dto.payment.price;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "isFree", {
        get: function () {
            return this.dto.payment.isFree;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "priceText", {
        get: function () {
            return this.dto.payment.priceText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "paymentType", {
        get: function () {
            return this.dto.payment.paymentType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "isHidden", {
        get: function () {
            return this.dto.schedulePolicy.uouHidden;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "dummy", {
        get: function () {
            return !!this.dto.dummy;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Offering.prototype, "offeredAs", {
        get: function () {
            return this.dto.offeredAs;
        },
        enumerable: true,
        configurable: true
    });
    return Offering;
}());
exports.Offering = Offering;
//# sourceMappingURL=offering.domain.js.map

/***/ }),

/***/ 168:
/*!**************************************************!*\
  !*** ../node_modules/currency-symbol-map/map.js ***!
  \**************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = {
  'AED': 'د.إ',
  'AFN': '؋',
  'ALL': 'L',
  'AMD': '֏',
  'ANG': 'ƒ',
  'AOA': 'Kz',
  'ARS': '$',
  'AUD': '$',
  'AWG': 'ƒ',
  'AZN': '₼',
  'BAM': 'KM',
  'BBD': '$',
  'BDT': '৳',
  'BGN': 'лв',
  'BHD': '.د.ب',
  'BIF': 'FBu',
  'BMD': '$',
  'BND': '$',
  'BOB': '$b',
  'BRL': 'R$',
  'BSD': '$',
  'BTC': '฿',
  'BTN': 'Nu.',
  'BWP': 'P',
  'BYR': 'Br',
  'BYN': 'Br',
  'BZD': 'BZ$',
  'CAD': '$',
  'CDF': 'FC',
  'CHF': 'CHF',
  'CLP': '$',
  'CNY': '¥',
  'COP': '$',
  'CRC': '₡',
  'CUC': '$',
  'CUP': '₱',
  'CVE': '$',
  'CZK': 'Kč',
  'DJF': 'Fdj',
  'DKK': 'kr',
  'DOP': 'RD$',
  'DZD': 'دج',
  'EEK': 'kr',
  'EGP': '£',
  'ERN': 'Nfk',
  'ETB': 'Br',
  'ETH': 'Ξ',
  'EUR': '€',
  'FJD': '$',
  'FKP': '£',
  'GBP': '£',
  'GEL': '₾',
  'GGP': '£',
  'GHC': '₵',
  'GHS': 'GH₵',
  'GIP': '£',
  'GMD': 'D',
  'GNF': 'FG',
  'GTQ': 'Q',
  'GYD': '$',
  'HKD': '$',
  'HNL': 'L',
  'HRK': 'kn',
  'HTG': 'G',
  'HUF': 'Ft',
  'IDR': 'Rp',
  'ILS': '₪',
  'IMP': '£',
  'INR': '₹',
  'IQD': 'ع.د',
  'IRR': '﷼',
  'ISK': 'kr',
  'JEP': '£',
  'JMD': 'J$',
  'JOD': 'JD',
  'JPY': '¥',
  'KES': 'KSh',
  'KGS': 'лв',
  'KHR': '៛',
  'KMF': 'CF',
  'KPW': '₩',
  'KRW': '₩',
  'KWD': 'KD',
  'KYD': '$',
  'KZT': 'лв',
  'LAK': '₭',
  'LBP': '£',
  'LKR': '₨',
  'LRD': '$',
  'LSL': 'M',
  'LTC': 'Ł',
  'LTL': 'Lt',
  'LVL': 'Ls',
  'LYD': 'LD',
  'MAD': 'MAD',
  'MDL': 'lei',
  'MGA': 'Ar',
  'MKD': 'ден',
  'MMK': 'K',
  'MNT': '₮',
  'MOP': 'MOP$',
  'MRO': 'UM',
  'MRU': 'UM',
  'MUR': '₨',
  'MVR': 'Rf',
  'MWK': 'MK',
  'MXN': '$',
  'MYR': 'RM',
  'MZN': 'MT',
  'NAD': '$',
  'NGN': '₦',
  'NIO': 'C$',
  'NOK': 'kr',
  'NPR': '₨',
  'NZD': '$',
  'OMR': '﷼',
  'PAB': 'B/.',
  'PEN': 'S/.',
  'PGK': 'K',
  'PHP': '₱',
  'PKR': '₨',
  'PLN': 'zł',
  'PYG': 'Gs',
  'QAR': '﷼',
  'RMB': '￥',
  'RON': 'lei',
  'RSD': 'Дин.',
  'RUB': '₽',
  'RWF': 'R₣',
  'SAR': '﷼',
  'SBD': '$',
  'SCR': '₨',
  'SDG': 'ج.س.',
  'SEK': 'kr',
  'SGD': '$',
  'SHP': '£',
  'SLL': 'Le',
  'SOS': 'S',
  'SRD': '$',
  'SSP': '£',
  'STD': 'Db',
  'STN': 'Db',
  'SVC': '$',
  'SYP': '£',
  'SZL': 'E',
  'THB': '฿',
  'TJS': 'SM',
  'TMT': 'T',
  'TND': 'د.ت',
  'TOP': 'T$',
  'TRL': '₤',
  'TRY': '₺',
  'TTD': 'TT$',
  'TVD': '$',
  'TWD': 'NT$',
  'TZS': 'TSh',
  'UAH': '₴',
  'UGX': 'USh',
  'USD': '$',
  'UYU': '$U',
  'UZS': 'лв',
  'VEF': 'Bs',
  'VND': '₫',
  'VUV': 'VT',
  'WST': 'WS$',
  'XAF': 'FCFA',
  'XBT': 'Ƀ',
  'XCD': '$',
  'XOF': 'CFA',
  'XPF': '₣',
  'YER': '﷼',
  'ZAR': 'R',
  'ZWD': 'Z$'
}


/***/ }),

/***/ 169:
/*!*****************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/domains/duration-dto-factory.js ***!
  \*****************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var __1 = __webpack_require__(/*! ../ */ 3);
var DurationDtoFactory = /** @class */ (function () {
    function DurationDtoFactory() {
    }
    DurationDtoFactory.fromOfferingDto = function (offeringDto) {
        return {
            startDate: offeringDto.schedule.startDate,
            durationInMinutes: DurationDtoFactory.durationInMinutesFromOffering(offeringDto),
        };
    };
    DurationDtoFactory.durationInMinutesFromOffering = function (offeringDto) {
        if (offeringDto.type === __1.OfferingType.INDIVIDUAL ||
            offeringDto.type === __1.OfferingType.DUMMY ||
            offeringDto.type === __1.OfferingType.GROUP) {
            var schedule = offeringDto.schedule;
            return schedule.durationInMinutes;
        }
        return 0;
    };
    return DurationDtoFactory;
}());
exports.DurationDtoFactory = DurationDtoFactory;
//# sourceMappingURL=duration-dto-factory.js.map

/***/ }),

/***/ 170:
/*!***********************************************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/entities/offering-schedule-header/offering-schedule-header.dto.builder.js ***!
  \***********************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var offering_schedule_header_dto_1 = __webpack_require__(/*! ./offering-schedule-header.dto */ 90);
var moment = __webpack_require__(/*! moment */ 30);
var date_time_1 = __webpack_require__(/*! ../../constants/date-time */ 42);
var OfferingScheduleHeaderDtoBuilder = /** @class */ (function () {
    function OfferingScheduleHeaderDtoBuilder() {
        this.now = moment();
        this.dateFormatInSchedule = new date_time_1.DateDefaultsConst().DATE_FORMAT;
        this.schedule = {
            startDate: this.now
                .clone()
                .add(20, 'days')
                .format(this.dateFormatInSchedule),
            endDate: this.now
                .clone()
                .add(100, 'days')
                .format(this.dateFormatInSchedule),
            durationInMinutes: 65,
            days: [offering_schedule_header_dto_1.WeekDay.MONDAY, offering_schedule_header_dto_1.WeekDay.THURSDAY],
        };
    }
    OfferingScheduleHeaderDtoBuilder.prototype.withStartDate = function (startDate) {
        this.schedule.startDate = startDate;
        return this;
    };
    OfferingScheduleHeaderDtoBuilder.prototype.withEndDate = function (endDate) {
        this.schedule.endDate = endDate;
        return this;
    };
    OfferingScheduleHeaderDtoBuilder.prototype.withDurationInMinutes = function (durationInMinutes) {
        this.schedule.durationInMinutes = durationInMinutes;
        return this;
    };
    OfferingScheduleHeaderDtoBuilder.prototype.withDays = function (days) {
        this.schedule.days = days;
        return this;
    };
    OfferingScheduleHeaderDtoBuilder.prototype.build = function () {
        return this.schedule;
    };
    return OfferingScheduleHeaderDtoBuilder;
}());
exports.OfferingScheduleHeaderDtoBuilder = OfferingScheduleHeaderDtoBuilder;
//# sourceMappingURL=offering-schedule-header.dto.builder.js.map

/***/ }),

/***/ 171:
/*!***************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/offerings/catalog-offering.dto.builder.js ***!
  \***************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var offering_dto_1 = __webpack_require__(/*! ./offering.dto */ 16);
var offering_info_dto_builder_1 = __webpack_require__(/*! ../entities/offering-info/offering-info.dto.builder */ 67);
var offering_payment_dto_buillder_1 = __webpack_require__(/*! ../entities/offering-payment/offering-payment.dto.buillder */ 66);
var offering_schedule_policy_dto_builder_1 = __webpack_require__(/*! ../entities/offering-schedule-policy/offering-schedule-policy.dto.builder */ 88);
var __1 = __webpack_require__(/*! .. */ 3);
var CatalogOfferingDtoBuilder = /** @class */ (function () {
    function CatalogOfferingDtoBuilder() {
        this.idGenerator = function () { return "offering-id-" + Math.random(); };
        this.offering = this.validCatalogOffering();
    }
    CatalogOfferingDtoBuilder.prototype.validCatalogOffering = function () {
        return {
            id: this.idGenerator(),
            categoryId: this.idGenerator(),
            order: 0,
            type: offering_dto_1.OfferingType.INDIVIDUAL,
            urlName: 'offering-id-0',
            offeredAs: [offering_dto_1.OfferedAsType.ONE_TIME],
            pricingPlanInfo: {
                displayText: null,
                pricingPlans: [],
            },
            info: new offering_info_dto_builder_1.OfferingInfoDtoBuilder().build(),
            payment: new offering_payment_dto_buillder_1.OfferingPaymentDtoBuilder().build(),
            schedulePolicy: new offering_schedule_policy_dto_builder_1.OfferingSchedulePolicyDtoBuilder().build(),
            scheduleHeader: new __1.OfferingScheduleHeaderDtoBuilder().build(),
        };
    };
    CatalogOfferingDtoBuilder.prototype.withId = function (id) {
        this.offering.id = id;
        return this;
    };
    CatalogOfferingDtoBuilder.prototype.withDummyIndication = function () {
        this.offering.dummy = true;
        return this;
    };
    CatalogOfferingDtoBuilder.prototype.withPricingPlanDisplayText = function (displayText) {
        this.offering.pricingPlanInfo.displayText = displayText;
        return this;
    };
    CatalogOfferingDtoBuilder.prototype.withUrlName = function (urlName) {
        this.offering.urlName = urlName;
        return this;
    };
    CatalogOfferingDtoBuilder.prototype.withType = function (offeringType) {
        this.offering.type = offeringType;
        return this;
    };
    CatalogOfferingDtoBuilder.prototype.withCategoryId = function (cid) {
        this.offering.categoryId = cid;
        return this;
    };
    CatalogOfferingDtoBuilder.prototype.withName = function (name) {
        this.offering.info.name = name;
        return this;
    };
    CatalogOfferingDtoBuilder.prototype.withPricePlan = function (pricingPlanName) {
        this.offering.offeredAs = [offering_dto_1.OfferedAsType.PRICING_PLAN];
        this.offering.pricingPlanInfo = {
            displayText: "in pricing plan: " + pricingPlanName,
            pricingPlans: [{ id: '1', name: pricingPlanName }],
        };
        return this;
    };
    CatalogOfferingDtoBuilder.prototype.withDescription = function (description) {
        this.offering.info.description = description;
        return this;
    };
    CatalogOfferingDtoBuilder.prototype.withTagLine = function (tagLine) {
        this.offering.info.tagLine = tagLine;
        return this;
    };
    CatalogOfferingDtoBuilder.prototype.withCapacity = function (capacity) {
        this.offering.schedulePolicy.capacity = capacity;
        return this;
    };
    CatalogOfferingDtoBuilder.prototype.withInfo = function (info) {
        this.offering.info = info;
        return this;
    };
    CatalogOfferingDtoBuilder.prototype.withOrder = function (order) {
        this.offering.order = order;
        return this;
    };
    CatalogOfferingDtoBuilder.prototype.withPayment = function (payment) {
        this.offering.payment = payment;
        return this;
    };
    CatalogOfferingDtoBuilder.prototype.withSchedulePolicy = function (schedulePolicy) {
        this.offering.schedulePolicy = schedulePolicy;
        return this;
    };
    CatalogOfferingDtoBuilder.prototype.withScheduleHeader = function (scheduleHeader) {
        this.offering.scheduleHeader = scheduleHeader;
        return this;
    };
    CatalogOfferingDtoBuilder.prototype.build = function () {
        return this.offering;
    };
    return CatalogOfferingDtoBuilder;
}());
exports.CatalogOfferingDtoBuilder = CatalogOfferingDtoBuilder;
//# sourceMappingURL=catalog-offering.dto.builder.js.map

/***/ }),

/***/ 172:
/*!**********************************************!*\
  !*** ../node_modules/object-assign/index.js ***!
  \**********************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 19:
/*!*******************************************!*\
  !*** ./Shared/appKeys/DefaultSettings.ts ***!
  \*******************************************/
/*! exports provided: defaultSettingsData, CLASSIC_PRESET_ID, OVERLAPPING_PRESET_ID, STRIP_PRESET_ID, GRID_PRESET_ID, BOOKINGS_MAIN_PAGE_PRESET_ID, defaultSettingsDataMap */
/*! exports used: BOOKINGS_MAIN_PAGE_PRESET_ID, CLASSIC_PRESET_ID, GRID_PRESET_ID, OVERLAPPING_PRESET_ID, STRIP_PRESET_ID, defaultSettingsDataMap */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultSettingsData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLASSIC_PRESET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OVERLAPPING_PRESET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STRIP_PRESET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GRID_PRESET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKINGS_MAIN_PAGE_PRESET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return defaultSettingsDataMap; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ 2);
/* harmony import */ var _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./SettingsKeys */ 1);
/* harmony import */ var _mobileToDesktopKeys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mobileToDesktopKeys */ 31);

var _a, _b, _c, _d, _e, _f, _g;


var fontHeading2 = function (size) { return ({
    size: size,
    editorKey: 'font_2',
}); };
var fontParagraph2 = function () { return ({
    size: 16,
    editorKey: 'font_8',
}); };
var color = function (themeName) { return ({ themeName: themeName }); };
var colorWithOpacity = function (themeName, opacity) { return ({
    themeName: themeName,
    opacity: opacity,
}); };
var defaultSettingsDataAll = (_a = {},
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].OFFERING_LIST_LAYOUT] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* OfferingListLayoutOptions */ "k"].CLASSIC,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].TEXT_ALIGNMENT] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* AlignmentOptions */ "a"].LEFT,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_IMAGE] = true,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_TAG_LINE] = true,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_DIVIDER] = true,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_PRICE] = true,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_DURATION] = true,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_START_DATE] = true,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_DAYS_OFFERED] = true,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_BUTTON] = true,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_MULTI_OFFERINGS_TITLE] = true,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_CATEGORIES] = true,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_SERVICE_DIVIDER] = true,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].IMAGE_RESIZE_OPTION] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* ImageResizeOptions */ "g"].CROP,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].IMAGE_SHAPE_OPTION] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* ImageShapeOptions */ "h"].SQUARE,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].IMAGE_POSITION_OPTION] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* ImagePositionOptions */ "f"].LEFT,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].PIN_LOCATION] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* DockLocationOptions */ "d"].MIDDLE,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].IMAGE_AND_TEXT_POSITION] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* OfferingLayoutOptions */ "j"].SIDE_BY_SIDE,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].IMAGE_AND_TEXT_RATIO] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* ImageAndTextRatioOptions */ "e"].RATIO_50_50,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].IMAGE_AND_TEXT_RATIO_IS_FLIPED] = false,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].BORDER_WIDTH] = 1,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].STRIP_BORDER_WIDTH] = 0,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DIVIDER_WIDTH] = 1,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].SERVICE_DIVIDER_WIDTH] = 1,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].BUTTON_STYLE] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* ButtonStyleOptions */ "c"].SQUARE_FILL,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].BUTTON_CORNER_RADIUS] = 100,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].BUTTON_BORDER_WIDTH] = 1,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].OFFERING_NAME_COLOR] = color('color-5'),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].OFFERING_TAGLINE_COLOR] = color('color-5'),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].OFFERING_DETAILS_COLOR] = color('color-5'),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].BACKGROUND_COLOR] = color('color-1'),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].BORDER_COLOR] = colorWithOpacity('color-5', 20),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].IMAGE_BACKGROUND_COLOR] = colorWithOpacity('color-5', 20),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DIVIDER_COLOR] = colorWithOpacity('color-5', 20),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].SERVICE_DIVIDER_COLOR] = colorWithOpacity('color-5', 20),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].BUTTON_TEXT_COLOR_FILL] = color('color-1'),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].BUTTON_TEXT_COLOR_HOLE] = color('color-8'),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].BUTTON_BORDER_COLOR] = color('color-8'),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].BUTTON_BACKGROUND_COLOR] = color('color-8'),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].MULTI_OFFERINGS_TITLE_COLOR] = color('color-5'),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].CATEGORY_SELECTED_UNDERLINE_COLOR] = color('color-8'),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].CATEGORY_DIVIDER_COLOR] = colorWithOpacity('color-5', 20),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].CATEGORY_NAME_COLOR] = color('color-5'),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].MULTI_OFFERINGS_BACKGROUND_COLOR] = color('color-1'),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].OFFERING_TAGLINE_FONT] = fontParagraph2(),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].OFFERING_DETAILS_FONT] = fontParagraph2(),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].MULTI_OFFERINGS_TITLE_FONT] = fontHeading2(32),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].BUTTON_TEXT_FONT] = fontParagraph2(),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].OFFERING_NAME_FONT] = fontHeading2(24),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].CATEGORY_NAME_FONT] = fontParagraph2(),
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].SPACE_BETWEEN_OFFERINGS] = 60,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].STRIP_SPACE_BETWEEN_OFFERINGS] = 0,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].STRIP_SIDE_PADDING] = 0,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].GRID_SIDE_PADDING] = 32,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].CLASSIC_SIDE_PADDING] = 60,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].OVERLAPPING_SIDE_PADDING] = 40,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].STRIP_VERTICAL_PADDING] = 40,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].GRID_VERTICAL_PADDING] = 40,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].CLASSIC_VERTICAL_PADDING] = 60,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].OVERLAPPING_VERTICAL_PADDING] = 40,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].CATEGORY_ALIGNMENT] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* AlignmentOptions */ "a"].CENTER,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].MULTI_OFFERINGS_TITLE_ALIGNMENT] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* AlignmentOptions */ "a"].CENTER,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].FIT_CATEGORY_WIDTH] = false,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].BOOK_FLOW_ACTION_TEXT] = '',
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].NO_BOOK_FLOW_ACTION_TEXT] = '',
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].MULTI_OFFERINGS_TITLE_TEXT] = '',
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].SELECTED_RESOURCES] = [],
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].LAYOUT_CARDS_PER_ROW] = 3,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].CARDS_SPACING] = 32,
    _a);
var defaultSettingsDataMobile = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, Object(_mobileToDesktopKeys__WEBPACK_IMPORTED_MODULE_2__[/* mergeDesktopDefaultsIntoMobile */ "c"])(defaultSettingsDataAll), (_b = {}, _b[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_IMAGE_SHAPE_OPTION] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* ImageShapeOptions */ "h"].RECTANGLE, _b[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_TEXT_ALIGNMENT] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* AlignmentOptions */ "a"].CENTER, _b[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_CARDS_SPACING] = 20, _b));
var defaultSettingsData = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, defaultSettingsDataAll, defaultSettingsDataMobile);
var CLASSIC_PRESET_ID = 'Wix_Bookings_Offering_List_Widget_Classic';
var OVERLAPPING_PRESET_ID = 'Wix_Bookings_Offering_List_Widget_Overlapping';
var STRIP_PRESET_ID = 'Wix_Bookings_Offering_List_Widget_Strip';
var GRID_PRESET_ID = 'Wix_Bookings_Offering_List_Widget_Grid';
var BOOKINGS_MAIN_PAGE_PRESET_ID = 'Wix_Bookings_Offering_List_Main_Page';
var CLASSIC_DEFAULT_SETTINGS = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, defaultSettingsData, (_c = {}, _c[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].IMAGE_AND_TEXT_RATIO] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* ImageAndTextRatioOptions */ "e"].RATIO_40_60, _c[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].IMAGE_AND_TEXT_RATIO_IS_FLIPED] = true, _c[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_DURATION] = false, _c[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_CATEGORIES] = false, _c[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_MULTI_OFFERINGS_TITLE] = false, _c));
var OVERLAPPING_DEFAULT_SETTINGS = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, defaultSettingsData, (_d = {}, _d[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].OFFERING_LIST_LAYOUT] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* OfferingListLayoutOptions */ "k"].OVERLAPPING, _d[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_CATEGORIES] = false, _d[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_MULTI_OFFERINGS_TITLE] = false, _d));
var STRIP_DEFAULT_SETTINGS = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, defaultSettingsData, (_e = {}, _e[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].OFFERING_LIST_LAYOUT] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* OfferingListLayoutOptions */ "k"].STRIP, _e[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].IMAGE_SHAPE_OPTION] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* ImageShapeOptions */ "h"].ROUND, _e[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].STRIP_SIDE_PADDING] = 0, _e[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].BACKGROUND_COLOR] = colorWithOpacity('color-1', 0), _e[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_IMAGE] = false, _e[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_TAG_LINE] = false, _e[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_DURATION] = false, _e[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_START_DATE] = false, _e[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_DAYS_OFFERED] = false, _e[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_MULTI_OFFERINGS_TITLE] = false, _e[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_CATEGORIES] = false, _e));
var GRID_DEFAULT_SETTINGS = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, defaultSettingsData, (_f = {}, _f[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].OFFERING_LIST_LAYOUT] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* OfferingListLayoutOptions */ "k"].GRID, _f[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].LAYOUT_CARDS_PER_ROW] = 3, _f[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].IMAGE_SHAPE_OPTION] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* ImageShapeOptions */ "h"].RECTANGLE, _f[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_CATEGORIES] = false, _f[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_MULTI_OFFERINGS_TITLE] = false, _f[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_TAG_LINE] = false, _f[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_MULTI_OFFERINGS_TITLE] = false, _f[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_CATEGORIES] = false, _f));
var BOOKINGS_MAIN_PAGE_SETTINGS = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, defaultSettingsData, (_g = {}, _g[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].OFFERING_LIST_LAYOUT] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* OfferingListLayoutOptions */ "k"].GRID, _g[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].LAYOUT_CARDS_PER_ROW] = 3, _g[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].IMAGE_SHAPE_OPTION] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* ImageShapeOptions */ "h"].RECTANGLE, _g[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_TAG_LINE] = false, _g));
var defaultSettingsDataMap = new Map();
defaultSettingsDataMap.set(CLASSIC_PRESET_ID, CLASSIC_DEFAULT_SETTINGS);
defaultSettingsDataMap.set(OVERLAPPING_PRESET_ID, OVERLAPPING_DEFAULT_SETTINGS);
defaultSettingsDataMap.set(STRIP_PRESET_ID, STRIP_DEFAULT_SETTINGS);
defaultSettingsDataMap.set(GRID_PRESET_ID, GRID_DEFAULT_SETTINGS);
defaultSettingsDataMap.set(BOOKINGS_MAIN_PAGE_PRESET_ID, BOOKINGS_MAIN_PAGE_SETTINGS);


/***/ }),

/***/ 193:
/*!**************************************!*\
  !*** ../node_modules/axios/index.js ***!
  \**************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./lib/axios */ 231);

/***/ }),

/***/ 2:
/*!******************************************!*\
  !*** ../node_modules/tslib/tslib.es6.js ***!
  \******************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ../node_modules/@wix/bookings-adapter-ooi-wix-sdk/dist/src/WixOOISDKAdapter.js (referenced with cjs require), ../node_modules/@wix/bookings-adapter-wix-sdk/dist/src/WixMock.js (referenced with cjs require), ../node_modules/@wix/bookings-adapter-wix-sdk/dist/src/WixSDKAdapter.js (referenced with cjs require), ../node_modules/@wix/bookings-adapter-wix-sdk/dist/src/WixSDKFakeAdapter.js (referenced with cjs require), ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/bookings-bi-defaults.js (referenced with cjs require), ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/ssr-logger/SSRLogger.js (referenced with cjs require), ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/web-logger/bookings-bi-defaults.js (referenced with cjs require), ../node_modules/@wix/bookings-viewer-ui/dist/src/assets/icons/dist/components/CloseIcon.js (referenced with cjs require), ../node_modules/@wix/bookings-viewer-ui/dist/src/components/Modal/TpaModal.js (referenced with cjs require), ../node_modules/@wix/bookings-viewer-ui/dist/src/components/UserMessage/UserMessage.js (referenced with cjs require), ../node_modules/@wix/js-sdk-wrapper/dist/src/create-wix-sdk-wrapper.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/button-next/button-next.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/checkbox/Checkbox.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/deprecated/button/Button.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/input/Input.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/popover/Popover.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/popover/index.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/popover/modifiers.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/toggle-switch/ToggleSwitch.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/tooltip/Tooltip.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/tooltip/index.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/hocs/Focusable/FocusableHOC.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/utils/withStylable/withStylable.js (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ 205:
/*!**********************************************************************!*\
  !*** ../node_modules/@wix/web-bi-logger/dist/src/tracking-logger.js ***!
  \**********************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHost = exports.factory = undefined;

var _tracker = __webpack_require__(/*! ./lib/tracker */ 215);

var tracker = _interopRequireWildcard(_tracker);

var _logger = __webpack_require__(/*! ./logger */ 217);

var logger = _interopRequireWildcard(_logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var factory = exports.factory = function factory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var trackSession = options.trackSession || typeof options.trackSession === 'undefined';

  if (trackSession) {
    tracker.track(logger.factory);
  }

  return logger.factory(options);
};

var setHost = exports.setHost = logger.setHost;

exports.default = {
  factory: factory,
  setHost: logger.setHost
};

/***/ }),

/***/ 209:
/*!***************************************************************************!*\
  !*** ../node_modules/@wix/wix-bi-logger-client/dist/bi-logger-factory.js ***!
  \***************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = __webpack_require__(/*! ./assert */ 109);
var BiLogger = __webpack_require__(/*! ./bi-logger */ 110);

var BiLoggerFactory = function () {
  function BiLoggerFactory() {
    _classCallCheck(this, BiLoggerFactory);

    this._publishers = [];
    this._validators = [];
    this._defaults = {};
    this._events = {};
  }

  _createClass(BiLoggerFactory, [{
    key: 'addPublisher',
    value: function addPublisher(publisher) {
      assert.defined(publisher, 'Publisher must be provided');
      assert.ok(typeof publisher === 'function', 'Expected a publisher function');
      this._publishers.push(publisher);
      return this;
    }
  }, {
    key: 'addValidator',
    value: function addValidator(validator) {
      assert.defined(validator, 'Validator must be provided');
      assert.ok((typeof validator === 'undefined' ? 'undefined' : _typeof(validator)) === 'object' && validator, 'Expected a validator object');
      assert.ok(validator.execute && validator.match, 'Provided validator does not match the interface');
      this._validators.push(validator);
      return this;
    }
  }, {
    key: 'setDefaults',
    value: function setDefaults(defaults) {
      assert.defined(defaults, 'Defaults must be provided');
      assert.object(defaults, 'Defaults must be an object');
      this._defaults = defaults;
      return this;
    }
  }, {
    key: 'updateDefaults',
    value: function updateDefaults(defaults) {
      assert.defined(defaults, 'Defaults must be provided');
      assert.object(defaults, 'Defaults must be an object');
      Object.assign(this._defaults, defaults);
      return this;
    }
  }, {
    key: 'setEvents',
    value: function setEvents(events) {
      assert.defined(events, 'Events must be provided');
      assert.object(events, 'Events must be an object');
      this._events = events;
      return this;
    }
  }, {
    key: 'setDefaultValueTimeout',
    value: function setDefaultValueTimeout(defaultValueTimeout) {
      assert.defined(defaultValueTimeout, 'Default Value Timeout must be provided');
      this._defaultValueTimeout = defaultValueTimeout;
      return this;
    }
  }, {
    key: 'setDefaultContinueOnFail',
    value: function setDefaultContinueOnFail(defaultContinueOnFail) {
      assert.defined(defaultContinueOnFail, 'Default Continue On Fail must be provided');
      this._defaultContinueOnFail = defaultContinueOnFail;
      return this;
    }
  }, {
    key: 'setPublisherFailHandler',
    value: function setPublisherFailHandler(onPublisherFailHandler) {
      assert.defined(onPublisherFailHandler, 'Publisher Fail Handler must be provided');
      this._onPublisherFailHandler = onPublisherFailHandler;
      return this;
    }
  }, {
    key: 'logger',
    value: function logger(context) {
      return new BiLogger({
        publishers: this._publishers,
        validators: this._validators,
        defaults: this._defaults,
        events: this._events,
        defaultValueTimeout: this._defaultValueTimeout,
        defaultContinueOnFail: this._defaultContinueOnFail,
        onPublisherFailHandler: this._onPublisherFailHandler
      }, context);
    }
  }]);

  return BiLoggerFactory;
}();

module.exports = BiLoggerFactory;
//# sourceMappingURL=bi-logger-factory.js.map

/***/ }),

/***/ 21:
/*!*************************************************!*\
  !*** ../node_modules/webpack/buildin/global.js ***!
  \*************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 210:
/*!***************************************************************************!*\
  !*** ../node_modules/@wix/wix-bi-logger-client/dist/utils/collections.js ***!
  \***************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This callback type is called `requestCallback` and is displayed as a global symbol.
 *
 * @callback iterateeCallback
 * @param {*} Value
 * @param {string} Key
 * @param {object} Original object
 */
/**
 * Iterates over object values
 * @param {Object} collection
 * @param {iterateeCallback} iteratee
 * @return {Object} iterated object
 */
module.exports.mapValues = function (collection, iteratee) {
  if (!collection) {
    return {};
  }

  return Object.keys(collection).reduce(function (acc, key) {
    acc[key] = iteratee(collection[key], key, collection);
    return acc;
  }, {});
};

module.exports.filterValues = function (collection, iteratee) {
  if (!collection) {
    return {};
  }

  return Object.keys(collection).reduce(function (acc, key) {
    var keep = iteratee(collection[key], key, collection);

    if (keep) {
      acc[key] = collection[key];
    }

    return acc;
  }, {});
};
//# sourceMappingURL=collections.js.map

/***/ }),

/***/ 211:
/*!***********************************************************************!*\
  !*** ../node_modules/@wix/wix-bi-logger-client/dist/utils/promise.js ***!
  \***********************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * rejects original promise after specified timeout
 * @param {Promise<R>} promise Original promise
 * @param {string} [message] Additional message for timeout reject
 * @param {number} timeout Time for reject
 * @return {Promise<R>}
 */
module.exports.timedPromise = function (promise, _ref) {
  var message = _ref.message,
      timeout = _ref.timeout;

  var timeoutPromise = new Promise(function (resolve, reject) {
    setTimeout(reject, timeout, message ? 'Timeout: ' + message : 'Timeout');
  });
  return Promise.race([promise, timeoutPromise]);
};

/**
 * Works like Promise.all expect uses object insetead of array.
 * @param {Object} promiseObject
 * @return {Promise} Promise wiht original keys and resolved values
 */
module.exports.allAsObject = function (promiseObject) {
  var keys = Object.keys(promiseObject);
  return Promise.all(keys.map(function (key) {
    return promiseObject[key];
  })).then(function (resolved) {
    return resolved.reduce(function (acc, value, i) {
      acc[keys[i]] = value;
      return acc;
    }, {});
  });
};
//# sourceMappingURL=promise.js.map

/***/ }),

/***/ 212:
/*!*******************************************************************!*\
  !*** ../node_modules/@wix/wix-bi-logger-client/dist/utils/log.js ***!
  \*******************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  error: function error() {
    if (console && console.error) {
      var _console;

      (_console = console).error.apply(_console, arguments);
    }
  }
};
//# sourceMappingURL=log.js.map

/***/ }),

/***/ 213:
/*!****************************************************************************!*\
  !*** ../node_modules/@wix/wix-bi-logger-client/dist/utils/event-buffer.js ***!
  \****************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debounce = __webpack_require__(/*! ./debounce */ 214);

var createEvent = function createEvent(event, startTime) {
  return {
    dt: Date.now() - startTime,
    f: event
  };
};

var createBatch = function createBatch(events, startTime) {
  return {
    dt: Date.now() - startTime,
    e: events
  };
};

var EventBuffer = function () {
  function EventBuffer(debounceMs) {
    var _this = this;

    _classCallCheck(this, EventBuffer);

    this._flushHandler = function (x) {
      return x;
    };
    this._flushDebounced = debounce(function () {
      return _this._flush();
    }, debounceMs);

    this._init();
  }

  _createClass(EventBuffer, [{
    key: '_init',
    value: function _init() {
      var _this2 = this;

      this._startTime = Date.now();
      this._events = [];
      this._resolve = null;
      this._promise = new Promise(function (resolve) {
        return _this2._resolve = resolve;
      });
    }
  }, {
    key: '_flush',
    value: function _flush() {
      var events = this._events;
      var resolve = this._resolve;
      var startTime = this._startTime;

      this._init();

      this._flushHandler(createBatch(events, startTime)).then(resolve);
    }
  }, {
    key: 'onFlush',
    value: function onFlush(handler) {
      this._flushHandler = handler;

      return this;
    }
  }, {
    key: 'feed',
    value: function feed(event) {
      this._events.push(createEvent(event, this._startTime));
      this._flushDebounced();

      return this._promise;
    }
  }]);

  return EventBuffer;
}();

module.exports = EventBuffer;
//# sourceMappingURL=event-buffer.js.map

/***/ }),

/***/ 214:
/*!************************************************************************!*\
  !*** ../node_modules/@wix/wix-bi-logger-client/dist/utils/debounce.js ***!
  \************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout = void 0;

  // This is the function that is actually executed when
  // the DOM event is triggered.
  return function () {
    // Store the context of this and any parameters passed to executedFunction
    var context = this;
    var args = arguments;

    // The function to be called after
    // the debounce time has elapsed
    var later = function later() {
      // null timeout to indicate the debounce ended
      timeout = null;

      // Call function now if you did not on the leading end
      if (!immediate) {
        func.apply(context, args);
      }
    };

    // Determine if you should call the function
    // on the leading or trail end
    var callNow = immediate && !timeout;

    // This will reset the waiting every function execution.
    // This is the step that prevents the function from
    // being executed because it will never reach the
    // inside of the previous setTimeout
    clearTimeout(timeout);

    // Restart the debounce waiting period.
    // setTimeout returns a truthy value (it differs in web vs node)
    timeout = setTimeout(later, wait);

    // Call immediately if you're dong a leading
    // end execution
    if (callNow) {
      func.apply(context, args);
    }
  };
}

module.exports = debounce;
//# sourceMappingURL=debounce.js.map

/***/ }),

/***/ 215:
/*!******************************************************************!*\
  !*** ../node_modules/@wix/web-bi-logger/dist/src/lib/tracker.js ***!
  \******************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.track = track;

var _utils = __webpack_require__(/*! ./utils */ 111);

var _navigator = __webpack_require__(/*! ./navigator */ 216);

var _env = __webpack_require__(/*! ./env */ 39);

var _browser = __webpack_require__(/*! ./browser */ 74);

var IS_TRACKING = '__isTrackingBiBrowsingSession__';
var ENDPOINT = 'p';
var SOURCE = 19;
var EVID = 3;

function shouldTrack() {
  return !(0, _env.isWebWorker)() && (0, _env.requestWindow)(function (window) {
    return !window[IS_TRACKING];
  });
}

function setIsTracking() {
  return (0, _env.requestWindow)(function (window) {
    return window[IS_TRACKING] = true;
  });
}

function getLogger(loggerFactory) {
  return loggerFactory({ endpoint: ENDPOINT, useBeacon: true }).setDefaults({ src: SOURCE, evid: EVID, vsi: (0, _utils.guid)() }).logger();
}

function trackBrowsingSession(loggerFactory) {
  var logger = getLogger(loggerFactory);
  var firstInSession = 1;

  (0, _navigator.listen)(function (fromUrl, toUrl) {
    var _requestWindow = (0, _env.requestWindow)(function (window) {
      return { sr: (0, _browser.getDesktopSize)(window), wr: (0, _browser.getWindowSize)(window) };
    }),
        sr = _requestWindow.sr,
        wr = _requestWindow.wr;

    logger.log({ from: fromUrl, to: toUrl, fis: firstInSession, sr: sr, wr: wr });
    firstInSession = 0;
  });
}

/**
 * Sends a page view event on initial load and on every page switch
 * BI event definition: http://bo.wix.com/bi-catalog-webapp/#/sources/19/events/3
 */
function track(loggerFactory) {
  if (shouldTrack()) {
    setIsTracking();
    trackBrowsingSession(loggerFactory);
  }
}

/***/ }),

/***/ 216:
/*!********************************************************************!*\
  !*** ../node_modules/@wix/web-bi-logger/dist/src/lib/navigator.js ***!
  \********************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listen = listen;

var _env = __webpack_require__(/*! ./env */ 39);

function hook(obj, fnName, hook) {
  if (!obj || !obj[fnName]) {
    return;
  }

  var original = obj[fnName];
  obj[fnName] = function () {
    hook.apply(null, arguments);
    return original.apply(obj, arguments);
  };
}

function onLoad(cb) {
  setTimeout(function () {
    return (0, _env.requestWindow)(function (window) {
      return cb(window.location.href);
    });
  });
}

function onPushState(cb) {
  (0, _env.requestWindow)(function (_ref) {
    var history = _ref.history;
    return ['pushState', 'replaceState'].forEach(function (fnName) {
      hook(history, fnName, function (_, __, url) {
        return cb(url);
      });
    });
  });
}

function onPopState(cb) {
  (0, _env.requestWindow)(function (window) {
    return window.addEventListener('popstate', function () {
      return cb(window.location.href);
    });
  });
}

function listen(cb) {
  (0, _env.requestWindow)(function (window) {
    var fromUrl = window.document.referrer;

    [onLoad, onPushState, onPopState].forEach(function (event) {
      return event(function (toUrl) {
        cb(fromUrl, toUrl);
        fromUrl = toUrl;
      });
    });
  });
}

/***/ }),

/***/ 217:
/*!*************************************************************!*\
  !*** ../node_modules/@wix/web-bi-logger/dist/src/logger.js ***!
  \*************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHost = exports.factory = undefined;

var _wixBiLoggerClient = __webpack_require__(/*! @wix/wix-bi-logger-client */ 108);

var _env = __webpack_require__(/*! ./lib/env */ 39);

var env = _interopRequireWildcard(_env);

var _publishers = __webpack_require__(/*! ./lib/publishers */ 218);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var factory = exports.factory = function factory(options) {
  return new _wixBiLoggerClient.BiLoggerFactory().addPublisher((0, _publishers.resolvePublisher)(options));
};
var setHost = exports.setHost = env.setHost;

/***/ }),

/***/ 218:
/*!*********************************************************************!*\
  !*** ../node_modules/@wix/web-bi-logger/dist/src/lib/publishers.js ***!
  \*********************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.imagePublisher = imagePublisher;
exports.beaconPublisher = beaconPublisher;
exports.fetchPublisher = fetchPublisher;
exports.resolvePublisher = resolvePublisher;

var _utils = __webpack_require__(/*! ./utils */ 111);

var _env = __webpack_require__(/*! ./env */ 39);

var _transport = __webpack_require__(/*! ./transport */ 219);

function imagePublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function imagePublisher(params) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params, context);
    return (0, _transport.pixelTransport)(url, context.image);
  };
}

function beaconPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function beaconPublisher(params) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params, context);
    return (0, _transport.beaconTransport)(url).catch(function () {
      return (0, _transport.pixelTransport)(url, context.image);
    });
  };
}

function fetchPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function fetchPublisher(params) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params, context);
    return (0, _transport.fetchTransport)(url);
  };
}

function resolvePublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var publisher = void 0;

  if ((0, _env.isWebWorker)()) {
    publisher = fetchPublisher;
  } else if (typeof options.useBeacon === 'undefined' || options.useBeacon) {
    publisher = beaconPublisher;
  } else {
    publisher = imagePublisher;
  }

  publisher = publisher(options);

  /* eslint-disable camelcase */
  return function (params, context) {
    return publisher(_extends({}, params, (0, _utils.getCookieParams)({
      _client_id: { name: '_wixCIDX' },
      _uuid: { name: '_wixUIDX', transform: function transform(value) {
          return typeof value === 'string' && value.split('|')[1];
        } }
    })), context);
  };
}

/***/ }),

/***/ 219:
/*!********************************************************************!*\
  !*** ../node_modules/@wix/web-bi-logger/dist/src/lib/transport.js ***!
  \********************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.beaconTransport = beaconTransport;
exports.pixelTransport = pixelTransport;
exports.fetchTransport = fetchTransport;

var _browser = __webpack_require__(/*! ./browser */ 74);

function beaconTransport(url) {
  return new Promise(function (resolve, reject) {
    return (0, _browser.sendBeacon)(url) ? resolve() : reject(new Error('Transport Error: Cannot send bi using beacons'));
  });
}

function pixelTransport(url, image) {
  return new Promise(function (resolve, reject) {
    var biImage = image || new window.Image(0, 0);
    biImage.onload = function () {
      return resolve();
    };
    biImage.onerror = function () {
      return reject(new Error('Transport Error: Cannot send bi using pixelTransport'));
    };
    biImage.src = url;
  });
}

function fetchTransport(url) {
  return fetch(url, { credentials: 'include' }).then(function (response) {
    if (!response.ok) {
      throw Error('Transport Error: Cannot send bi using fetch. Status: ' + response.status);
    }
  });
}

/***/ }),

/***/ 220:
/*!***************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/reporter/reporter.js ***!
  \***************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _logger = __webpack_require__(/*! @wix/web-bi-logger/dist/src/logger */ 357);

var biLoggerFactory = _interopRequireWildcard(_logger);

var _conf = __webpack_require__(/*! ../conf */ 94);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Reporter = function () {
  function Reporter(loggerFactory, baseUrl) {
    _classCallCheck(this, Reporter);

    this.factory = loggerFactory ? loggerFactory : biLoggerFactory.factory({ host: baseUrl });

    this.performancePublisher = this.factory.logger({
      endpoint: _conf.PERFORMANCE_BI_ENPOINT
    });
    this.fedopsPublisher = this.factory.logger({
      endpoint: _conf.FEDOPS_BI_ENDPOINT
    });
  }

  Reporter.prototype.report = function report(data, reporterEndpoint) {
    if (!data) {
      return null;
    }

    switch (reporterEndpoint) {
      case _conf.PERFORMANCE_BI_ENPOINT:
        return this.performancePublisher.log(data);
      default:
        return this.fedopsPublisher.log(data);
    }
  };

  return Reporter;
}();

exports.default = Reporter;

/***/ }),

/***/ 221:
/*!************************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/node_modules/@wix/web-bi-logger/dist/src/lib/utils.js ***!
  \************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var browser_1 = __webpack_require__(/*! ./browser */ 131);
var env_1 = __webpack_require__(/*! ./env */ 132);
var cacheKillerCounter = 0;
function getCookies(params) {
    return Object.keys(params).reduce(function (res, param) {
        var _a = typeof params[param] === 'string'
            ? { name: params[param] }
            : params[param], name = _a.name, _b = _a.transform, transform = _b === void 0 ? function (x) { return x; } : _b;
        var value = transform(browser_1.readCookie(name));
        if (value) {
            res[param] = value;
        }
        return res;
    }, {});
}
exports.getCookies = getCookies;
function buildBiUrl(_a, params, context) {
    var _b = _a.host, host = _b === void 0 ? '' : _b, _c = _a.endpoint, endpoint = _c === void 0 ? '' : _c;
    if (context === void 0) { context = {}; }
    host = host || env_1.getHost();
    endpoint = context.endpoint || endpoint;
    if (!context.useBatch) {
        params._ = '' + new Date().getTime() + cacheKillerCounter++;
    }
    var pairs = context.useBatch
        ? []
        : Object.keys(params).map(function (key) {
            return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
        }, []);
    return ["//" + host + "/" + endpoint]
        .concat(pairs.length ? pairs.join('&') : [])
        .join('?');
}
exports.buildBiUrl = buildBiUrl;
function guid() {
    /*eslint-disable */
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
    /*eslint-enable */
}
exports.guid = guid;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 222:
/*!***************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/app-data/location.js ***!
  \***************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _env = __webpack_require__(/*! ../env */ 48);

var location = function location() {
  return typeof (0, _env.env)() !== 'undefined' && (0, _env.env)().location;
};

exports.default = {
  getHost: function getHost() {
    return location() && (0, _env.env)().location.host;
  },
  isFedopsDev: function isFedopsDev() {
    var q = (location() || {}).search || '';
    return q.indexOf('fedops=dev') > -1;
  }
};

/***/ }),

/***/ 223:
/*!**********************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/data-items/phases/loading-phase-item.js ***!
  \**********************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dataItem = __webpack_require__(/*! ../common/data-item */ 49);

var _dataItem2 = _interopRequireDefault(_dataItem);

var _performance = __webpack_require__(/*! ../../performance/performance */ 75);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingPhaseItem = function (_DataItem) {
  _inherits(LoadingPhaseItem, _DataItem);

  function LoadingPhaseItem(_ref) {
    var name = _ref.name,
        phaseStartTime = _ref.phaseStartTime;

    _classCallCheck(this, LoadingPhaseItem);

    var _this = _possibleConstructorReturn(this, _DataItem.call(this, {}));

    _this.data.name = name;
    _this.data.duration = Math.floor(_performance2.default.now() - phaseStartTime);
    return _this;
  }

  return LoadingPhaseItem;
}(_dataItem2.default);

exports.default = LoadingPhaseItem;

/***/ }),

/***/ 224:
/*!**************************************************!*\
  !*** ../node_modules/strict-uri-encode/index.js ***!
  \**************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),

/***/ 225:
/*!*****************************************************!*\
  !*** ../node_modules/decode-uri-component/index.js ***!
  \*****************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),

/***/ 226:
/*!***********************************************!*\
  !*** ../node_modules/uuid/lib/rng-browser.js ***!
  \***********************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),

/***/ 227:
/*!***********************************************!*\
  !*** ../node_modules/uuid/lib/bytesToUuid.js ***!
  \***********************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),

/***/ 228:
/*!*************************************************************!*\
  !*** ../node_modules/@wix/js-sdk-wrapper/dist/src/utils.js ***!
  \*************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function addTimeout(promise, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.timeout, timeout = _c === void 0 ? 2 * 60 * 1000 : _c, _d = _b.message, message = _d === void 0 ? 'Timeout: Wix Js Sdk' : _d;
    var error;
    try {
        throw new Error(message); // to capture stack trace for IE
    }
    catch (ex) {
        error = ex;
    }
    var timerId;
    var timeoutPromise = new Promise(function (resolve, reject) {
        timerId = setTimeout(reject, timeout, error);
    });
    var clear = function () { return clearTimeout(timerId); };
    promise.then(clear, clear);
    return Promise.race([promise, timeoutPromise]);
}
exports.addTimeout = addTimeout;
function createSafeCall(onError) {
    return function (fn) {
        return function () {
            try {
                return fn.apply(this, arguments); //tslint:disable-line:no-invalid-this
            }
            catch (ex) {
                onError(ex);
                return null;
            }
        };
    };
}
exports.createSafeCall = createSafeCall;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 229:
/*!******************************************************!*\
  !*** ../node_modules/greedy-split/dist/src/index.js ***!
  \******************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function greedySplit(str, separator, limit) {
  var result = str.split(separator, limit);
  if (result.length === limit) {
    var length = 0;
    if (typeof separator === 'string') {
      length = result.join(separator).length;
    } else {
      length = result.reduce(function (l, x, i) {
        var separatorLength = 0;
        if (i + 1 < limit) {
          separatorLength = str.slice(l).match(separator).shift().length;
        }
        return l + x.length + separatorLength;
      }, 0);
    }
    result[limit - 1] += str.slice(length);
  }
  return result;
}

module.exports = greedySplit;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 230:
/*!*******************************************************************!*\
  !*** ../node_modules/data-capsule/dist/src/utils/record-utils.js ***!
  \*******************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global localStorage */


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _require = __webpack_require__(/*! ../utils/constants */ 51),
    STORAGE_PREFIX = _require.STORAGE_PREFIX,
    PREFIX_SEPARATOR = _require.PREFIX_SEPARATOR,
    KEY_SEPARATOR = _require.KEY_SEPARATOR;

function parseCacheKey(cacheKey) {
  var _cacheKey$split = cacheKey.split(KEY_SEPARATOR),
      _cacheKey$split2 = _slicedToArray(_cacheKey$split, 2),
      prefix = _cacheKey$split2[0],
      key = _cacheKey$split2[1];

  var _prefix$split = prefix.split(PREFIX_SEPARATOR),
      _prefix$split2 = _slicedToArray(_prefix$split, 3),
      namespace = _prefix$split2[1],
      scope = _prefix$split2[2];

  if (scope === undefined) {
    return { namespace: namespace, key: key };
  } else {
    return { namespace: namespace, scope: scope, key: key };
  }
}

function deserializeData(data) {
  return JSON.parse(data);
}

function getCacheRecords() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STORAGE_PREFIX + PREFIX_SEPARATOR;

  var items = [];
  for (var i = 0; i < localStorage.length; i++) {
    var key = localStorage.key(i);
    if (key.startsWith(prefix)) {
      var data = localStorage.getItem(key);
      items.push(Object.assign({
        size: key.length + data.length,
        originalKey: key
      }, deserializeData(data), parseCacheKey(key)));
    }
  }
  return items;
}

function isExpired(data) {
  if (data.expiration) {
    return data.createdAt + data.expiration * 1000 <= Date.now();
  } else {
    return false;
  }
}

module.exports = {
  deserializeData: deserializeData,
  getCacheRecords: getCacheRecords,
  isExpired: isExpired
};

/***/ }),

/***/ 231:
/*!******************************************!*\
  !*** ../node_modules/axios/lib/axios.js ***!
  \******************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./utils */ 15);
var bind = __webpack_require__(/*! ./helpers/bind */ 112);
var Axios = __webpack_require__(/*! ./core/Axios */ 233);
var mergeConfig = __webpack_require__(/*! ./core/mergeConfig */ 118);
var defaults = __webpack_require__(/*! ./defaults */ 115);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(/*! ./cancel/Cancel */ 119);
axios.CancelToken = __webpack_require__(/*! ./cancel/CancelToken */ 245);
axios.isCancel = __webpack_require__(/*! ./cancel/isCancel */ 114);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(/*! ./helpers/spread */ 246);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ 232:
/*!*************************************************************!*\
  !*** ../node_modules/axios/node_modules/is-buffer/index.js ***!
  \*************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),

/***/ 233:
/*!***********************************************!*\
  !*** ../node_modules/axios/lib/core/Axios.js ***!
  \***********************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 15);
var buildURL = __webpack_require__(/*! ../helpers/buildURL */ 113);
var InterceptorManager = __webpack_require__(/*! ./InterceptorManager */ 234);
var dispatchRequest = __webpack_require__(/*! ./dispatchRequest */ 235);
var mergeConfig = __webpack_require__(/*! ./mergeConfig */ 118);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);
  config.method = config.method ? config.method.toLowerCase() : 'get';

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 234:
/*!************************************************************!*\
  !*** ../node_modules/axios/lib/core/InterceptorManager.js ***!
  \************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 15);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 235:
/*!*********************************************************!*\
  !*** ../node_modules/axios/lib/core/dispatchRequest.js ***!
  \*********************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 15);
var transformData = __webpack_require__(/*! ./transformData */ 236);
var isCancel = __webpack_require__(/*! ../cancel/isCancel */ 114);
var defaults = __webpack_require__(/*! ../defaults */ 115);
var isAbsoluteURL = __webpack_require__(/*! ./../helpers/isAbsoluteURL */ 243);
var combineURLs = __webpack_require__(/*! ./../helpers/combineURLs */ 244);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 236:
/*!*******************************************************!*\
  !*** ../node_modules/axios/lib/core/transformData.js ***!
  \*******************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 15);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ 237:
/*!****************************************************************!*\
  !*** ../node_modules/axios/lib/helpers/normalizeHeaderName.js ***!
  \****************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ../utils */ 15);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 238:
/*!************************************************!*\
  !*** ../node_modules/axios/lib/core/settle.js ***!
  \************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(/*! ./createError */ 117);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 239:
/*!******************************************************!*\
  !*** ../node_modules/axios/lib/core/enhanceError.js ***!
  \******************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ 240:
/*!*********************************************************!*\
  !*** ../node_modules/axios/lib/helpers/parseHeaders.js ***!
  \*********************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 15);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 241:
/*!************************************************************!*\
  !*** ../node_modules/axios/lib/helpers/isURLSameOrigin.js ***!
  \************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 15);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 242:
/*!****************************************************!*\
  !*** ../node_modules/axios/lib/helpers/cookies.js ***!
  \****************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 15);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 243:
/*!**********************************************************!*\
  !*** ../node_modules/axios/lib/helpers/isAbsoluteURL.js ***!
  \**********************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 244:
/*!********************************************************!*\
  !*** ../node_modules/axios/lib/helpers/combineURLs.js ***!
  \********************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 245:
/*!*******************************************************!*\
  !*** ../node_modules/axios/lib/cancel/CancelToken.js ***!
  \*******************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(/*! ./Cancel */ 119);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 246:
/*!***************************************************!*\
  !*** ../node_modules/axios/lib/helpers/spread.js ***!
  \***************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 25:
/*!***********************************************************!*\
  !*** ./WidgetApp/platform/navigation/navigation.const.ts ***!
  \***********************************************************/
/*! exports provided: OfferingIntent, NavigationTarget */
/*! exports used: OfferingIntent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OfferingIntent; });
/* unused harmony export NavigationTarget */
var OfferingIntent;
(function (OfferingIntent) {
    OfferingIntent["SHOW_DETAILS"] = "showDetails";
    OfferingIntent["BOOK_OFFERING"] = "bookOffering";
})(OfferingIntent || (OfferingIntent = {}));
var NavigationTarget;
(function (NavigationTarget) {
    NavigationTarget["CALENDAR"] = "calendar";
    NavigationTarget["SERVICE_PAGE"] = "servicePage";
})(NavigationTarget || (NavigationTarget = {}));


/***/ }),

/***/ 27:
/*!************************************************************!*\
  !*** ./WidgetApp/adapters/reporting/bi-logger/bi.const.ts ***!
  \************************************************************/
/*! exports provided: WidgetViewerEvents, BI_OFFERING_TYPE, WIDGET_BI_REFERRAL, BI_BOOKINGS_SRC, BI_BOOKINGS_USER_OF_USER_END_POINT, WIDGET_NAME_PHASE_1 */
/*! exports used: BI_OFFERING_TYPE, WIDGET_BI_REFERRAL, WIDGET_NAME_PHASE_1, WidgetViewerEvents */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return WidgetViewerEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BI_OFFERING_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WIDGET_BI_REFERRAL; });
/* unused harmony export BI_BOOKINGS_SRC */
/* unused harmony export BI_BOOKINGS_USER_OF_USER_END_POINT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WIDGET_NAME_PHASE_1; });
var WidgetViewerEvents = {
    WIDGET_VIEWER_CLICK: { evid: 501 },
    WIDGET_VIEWER_PAGE_LOADED: { evid: 540 },
    WIDGET_VIEWER_EXPOSURE_TEST: { evid: 666 },
    WIDGET_CANT_BOOK_GROUPS: { evid: 527 },
};
var BI_OFFERING_TYPE = {
    INDIVIDUAL: 'ind',
    GROUP: 'class',
};
var WIDGET_BI_REFERRAL = {
    WIDGET: 'widget',
    WIDGET_IMAGE: 'widget_image',
    WIDGET_TITLE: 'widget_title',
    WIDGET_DESCRIPTION: 'widget_description',
    WIDGET_BUTTON: 'widget_button',
};
var BI_BOOKINGS_SRC = 16;
var BI_BOOKINGS_USER_OF_USER_END_POINT = 'wixboost-ugc';
var WIDGET_NAME_PHASE_1 = 'widget-phase-one';


/***/ }),

/***/ 3:
/*!******************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/index.js ***!
  \******************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var base_offering_dto_builder_1 = __webpack_require__(/*! ./offerings/base-offering.dto.builder */ 35);
exports.BaseOfferingDtoBuilder = base_offering_dto_builder_1.BaseOfferingDtoBuilder;
var category_dto_builder_1 = __webpack_require__(/*! ./offerings/category.dto.builder */ 161);
exports.OfferingCategoryDtoBuilder = category_dto_builder_1.OfferingCategoryDtoBuilder;
var course_offering_dto_builder_1 = __webpack_require__(/*! ./offerings/course-offering.dto.builder */ 162);
exports.CourseOfferingDtoBuilder = course_offering_dto_builder_1.CourseOfferingDtoBuilder;
var group_offering_dto_builder_1 = __webpack_require__(/*! ./offerings/group-offering.dto.builder */ 163);
exports.GroupOfferingDtoBuilder = group_offering_dto_builder_1.GroupOfferingDtoBuilder;
var individual_offering_dto_builder_1 = __webpack_require__(/*! ./offerings/individual-offering.dto.builder */ 164);
exports.IndividualOfferingDtoBuilder = individual_offering_dto_builder_1.IndividualOfferingDtoBuilder;
var tour_offering_dto_builder_1 = __webpack_require__(/*! ./offerings/tour-offering.dto.builder */ 165);
exports.TourOfferingDtoBuilder = tour_offering_dto_builder_1.TourOfferingDtoBuilder;
var staff_dto_builder_1 = __webpack_require__(/*! ./staff/staff.dto.builder */ 166);
exports.StaffMemberListDtoBuilder = staff_dto_builder_1.StaffMemberListDtoBuilder;
exports.StaffMemberDtoBuilder = staff_dto_builder_1.StaffMemberDtoBuilder;
var offering_dto_1 = __webpack_require__(/*! ./offerings/offering.dto */ 16);
exports.OfferingType = offering_dto_1.OfferingType;
exports.OfferedAsType = offering_dto_1.OfferedAsType;
var offering_domain_1 = __webpack_require__(/*! ./offerings/offering.domain */ 167);
exports.OfferingFactory = offering_domain_1.OfferingFactory;
var price_domain_1 = __webpack_require__(/*! ./domains/price-domain */ 81);
exports.PriceDomain = price_domain_1.PriceDomain;
var duration_domain_1 = __webpack_require__(/*! ./domains/duration-domain */ 82);
exports.DurationDomain = duration_domain_1.DurationDomain;
var price_dto_factory_1 = __webpack_require__(/*! ./domains/price-dto-factory */ 89);
exports.PriceDtoFactory = price_dto_factory_1.PriceDtoFactory;
exports.PriceUtils = price_dto_factory_1.PriceUtils;
var duration_dto_factory_1 = __webpack_require__(/*! ./domains/duration-dto-factory */ 169);
exports.DurationDtoFactory = duration_dto_factory_1.DurationDtoFactory;
var date_time_1 = __webpack_require__(/*! ./constants/date-time */ 42);
exports.DateDefaultsConst = date_time_1.DateDefaultsConst;
var bookings_consts_1 = __webpack_require__(/*! ./constants/bookings.consts */ 47);
exports.BOOKINGS_APP_DEF_ID = bookings_consts_1.BOOKINGS_APP_DEF_ID;
exports.BOOKINGS_WIDGET_ID = bookings_consts_1.BOOKINGS_WIDGET_ID;
exports.BOOKINGS_OFFERING_LIST_WIDGET_ID = bookings_consts_1.BOOKINGS_OFFERING_LIST_WIDGET_ID;
exports.BOOKINGS_MAIN_PAGE_ID = bookings_consts_1.BOOKINGS_MAIN_PAGE_ID;
exports.BOOKINGS_LIST_PAGE_ID = bookings_consts_1.BOOKINGS_LIST_PAGE_ID;
exports.BOOKINGS_CHECKOUT_SECTION_ID = bookings_consts_1.BOOKINGS_CHECKOUT_SECTION_ID;
exports.BOOKINGS_SCHEDULER_SECTION_ID = bookings_consts_1.BOOKINGS_SCHEDULER_SECTION_ID;
exports.BOOKINGS_LIST_SECTION_ID = bookings_consts_1.BOOKINGS_LIST_SECTION_ID;
var offering_payment_type_1 = __webpack_require__(/*! ./entities/offering-payment/offering-payment-type */ 85);
exports.PaymentType = offering_payment_type_1.PaymentType;
var offering_payment_dto_buillder_1 = __webpack_require__(/*! ./entities/offering-payment/offering-payment.dto.buillder */ 66);
exports.OfferingPaymentDtoBuilder = offering_payment_dto_buillder_1.OfferingPaymentDtoBuilder;
var offering_location_dto_1 = __webpack_require__(/*! ./entities/offering-location/offering-location.dto */ 87);
exports.OfferingLocationType = offering_location_dto_1.OfferingLocationType;
var offering_location_dto_builder_1 = __webpack_require__(/*! ./entities/offering-location/offering-location.dto.builder */ 86);
exports.OfferingLocationDtoBuilder = offering_location_dto_builder_1.OfferingLocationDtoBuilder;
var offering_info_dto_builder_1 = __webpack_require__(/*! ./entities/offering-info/offering-info.dto.builder */ 67);
exports.ImageDtoBuilder = offering_info_dto_builder_1.ImageDtoBuilder;
exports.OfferingInfoDtoBuilder = offering_info_dto_builder_1.OfferingInfoDtoBuilder;
var offering_schedule_header_dto_1 = __webpack_require__(/*! ./entities/offering-schedule-header/offering-schedule-header.dto */ 90);
exports.WeekDay = offering_schedule_header_dto_1.WeekDay;
var offering_schedule_header_dto_builder_1 = __webpack_require__(/*! ./entities/offering-schedule-header/offering-schedule-header.dto.builder */ 170);
exports.OfferingScheduleHeaderDtoBuilder = offering_schedule_header_dto_builder_1.OfferingScheduleHeaderDtoBuilder;
var catalog_offering_dto_builder_1 = __webpack_require__(/*! ./offerings/catalog-offering.dto.builder */ 171);
exports.CatalogOfferingDtoBuilder = catalog_offering_dto_builder_1.CatalogOfferingDtoBuilder;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 30:
/*!****************************************!*\
  !*** ../node_modules/moment/moment.js ***!
  \****************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    undefined
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module 'undefined'"); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/module.js */ 59)(module)))

/***/ }),

/***/ 304:
/*!***************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/bookings-bi-defaults.js ***!
  \***************************************************************************************************/
/*! no static exports found */
/*! exports used: getWebBiLoggerDefaultsConfigForViewer */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(/*! tslib */ 2);
var bi_logger_const_1 = __webpack_require__(/*! ./bi-logger.const */ 160);
var iframe_app_bi_context_1 = __webpack_require__(/*! @wix/iframe-app-bi-context */ 159);
function getWebBiLoggerDefaultsConfigForViewer(wixSdkAdapter, widgetName) {
    var _a = prepareConfigParams(wixSdkAdapter), _b = _a.biToken, biToken = _b === void 0 ? '' : _b, _c = _a.businessId, businessId = _c === void 0 ? '' : _c, isOwner = _a.isOwner, isOverEditor = _a.isOverEditor, ownerId = _a.ownerId, _d = _a.uid, uid = _d === void 0 ? '' : _d;
    var sdkWindowJsAdapter = {
        Utils: {
            getInstanceValue: function (key) { return wixSdkAdapter.getInstanceValue(key); },
            getUid: function () { return wixSdkAdapter.getInstanceValue('uid'); },
            getViewMode: function () { return wixSdkAdapter.getViewMode(); },
            getInstanceId: function () { return wixSdkAdapter.getInstanceId(); },
            getSiteOwnerId: function () { return wixSdkAdapter.getOwnerId(); },
        },
    };
    var defaultBiParams = iframe_app_bi_context_1.getBiContext(sdkWindowJsAdapter);
    return tslib_1.__assign({ src: bi_logger_const_1.BI_BOOKINGS_SRC, widget_name: widgetName, businessId: businessId,
        biToken: biToken, is_owner: isOwner, is_over_editor: isOverEditor, visitor_id: uid, ownerId: ownerId, roles: undefined }, defaultBiParams);
}
exports.getWebBiLoggerDefaultsConfigForViewer = getWebBiLoggerDefaultsConfigForViewer;
function prepareConfigParams(wixSdkAdapter) {
    return {
        uid: wixSdkAdapter.getVisitorId(),
        biToken: wixSdkAdapter.getBiToken(),
        businessId: wixSdkAdapter.getInstanceId(),
        isOwner: wixSdkAdapter.isOwner(),
        ownerId: wixSdkAdapter.getOwnerId(),
        isOverEditor: wixSdkAdapter.isEditorMode() || wixSdkAdapter.isPreviewMode(),
    };
}
function getWebBiLoggerDefaultsConfigForEditor(wixSdkAdapter, Wix) {
    var defaultBiParams = iframe_app_bi_context_1.getBiContext(Wix);
    return tslib_1.__assign({ visitor_id: wixSdkAdapter.visitorId, src: 16, businessId: wixSdkAdapter.instanceId, is_over_editor: wixSdkAdapter.isOverEditor, is_owner: wixSdkAdapter.isOwner, biToken: wixSdkAdapter.biToken, contactId: wixSdkAdapter.contactId }, defaultBiParams);
}
exports.getWebBiLoggerDefaultsConfigForEditor = getWebBiLoggerDefaultsConfigForEditor;
//# sourceMappingURL=bookings-bi-defaults.js.map

/***/ }),

/***/ 305:
/*!**************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-adapter-ooi-wix-sdk/dist/src/WixOOISDKAdapter.js ***!
  \**************************************************************************************/
/*! no static exports found */
/*! exports used: WixOOISDKAdapter */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(/*! tslib */ 2);
var bookings_const_1 = __webpack_require__(/*! ./bookings.const */ 355);
var src_1 = __webpack_require__(/*! @wix/bookings-uou-domain/dist/src */ 3);
var WixOOISDKAdapter = /** @class */ (function () {
    function WixOOISDKAdapter(wixCodeApi, platformAPIs, appParams, compId) {
        this.wixCodeApi = wixCodeApi;
        this.platformAPIs = platformAPIs;
        this.appParams = appParams;
        this.compId = compId;
        this.sessionInstanceKey = compId + "_instance";
        this.currentLanguage = this.getCurrentLanguageFromPlatform();
    }
    WixOOISDKAdapter.prototype.isPricingPlanInstalled = function () {
        if (this.wixCodeApi.site) {
            if (this.wixCodeApi.site.isAppSectionInstalled) {
                return Promise.resolve(this.wixCodeApi.site.isAppSectionInstalled({
                    appDefinitionId: bookings_const_1.PRICING_PLAN_APP_DEF_ID,
                    sectionId: bookings_const_1.PRICING_PLAN_SECTION_ID,
                }));
            }
            //TODO: remove when wixCodeApi.site.getAppToken is added to viewerWrapper
            if (this.wixCodeApi.site.getAppToken) {
                return Promise.resolve(!!this.wixCodeApi.site.getAppToken(bookings_const_1.PRICING_PLAN_APP_DEF_ID));
            }
        }
        return this.isPricingPlanInstalledLegacyMode();
    };
    WixOOISDKAdapter.prototype.isPricingPlanInstalledLegacyMode = function () {
        return new Promise(function (resolve) {
            if (window.Wix.Utils.getViewMode() !== 'standalone') {
                window.Wix.isAppSectionInstalled(bookings_const_1.PRICING_PLAN_SECTION_ID, { appDefinitionId: bookings_const_1.PRICING_PLAN_APP_DEF_ID }, function (isInstalled) {
                    resolve(isInstalled);
                });
            }
            else {
                resolve(false);
            }
        });
    };
    WixOOISDKAdapter.prototype.isPreviewMode = function () {
        return this.getViewMode() === 'preview';
    };
    WixOOISDKAdapter.prototype.isEditorMode = function () {
        return this.getViewMode() === 'editor';
    };
    WixOOISDKAdapter.prototype.isDemoMode = function () {
        return this.getDecodedInstance().demoMode;
    };
    WixOOISDKAdapter.prototype.setContainerDimensions = function (newWidth, newHeight) {
        if (this.isRunningInIframe() && this.isEditorMode()) {
            window.Wix.resizeComponent({
                width: newWidth,
                height: newHeight,
            });
        }
    };
    WixOOISDKAdapter.prototype.setContainerHeight = function (newHeight) {
        if (this.isRunningInIframe()) {
            window.Wix.setHeight(newHeight);
        }
    };
    WixOOISDKAdapter.prototype.getExternalId = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.isRunningInIframe()) {
                window.Wix.getExternalId(function (externalId) { return resolve(externalId); });
            }
            else {
                reject('should not be called in OOI mode');
            }
        });
    };
    WixOOISDKAdapter.prototype.getViewMode = function () {
        return this.wixCodeApi.window.viewMode.toLowerCase();
    };
    WixOOISDKAdapter.prototype.getCurrentLanguage = function () {
        return this.currentLanguage;
    };
    WixOOISDKAdapter.prototype.setCurrentLanguage = function (locale) {
        this.currentLanguage = this.getCurrentLanguageFromLocale(locale);
    };
    WixOOISDKAdapter.prototype.getCurrentLanguageFromPlatform = function () {
        return this.getCurrentLanguageFromLocale(this.wixCodeApi.site.language);
    };
    WixOOISDKAdapter.prototype.getCurrentLanguageFromLocale = function (locale) {
        var localeToSubstring = locale ? locale.substring(0, 2) : undefined;
        return localeToSubstring || 'en';
    };
    WixOOISDKAdapter.prototype.isRunningInIframe = function () {
        return !(typeof WorkerGlobalScope !== 'undefined' &&
            self instanceof WorkerGlobalScope);
    };
    WixOOISDKAdapter.prototype.getVisitorId = function () {
        return this.platformAPIs.bi.visitorId;
    };
    WixOOISDKAdapter.prototype.getMetaSiteId = function () {
        return this.platformAPIs.bi.metaSiteId;
    };
    WixOOISDKAdapter.prototype.getOwnerId = function () {
        return this.platformAPIs.bi.ownerId;
    };
    WixOOISDKAdapter.prototype.getBiToken = function () {
        return this.platformAPIs.bi.biToken;
    };
    WixOOISDKAdapter.prototype.getInstanceId = function () {
        return this.appParams.instanceId;
    };
    WixOOISDKAdapter.prototype.getInstance = function () {
        return this.appParams.instance;
    };
    WixOOISDKAdapter.prototype.getAppDefId = function () {
        return this.appParams.appDefinitionId;
    };
    WixOOISDKAdapter.prototype.getStaticsBaseUrl = function () {
        return this.appParams.baseUrls && this.appParams.baseUrls.staticsBaseUrl;
    };
    WixOOISDKAdapter.prototype.getPlatformAPIs = function () {
        return this.platformAPIs;
    };
    WixOOISDKAdapter.prototype.getServiceListStaticsBaseUrl = function () {
        return (this.appParams.baseUrls &&
            this.appParams.baseUrls.serviceListStaticsBaseUrl);
    };
    WixOOISDKAdapter.prototype.getServerBaseUrl = function () {
        return this.isSSR() && this.appParams.baseUrls
            ? this.appParams.baseUrls.serverBaseUrl
            : '/';
    };
    WixOOISDKAdapter.prototype.isOwner = function () {
        return this.getOwnerId() === this.getVisitorId();
    };
    WixOOISDKAdapter.prototype.trackEvent = function (evid, payload) {
        this.wixCodeApi.window.trackEvent(evid, payload);
    };
    WixOOISDKAdapter.prototype.getSiteRevision = function () {
        return this.wixCodeApi.site.revision;
    };
    WixOOISDKAdapter.prototype.getInstanceValue = function (key) {
        var decodedInstance = this.getDecodedInstance();
        if (decodedInstance) {
            return decodedInstance[key] || null;
        }
        return null;
    };
    WixOOISDKAdapter.prototype.getDeviceType = function () {
        return this.wixCodeApi.window.formFactor;
    };
    WixOOISDKAdapter.prototype.getBookingsRelativeUrl = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isBookingCheckoutInstalled, fullBookingsUrl, baseUrl, urlParts;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isBookCheckoutInstalled()];
                    case 1:
                        isBookingCheckoutInstalled = _a.sent();
                        return [4 /*yield*/, this.wixCodeApi.site.getSectionUrl({
                                sectionId: isBookingCheckoutInstalled
                                    ? src_1.BOOKINGS_CHECKOUT_SECTION_ID
                                    : src_1.BOOKINGS_SCHEDULER_SECTION_ID,
                            })];
                    case 2:
                        fullBookingsUrl = (_a.sent()).url;
                        baseUrl = this.wixCodeApi.location.baseUrl;
                        urlParts = fullBookingsUrl.split(baseUrl);
                        return [2 /*return*/, urlParts.length > 1 ? urlParts[1] : fullBookingsUrl];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.navigateToBookingsWithSuffix = function (suffix) {
        if (suffix === void 0) { suffix = ''; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var bookingsRelativeUrl;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBookingsRelativeUrl()];
                    case 1:
                        bookingsRelativeUrl = _a.sent();
                        this.wixCodeApi.location.to(bookingsRelativeUrl + suffix);
                        return [2 /*return*/];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.isSSR = function () {
        return this.wixCodeApi.window.rendering.env === 'backend';
    };
    WixOOISDKAdapter.prototype.getCompId = function () {
        return this.compId;
    };
    WixOOISDKAdapter.prototype.isSessionInstanceSet = function () {
        return (this.platformAPIs.storage.session.getItem(this.sessionInstanceKey) ===
            this.getInstance());
    };
    WixOOISDKAdapter.prototype.setSessionInstance = function () {
        this.platformAPIs.storage.session.setItem(this.sessionInstanceKey, this.getInstance());
    };
    WixOOISDKAdapter.prototype.isViewDirectionRtl = function () {
        return bookings_const_1.RTL_LANGUAGES.indexOf(this.getCurrentLanguage()) > -1;
    };
    WixOOISDKAdapter.prototype.getScale = function () {
        var _this = this;
        return new Promise(function (resolve) {
            if (_this.isRunningInIframe()) {
                window.Wix.getBoundingRectAndOffsets(function (_a) {
                    var scale = _a.scale;
                    return resolve(scale);
                });
            }
            else {
                resolve(1);
            }
        });
    };
    WixOOISDKAdapter.prototype.getDecodedInstance = function () {
        var instance = this.getInstance();
        if (!instance) {
            return null;
        }
        var encodedInstance = instance.substring(instance.indexOf('.') + 1);
        return JSON.parse(this.decodeBase64(encodedInstance));
    };
    WixOOISDKAdapter.prototype.decodeBase64 = function (str) {
        if (typeof atob !== 'undefined') {
            return atob(str);
        }
        return '{}';
    };
    WixOOISDKAdapter.prototype.isBookCheckoutInstalled = function () {
        if (this.isRunningInIframe()) {
            return new Promise(function (resolve) {
                window.Wix.isAppSectionInstalled(src_1.BOOKINGS_CHECKOUT_SECTION_ID, { appDefinitionId: src_1.BOOKINGS_APP_DEF_ID }, function (isInstalled) {
                    resolve(isInstalled);
                });
            });
        }
        return Promise.resolve(this.wixCodeApi.site.isAppSectionInstalled({
            sectionId: src_1.BOOKINGS_CHECKOUT_SECTION_ID,
            appDefinitionId: src_1.BOOKINGS_APP_DEF_ID,
        }));
    };
    WixOOISDKAdapter.prototype.getCsrfToken = function () {
        return this.platformAPIs.getCsrfToken();
    };
    WixOOISDKAdapter.prototype.getBookingsUrlSuffix = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fullBookingsUrl, fullUrl, urlParts, bookingsSuffix;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wixCodeApi.site.getSectionUrl({
                            sectionId: src_1.BOOKINGS_LIST_SECTION_ID,
                        })];
                    case 1:
                        fullBookingsUrl = (_a.sent()).url;
                        fullUrl = this.wixCodeApi.location.url;
                        urlParts = fullUrl.split(fullBookingsUrl);
                        bookingsSuffix = urlParts.length > 1 && urlParts[1] ? urlParts[1] : '';
                        return [2 /*return*/, this.isSuffixContainOnlyQueryParam(bookingsSuffix)
                                ? ''
                                : bookingsSuffix];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.isSuffixContainOnlyQueryParam = function (urlSuffix) {
        var splittedByQueryParam = urlSuffix.split('?');
        return (splittedByQueryParam.length > 1 &&
            (!splittedByQueryParam[0] && splittedByQueryParam[1]));
    };
    return WixOOISDKAdapter;
}());
exports.WixOOISDKAdapter = WixOOISDKAdapter;
//# sourceMappingURL=WixOOISDKAdapter.js.map

/***/ }),

/***/ 306:
/*!******************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-adapters-reporting/dist/src/fedops/fedops-adapter.js ***!
  \******************************************************************************************/
/*! no static exports found */
/*! exports used: FedopsAdapter */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var fedops_logger_1 = __webpack_require__(/*! @wix/fedops-logger */ 356);
var bookings_consts_1 = __webpack_require__(/*! @wix/bookings-uou-domain/dist/src/constants/bookings.consts */ 47);
var fedops_const_1 = __webpack_require__(/*! ./fedops.const */ 378);
var FedopsAdapter = /** @class */ (function () {
    function FedopsAdapter(wixSdkAdapter, fedopsAppName, widgetId) {
        this.wixSdkAdapter = wixSdkAdapter;
        if (this.wixSdkAdapter.isRunningInIframe()) {
            this.fedopsAppName = fedopsAppName;
            this.fedopsLogger = fedops_logger_1.create(this.fedopsAppName);
        }
        else {
            var platformAPIs = wixSdkAdapter.getPlatformAPIs();
            this.fedopsLogger = platformAPIs.fedOpsLoggerFactory.getLoggerForWidget({
                appId: bookings_consts_1.BOOKINGS_APP_DEF_ID,
                widgetId: widgetId,
            });
            var isServerSide = this.wixSdkAdapter.isSSR();
            this.fedopsAppName = "" + fedopsAppName + fedops_const_1.FEDOPS_APP_NAME_OOI_SUFFIX + (isServerSide ? fedops_const_1.FEDOPS_APP_NAME_SSR_SUFFIX : '');
            this.oldFedopsLogger = fedops_logger_1.create(this.fedopsAppName, {
                isWidgetLogger: true,
                isServerSide: isServerSide,
                appId: bookings_consts_1.BOOKINGS_APP_DEF_ID,
                widgetId: widgetId,
            });
            this.logAppLoadedStarted();
        }
    }
    FedopsAdapter.prototype.logAppLoadedStarted = function () {
        this.fedopsLogger.appLoadStarted();
        this.oldFedopsLogger && this.oldFedopsLogger.appLoadStarted();
    };
    FedopsAdapter.prototype.logAppLoaded = function () {
        this.fedopsLogger.appLoaded();
        this.oldFedopsLogger && this.oldFedopsLogger.appLoaded();
    };
    return FedopsAdapter;
}());
exports.FedopsAdapter = FedopsAdapter;
//# sourceMappingURL=fedops-adapter.js.map

/***/ }),

/***/ 31:
/*!***********************************************!*\
  !*** ./Shared/appKeys/mobileToDesktopKeys.ts ***!
  \***********************************************/
/*! exports provided: MAX_MOBILE_CARD_SPACING, MAX_MOBILE_BORDER_WIDTH, mergeDesktopDefaultsIntoMobile, mergeMobileDefaultsIntoDesktop, mergeMobileSettingsIntoDesktop */
/*! exports used: MAX_MOBILE_BORDER_WIDTH, MAX_MOBILE_CARD_SPACING, mergeDesktopDefaultsIntoMobile, mergeMobileDefaultsIntoDesktop, mergeMobileSettingsIntoDesktop */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_MOBILE_CARD_SPACING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_MOBILE_BORDER_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mergeDesktopDefaultsIntoMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mergeMobileDefaultsIntoDesktop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return mergeMobileSettingsIntoDesktop; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ 2);
/* harmony import */ var _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./SettingsKeys */ 1);
//define the mobile setting keys that should use the desktop if not defined

var _a, _b;

var MAX_MOBILE_CARD_SPACING = 60;
var MAX_MOBILE_BORDER_WIDTH = 5;
var desktopSettingsDefaultsToMobileMap = (_a = {},
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].CARDS_SPACING] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_CARDS_SPACING,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].TEXT_ALIGNMENT] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_TEXT_ALIGNMENT,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_IMAGE] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DISPLAY_IMAGE,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_TAG_LINE] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DISPLAY_TAG_LINE,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_DIVIDER] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DISPLAY_DIVIDER,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_PRICE] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DISPLAY_PRICE,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_DURATION] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DISPLAY_DURATION,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DIVIDER_WIDTH] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DIVIDER_WIDTH,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].BORDER_WIDTH] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_BORDER_WIDTH,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_START_DATE] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DISPLAY_START_DATE,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_DAYS_OFFERED] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DISPLAY_DAYS_OFFERED,
    _a[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_BUTTON] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DISPLAY_BUTTON,
    _a);
var mobileSettingsDefaultsToDesktopKeysMap = (_b = {},
    _b[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_CARDS_SPACING] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].CARDS_SPACING,
    _b[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_IMAGE_SHAPE_OPTION] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].IMAGE_SHAPE_OPTION,
    _b[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_TEXT_ALIGNMENT] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].TEXT_ALIGNMENT,
    _b[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DISPLAY_IMAGE] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_IMAGE,
    _b[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DISPLAY_TAG_LINE] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_TAG_LINE,
    _b[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DISPLAY_DIVIDER] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_DIVIDER,
    _b[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DISPLAY_PRICE] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_PRICE,
    _b[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DISPLAY_DURATION] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_DURATION,
    _b[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DISPLAY_START_DATE] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_START_DATE,
    _b[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DISPLAY_DAYS_OFFERED] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_DAYS_OFFERED,
    _b[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DISPLAY_BUTTON] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DISPLAY_BUTTON,
    _b[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DIVIDER_WIDTH] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DIVIDER_WIDTH,
    _b[_SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_BORDER_WIDTH] = _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].BORDER_WIDTH,
    _b);
var mobileSettingsToDesktopKeysMap = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, mobileSettingsDefaultsToDesktopKeysMap);
function mergeSettingsKeys(data, keysMap, forceMerge) {
    if (forceMerge === void 0) { forceMerge = false; }
    var res = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, data);
    Object.keys(keysMap).forEach(function (sourceKey) {
        var targetKey = keysMap[sourceKey];
        var decoratedValue = decoratorMappings(sourceKey, targetKey, res[sourceKey]);
        if (typeof res[sourceKey] !== 'undefined' &&
            (forceMerge || typeof res[targetKey] === 'undefined')) {
            res[targetKey] = decoratedValue;
        }
        else if (res[targetKey]) {
            res[targetKey] = decoratorMappings(sourceKey, targetKey, res[targetKey]);
        }
    });
    return res;
}
var decoratorMappings = function (sourceKey, targetKey, value) {
    switch (sourceKey + " -> " + targetKey) {
        case _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DIVIDER_WIDTH + " -> " + _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DIVIDER_WIDTH:
        case _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_DIVIDER_WIDTH + " -> " + _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].DIVIDER_WIDTH:
        case _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].BORDER_WIDTH + " -> " + _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_BORDER_WIDTH:
        case _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_BORDER_WIDTH + " -> " + _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].BORDER_WIDTH:
            return value ? Math.min(value, MAX_MOBILE_CARD_SPACING) : value;
        case _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].CARDS_SPACING + " -> " + _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_CARDS_SPACING:
        case _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* MobileSettingsKeys */ "i"].MOBILE_CARDS_SPACING + " -> " + _SettingsKeys__WEBPACK_IMPORTED_MODULE_1__[/* SettingsKeys */ "l"].CARDS_SPACING:
            return value ? Math.min(value, MAX_MOBILE_CARD_SPACING) : value;
        default:
            return value;
    }
};
var mergeDesktopDefaultsIntoMobile = function (settingsData) {
    return mergeSettingsKeys(settingsData, desktopSettingsDefaultsToMobileMap, false);
};
var mergeMobileDefaultsIntoDesktop = function (settingsData) {
    return mergeSettingsKeys(settingsData, mobileSettingsDefaultsToDesktopKeysMap, true);
};
var mergeMobileSettingsIntoDesktop = function (settingsData) {
    return mergeSettingsKeys(settingsData, mobileSettingsToDesktopKeysMap, true);
};


/***/ }),

/***/ 32:
/*!*************************!*\
  !*** ./Shared/utils.ts ***!
  \*************************/
/*! exports provided: getPresetId, getSiteTextPresets, getSiteColors, getStyleParams, getCurrentStyles, isMobileFromFormFactor */
/*! exports used: getCurrentStyles, getPresetId, getSiteColors, getSiteTextPresets, getStyleParams, isMobileFromFormFactor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPresetId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSiteTextPresets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSiteColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getStyleParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isMobileFromFormFactor; });
/* harmony import */ var _WidgetApp_constants_environment_const__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../WidgetApp/constants/environment.const */ 56);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash */ 4);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);


var getPresetId = function () {
    return new Promise(function (resolve) {
        window.Wix.Data.Public.get('presetId', { scope: 'COMPONENT' }, function (data) { return resolve(data); }, function () { return resolve(); });
    });
};
var getSiteTextPresets = function () {
    return new Promise(function (resolve) {
        window.Wix.Styles.getSiteTextPresets(resolve, resolve);
    });
};
var getSiteColors = function () {
    return new Promise(function (resolve) {
        window.Wix.Styles.getSiteColors(resolve, resolve);
    });
};
var getStyleParams = function () {
    return new Promise(function (resolve) {
        window.Wix.Styles.getStyleParams(resolve, resolve);
    });
};
var getCurrentStyles = function () {
    return Promise.all([getSiteColors(), getSiteTextPresets(), getStyleParams()]);
};
var isMobileFromFormFactor = function (props) {
    return lodash__WEBPACK_IMPORTED_MODULE_1__["get"](props, 'host.formFactor', _WidgetApp_constants_environment_const__WEBPACK_IMPORTED_MODULE_0__[/* FormFactor */ "a"].DESKTOP) === _WidgetApp_constants_environment_const__WEBPACK_IMPORTED_MODULE_0__[/* FormFactor */ "a"].MOBILE;
};


/***/ }),

/***/ 326:
/*!***************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/web-logger/WebLogger.js ***!
  \***************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var web_bi_logger_1 = __webpack_require__(/*! @wix/web-bi-logger */ 205);
var bookings_bi_defaults_1 = __webpack_require__(/*! ./bookings-bi-defaults */ 327);
var bookings_adapter_wix_sdk_1 = __webpack_require__(/*! @wix/bookings-adapter-wix-sdk */ 338);
var WebLogger = /** @class */ (function () {
    function WebLogger(_a) {
        var _b = _a.biLoggerDefaults, biLoggerDefaults = _b === void 0 ? null : _b, biLoggerEndPoint = _a.biLoggerEndPoint, _c = _a.Wix, Wix = _c === void 0 ? null : _c;
        if (!biLoggerDefaults && !Wix) {
            throw new Error('must provide biLoggerDefaults or Wix');
        }
        var biLoggerDefaultConfigurations = biLoggerDefaults ||
            new bookings_bi_defaults_1.BookingsBIDefaults(new bookings_adapter_wix_sdk_1.WixSDKAdapter(Wix), Wix).getDefaults();
        this.logger = web_bi_logger_1.default
            .factory({ endpoint: biLoggerEndPoint })
            .setDefaults(biLoggerDefaultConfigurations)
            .logger();
    }
    WebLogger.prototype.log = function (data) {
        return this.logger.log(data);
    };
    return WebLogger;
}());
exports.WebLogger = WebLogger;
//# sourceMappingURL=WebLogger.js.map

/***/ }),

/***/ 327:
/*!**************************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/web-logger/bookings-bi-defaults.js ***!
  \**************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(/*! tslib */ 2);
var iframe_app_bi_context_1 = __webpack_require__(/*! @wix/iframe-app-bi-context */ 159);
var BookingsBIDefaults = /** @class */ (function () {
    function BookingsBIDefaults(wixSKDBookingsAdapter, Wix) {
        this.wixSKDBookingsAdapter = wixSKDBookingsAdapter;
        this.biContext = iframe_app_bi_context_1.getBiContext(Wix);
    }
    BookingsBIDefaults.prototype.getDefaults = function () {
        return tslib_1.__assign({ src: 16, businessId: this.wixSKDBookingsAdapter.instanceId, is_over_editor: this.wixSKDBookingsAdapter.isOverEditor, is_owner: this.wixSKDBookingsAdapter.isOwner, biToken: this.wixSKDBookingsAdapter.biToken, contactId: this.wixSKDBookingsAdapter.contactId }, this.biContext);
    };
    return BookingsBIDefaults;
}());
exports.BookingsBIDefaults = BookingsBIDefaults;
//# sourceMappingURL=bookings-bi-defaults.js.map

/***/ }),

/***/ 328:
/*!**************************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/platform-logger/platform-logger.js ***!
  \**************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PlatformLogger = /** @class */ (function () {
    function PlatformLogger(_a) {
        var platformAPIs = _a.platformAPIs, biLoggerDefaultConfigurations = _a.biLoggerDefaultConfigurations, biLoggerEndPoint = _a.biLoggerEndPoint;
        this.logger = platformAPIs
            .biLoggerFactory()
            .updateDefaults(biLoggerDefaultConfigurations)
            .logger({
            endpoint: biLoggerEndPoint,
        });
    }
    PlatformLogger.prototype.log = function (data) {
        return this.logger.log(data);
    };
    return PlatformLogger;
}());
exports.PlatformLogger = PlatformLogger;
//# sourceMappingURL=platform-logger.js.map

/***/ }),

/***/ 329:
/*!***************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/ssr-logger/SSRLogger.js ***!
  \***************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(/*! tslib */ 2);
var SSRLogger = /** @class */ (function () {
    function SSRLogger() {
    }
    SSRLogger.prototype.log = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    return SSRLogger;
}());
exports.SSRLogger = SSRLogger;
//# sourceMappingURL=SSRLogger.js.map

/***/ }),

/***/ 338:
/*!**************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-adapter-wix-sdk/dist/es/src/index.js + 5 modules ***!
  \**************************************************************************************/
/*! exports provided: WixSDKAdapter, DeepLink, WixMock, wixSDKDemoValues, WixSDKFakeAdapter */
/*! all exports used */
/*! ModuleConcatenation bailout: Cannot concat with ../node_modules/tslib/tslib.es6.js (<- Module is referenced from these modules with unsupported syntax: ../node_modules/@wix/bookings-adapter-ooi-wix-sdk/dist/src/WixOOISDKAdapter.js (referenced with cjs require), ../node_modules/@wix/bookings-adapter-wix-sdk/dist/src/WixMock.js (referenced with cjs require), ../node_modules/@wix/bookings-adapter-wix-sdk/dist/src/WixSDKAdapter.js (referenced with cjs require), ../node_modules/@wix/bookings-adapter-wix-sdk/dist/src/WixSDKFakeAdapter.js (referenced with cjs require), ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/bookings-bi-defaults.js (referenced with cjs require), ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/ssr-logger/SSRLogger.js (referenced with cjs require), ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/web-logger/bookings-bi-defaults.js (referenced with cjs require), ../node_modules/@wix/bookings-viewer-ui/dist/src/assets/icons/dist/components/CloseIcon.js (referenced with cjs require), ../node_modules/@wix/bookings-viewer-ui/dist/src/components/Modal/TpaModal.js (referenced with cjs require), ../node_modules/@wix/bookings-viewer-ui/dist/src/components/UserMessage/UserMessage.js (referenced with cjs require), ../node_modules/@wix/js-sdk-wrapper/dist/src/create-wix-sdk-wrapper.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/button-next/button-next.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/checkbox/Checkbox.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/deprecated/button/Button.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/input/Input.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/popover/Popover.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/popover/index.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/popover/modifiers.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/toggle-switch/ToggleSwitch.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/tooltip/Tooltip.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/tooltip/index.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/hocs/Focusable/FocusableHOC.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/utils/withStylable/withStylable.js (referenced with cjs require)) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// CONCATENATED MODULE: ../node_modules/@wix/bookings-adapter-wix-sdk/dist/es/src/WixSDKAdapter.js

var refreshWindow = function () { return window.location.reload(); };
var WixSDKAdapter_WixSDKAdapter = /** @class */ (function () {
    function WixSDKAdapter(Wix) {
        this.Wix = Wix;
        this.setColor = this.setColor.bind(this);
        this.setFont = this.setFont.bind(this);
    }
    WixSDKAdapter.prototype.openBackOfficeFrom = function (deepLink) {
        return tslib_es6["__awaiter"](this, void 0, void 0, function () {
            return tslib_es6["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.forceSaveSite()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.Wix.Settings.openDashboard({
                                onClose: function () {
                                    refreshWindow();
                                },
                                state: deepLink,
                            })];
                }
            });
        });
    };
    WixSDKAdapter.prototype.isAppSectionInstalled = function (sectionId, options, cb) {
        return this.Wix.isAppSectionInstalled(sectionId, options, cb);
    };
    WixSDKAdapter.prototype.refreshApp = function (event) {
        return this.Wix.Settings.triggerSettingsUpdatedEvent(event, this.Wix.Utils.getOrigCompId());
    };
    WixSDKAdapter.prototype.forceSaveSite = function () {
        var _this = this;
        var didSiteUnsaved = function (siteInfo) { return siteInfo.baseUrl === ''; };
        return new Promise(function (resolve) {
            _this.Wix.Settings.getSiteInfo(function (siteInfo) {
                if (didSiteUnsaved(siteInfo)) {
                    _this.Wix.Settings.getDashboardAppUrl(function () {
                        _this.refreshApp('scheduler-owner-update');
                        refreshWindow();
                    });
                }
                else {
                    resolve();
                }
            });
        });
    };
    WixSDKAdapter.prototype.navigate = function (sectionId) {
        this.Wix.Utils.navigateToSection({ sectionId: sectionId }, function () {
            return console.error('cant navigate to book checkout');
        });
    };
    WixSDKAdapter.prototype.closeSettingsPanel = function () {
        this.Wix.Settings.closeWindow({ target: 'ALL' });
    };
    WixSDKAdapter.prototype.openPackagePicker = function (referrer) {
        (this.Wix.SuperApps || this.Wix).Settings.openBillingPage(referrer);
    };
    WixSDKAdapter.prototype.isPremium = function () {
        var _this = this;
        return !!this.getSafeValue(function () {
            return _this.Wix.Utils.getInstanceValue('vendorProductId');
        });
    };
    Object.defineProperty(WixSDKAdapter.prototype, "instanceId", {
        get: function () {
            return this.getSafeValue(this.Wix.Utils.getInstanceId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WixSDKAdapter.prototype, "isOverEditor", {
        get: function () {
            return this.getSafeValue(this.Wix.Utils.isOverEditor);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WixSDKAdapter.prototype, "isOwner", {
        get: function () {
            var permissions = this.getSafeValue(this.Wix.Utils.getPermissions);
            return permissions === 'OWNER';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WixSDKAdapter.prototype, "biToken", {
        get: function () {
            var _this = this;
            return this.getSafeValue(function () { return _this.Wix.Utils.getInstanceValue('biToken'); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WixSDKAdapter.prototype, "contactId", {
        get: function () {
            return this.getSafeValue(this.Wix.Utils.getUid);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WixSDKAdapter.prototype, "visitorId", {
        get: function () {
            var uid = this.Wix.Utils.getInstanceValue('uid');
            if (uid === null) {
                return this.Wix.Utils.getInstanceValue('aid');
            }
            return uid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WixSDKAdapter.prototype, "siteColors", {
        get: function () {
            return new Promise(this.Wix.Styles.getSiteColors);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WixSDKAdapter.prototype, "siteTextPresets", {
        get: function () {
            return new Promise(this.Wix.Styles.getSiteTextPresets);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WixSDKAdapter.prototype, "styleParams", {
        get: function () {
            return new Promise(this.Wix.Styles.getStyleParams);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WixSDKAdapter.prototype, "isFullWidth", {
        get: function () {
            var _this = this;
            return new Promise(function (resolve) { return _this.Wix.Settings.isFullWidth(resolve); });
        },
        enumerable: true,
        configurable: true
    });
    WixSDKAdapter.prototype.setColor = function (key, value) {
        var _this = this;
        return new Promise(function (resolve) {
            return _this.Wix.Styles.setColorParam(key, { value: value }, resolve);
        });
    };
    WixSDKAdapter.prototype.setFont = function (key, value) {
        var _this = this;
        return new Promise(function (resolve) {
            return _this.Wix.Styles.setFontParam(key, { value: value }, resolve);
        });
    };
    WixSDKAdapter.prototype.getSafeValue = function (invokable) {
        try {
            return invokable();
        }
        catch (e) {
            return '';
        }
    };
    WixSDKAdapter.prototype.setHelpArticleId = function (articleId) {
        return this.Wix.Settings.setHelpArticle(articleId);
    };
    WixSDKAdapter.prototype.getDeviceType = function () {
        return this.Wix.Utils.getDeviceType();
    };
    return WixSDKAdapter;
}());

//# sourceMappingURL=WixSDKAdapter.js.map
// CONCATENATED MODULE: ../node_modules/@wix/bookings-adapter-wix-sdk/dist/es/src/DeepLink.js
var DeepLink;
(function (DeepLink) {
    DeepLink["BOOKINGS_OFFERINGS"] = "scheduler/owner/offerings";
    DeepLink["BOOKINGS_FORM"] = "scheduler/owner/bookings-form-settings";
    DeepLink["BOOKINGS_INDIVIDUAL_FORM"] = "scheduler/owner/offerings-form/new/INDIVIDUAL";
    DeepLink["BOOKINGS_GROUP_FORM"] = "scheduler/owner/offerings-form/new/GROUP";
    DeepLink["BOOKINGS_WIZARD"] = "scheduler/owner/offerings/wizard";
})(DeepLink || (DeepLink = {}));
//# sourceMappingURL=DeepLink.js.map
// CONCATENATED MODULE: ../node_modules/@wix/bookings-adapter-wix-sdk/dist/es/src/WixMock.js

var getCurrentDeviceType = function () { return "desktop" /* DESKTOP */; };
var getCurrentDimensions = function () {
    return getCurrentDeviceType() === "mobile" /* MOBILE */
        ? {
            width: 280,
            height: 500,
        }
        : {
            width: 700,
            height: 400,
        };
};
var WixMock_WixMock = /** @class */ (function () {
    function WixMock(fakeTpaResponse, deviceType, dimensions, windowAdapter) {
        if (fakeTpaResponse === void 0) { fakeTpaResponse = null; }
        if (deviceType === void 0) { deviceType = getCurrentDeviceType(); }
        if (dimensions === void 0) { dimensions = getCurrentDimensions(); }
        if (windowAdapter === void 0) { windowAdapter = window; }
        var _this = this;
        this.deviceType = deviceType;
        this.dimensions = dimensions;
        this.windowAdapter = windowAdapter;
        this.getInstance = function () {
            return _this.instanceValue;
        };
        this.getBoundingRectAndOffsets = function (callback) {
            var _a = _this.dimensions, width = _a.width, height = _a.height;
            callback({
                rect: {
                    width: width,
                    height: height,
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                },
                offsets: {
                    x: 0,
                    y: 0,
                },
                scale: 1,
            });
        };
        this.Utils = {
            isOverEditor: function () {
                return false;
            },
            getPermissions: function () {
                return '';
            },
            getInstance: function () {
                return _this.instanceValue;
            },
            getInstanceValue: function (key) {
                return _this.instanceValue[key];
            },
            getInstanceId: function () {
                return 'id-of-buissnes';
            },
            Media: {
                getResizedImageUrl: function (uri, width, height) {
                    return '';
                },
            },
            getViewMode: function () {
                return 'standalone';
            },
            navigateToSection: function (_a, cb) {
                var _b = _a.sectionId, sectionId = _b === void 0 ? null : _b;
                if (cb === void 0) { cb = function () { return null; }; }
                return null;
            },
            getOrigCompId: function () {
                return '123';
            },
            getCompId: function () {
                return 'comp-jnybzzmo';
            },
            getSiteOwnerId: function () {
                return '';
            },
            getUid: function () {
                return '';
            },
            getDemoMode: function () {
                return true;
            },
            getLocale: function () {
                return 'en';
            },
            getDeviceType: function () {
                return _this.deviceType;
            },
        };
        this.Performance = {
            applicationLoaded: function () { return null; },
        };
        this.Settings = {
            getSiteBaseUrl: function () {
                return 'https://same.site.url';
            },
            getSiteInfo: function (func) {
                func({ baseUrl: 'https://site.url.com' });
            },
            triggerSettingsUpdatedEvent: function (msg, compId) {
                return null;
            },
            setHelpArticle: function (articleId) {
                return null;
            },
            isFullWidth: function (callback) {
                callback(true);
            },
            closeWindow: function (args) {
                return null;
            },
        };
        this.Styles = {
            getSiteColors: function (cb) {
                cb(_this.siteColors);
            },
            getSiteTextPresets: function (cb) {
                cb(_this.siteTextPresets);
            },
            getStyleParams: function (cb) {
                cb(_this.styleParams);
            },
            getStyleId: function (cb) {
                cb('style-jp8ide5x');
            },
            getEditorFonts: function (cb) {
                // cb(fakeTpaResponse.res.fonts);
            },
            setFontParam: function (name) {
                return null;
            },
            openFontPicker: function (name) {
                return null;
            },
            openColorPicker: function (name) {
                return null;
            },
            setColorParam: function (name) {
                return null;
            },
            setNumberParam: function (key, value) {
                return null;
            },
            setUILIBParamValue: function (name) {
                return null;
            },
        };
        this.Events = {
            PUBLIC_DATA_CHANGED: 'PUBLIC_DATA_CHANGED',
        };
        this.addEventListener = function (eventName, cb) {
            _this.queue.push(cb);
        };
        this.Data = {
            Public: {
                get: function (key, scope, success, failure) {
                    if (success === void 0) { success = null; }
                    if (failure === void 0) { failure = null; }
                    var _a;
                    if (success) {
                        success((_a = {}, _a[key] = _this.publicData[key], _a));
                    }
                    else if (failure) {
                        failure();
                    }
                },
                set: function (key, value, scope, success, failure) {
                    if (success === void 0) { success = null; }
                    if (failure === void 0) { failure = null; }
                    _this.publicData[key] = value;
                    if (success) {
                        success();
                    }
                    else if (failure) {
                        failure();
                    }
                },
                getAll: function (success, failure) {
                    if (success === void 0) { success = null; }
                    if (failure === void 0) { failure = null; }
                    if (success) {
                        success({ COMPONENT: _this.publicData });
                    }
                    else if (failure) {
                        failure();
                    }
                },
            },
        };
        this.PubSub = {
            publish: function (key, data, isTo) {
                return null;
            },
        };
        this.Activities = {};
        this.Analytics = {};
        this.Billing = {};
        this.Dashboard = {};
        this.Features = {};
        this.Media = {};
        this.Preview = {};
        this.publicData = {};
        this.instanceValue =
            'fjedznBGpRyC4DtPPLy-PcWfOCfMsqgsNVqQw-DDqeY.eyJpbnN0YW5jZUlkIjoiODUxMTY1NGEtNmM1Yi00ODhlLTg1ZmItZTIzZmI4MDZiNWU5IiwiYXBwRGVmSWQiOiIxM2QyMWM2My1iNWVjLTU5MTItODM5Ny1jM2E1ZGRiMjdhOTciLCJtZXRhU2l0ZUlkIjoiNWRlZGI3ZDAtYzBmNi00OGFhLTg3M2YtNGUyMjg2MTc4ZGVmIiwic2lnbkRhdGUiOiIyMDE5LTAxLTAyVDEwOjE5OjU1LjIxOVoiLCJ1aWQiOm51bGwsImlwQW5kUG9ydCI6IjkxLjE5OS4xMTkuMjU0LzQwMDc0IiwidmVuZG9yUHJvZHVjdElkIjoiV2l4Qm9va2luZ3NVbmxpbWl0ZWQiLCJkZW1vTW9kZSI6ZmFsc2UsImFpZCI6ImU3N2IzYmYwLWQ4MzAtNDdkMy04YTUzLTE2NjFiNWM5NTgyYiIsImJpVG9rZW4iOiJkOGZjZDI5YS1hY2FkLTAwMjQtMDJjNC1hYzFkM2UxMTM4MDYiLCJzaXRlT3duZXJJZCI6IjRlNjYzNmQzLTE3OTMtNGQ0Yi05ZDk0LTBkNDY0MjJiZmVhYSJ9';
        this.siteColors = fakeTpaResponse ? fakeTpaResponse.res.siteColors : [];
        this.siteTextPresets = fakeTpaResponse
            ? fakeTpaResponse.res.siteTextPresets
            : {};
        this.styleParams = fakeTpaResponse
            ? fakeTpaResponse.res.style
            : { numbers: {} };
        if (windowAdapter.Wix &&
            windowAdapter.Wix.Utils.getViewMode() === 'standalone') {
            windowAdapter.Wix.Utils.getViewMode = function () { return 'site'; };
            if (fakeTpaResponse) {
                windowAdapter.postMessage(JSON.stringify(fakeTpaResponse), '*');
            }
        }
        this.queue = [];
    }
    WixMock.prototype.getDashboardBaseUrl = function () {
        return 'htts://wix.com/biz-mgr/234234-3434/';
    };
    WixMock.prototype.getComponentInfo = function () {
        return 'componentInfo';
    };
    WixMock.prototype.getCurrentPageId = function (callback) {
        callback({});
    };
    WixMock.prototype.pushState = function () {
        //
    };
    WixMock.prototype.replaceSectionState = function () {
        //
    };
    WixMock.prototype.resizeComponent = function () {
        //
    };
    WixMock.prototype.openPackagePicker = function (referrer) {
        //
    };
    WixMock.prototype.openBackOfficeFrom = function (deepLink) {
        return tslib_es6["__awaiter"](this, void 0, void 0, function () {
            return tslib_es6["__generator"](this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    WixMock.prototype.isPremium = function () {
        return true;
    };
    WixMock.prototype.isAppSectionInstalled = function (sectionId, options, cb) {
        cb(sectionId === 'bookings_member_area' || sectionId === 'book_checkout');
    };
    WixMock.prototype.getSiteInfo = function (callback) {
        callback({
            pageTitle: 'Local Server',
            pageTitleOnly: 'Home',
            referer: '',
            siteDescription: 'Local server',
            siteKeywords: 'Good things happen when everything connects',
            url: this.windowAdapter.location.href,
            baseUrl: this.windowAdapter.location.href,
        });
    };
    WixMock.prototype.setHeight = function () {
        return null;
    };
    WixMock.prototype.getExternalId = function (callback) {
        callback(null);
    };
    return WixMock;
}());

//# sourceMappingURL=WixMock.js.map
// CONCATENATED MODULE: ../node_modules/@wix/bookings-adapter-wix-sdk/dist/es/src/WixSDKMockValues.js
var wixSDKDemoValues = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.instanceId, instanceId = _c === void 0 ? '' : _c, _d = _b.isOverEditor, isOverEditor = _d === void 0 ? true : _d, _e = _b.isOwner, isOwner = _e === void 0 ? true : _e, _f = _b.biToken, biToken = _f === void 0 ? '' : _f, _g = _b.contactId, contactId = _g === void 0 ? '' : _g, _h = _b.visitorId, visitorId = _h === void 0 ? '' : _h, _j = _b.isFullWidth, isFullWidth = _j === void 0 ? true : _j;
    return ({
        Utils: {
            getInstanceId: function () {
                return instanceId;
            },
            isOverEditor: function () {
                return isOverEditor;
            },
            getPermissions: function () {
                return isOwner ? 'OWNER' : '';
            },
            getInstanceValue: function (key) {
                var map = { biToken: biToken, uid: visitorId };
                return map[key];
            },
            getUid: function () {
                return contactId;
            },
        },
        Settings: {
            isFullWidth: function () {
                return isFullWidth;
            },
        },
    });
};
//# sourceMappingURL=WixSDKMockValues.js.map
// CONCATENATED MODULE: ../node_modules/@wix/bookings-adapter-wix-sdk/dist/es/src/WixSDKFakeAdapter.js

var WixSDKFakeAdapter_getCurrentDeviceType = function () { return "desktop" /* DESKTOP */; };
var WixSDKFakeAdapter_getCurrentDimensions = function () {
    return WixSDKFakeAdapter_getCurrentDeviceType() === "mobile" /* MOBILE */
        ? {
            width: 280,
            height: 500,
        }
        : {
            width: 700,
            height: 400,
        };
};
var WixSDKFakeAdapter_WixSDKFakeAdapter = /** @class */ (function () {
    function WixSDKFakeAdapter(fakeTpaResponse, deviceType, dimensions) {
        if (fakeTpaResponse === void 0) { fakeTpaResponse = null; }
        if (deviceType === void 0) { deviceType = WixSDKFakeAdapter_getCurrentDeviceType(); }
        if (dimensions === void 0) { dimensions = WixSDKFakeAdapter_getCurrentDimensions(); }
        var _this = this;
        this.deviceType = deviceType;
        this.dimensions = dimensions;
        this.getInstance = function () {
            return '11111111';
        };
        this.getBoundingRectAndOffsets = function (callback) {
            var _a = _this.dimensions, width = _a.width, height = _a.height;
            callback({
                rect: {
                    width: width,
                    height: height,
                    top: 0,
                    left: 0,
                },
            });
        };
        this.addEventListener = function (eventName, cb) {
            _this.queue.push(cb);
        };
        this.publicData = {};
        this.instanceValue =
            'fjedznBGpRyC4DtPPLy-PcWfOCfMsqgsNVqQw-DDqeY.eyJpbnN0YW5jZUlkIjoiODUxMTY1NGEtNmM1Yi00ODhlLTg1ZmItZTIzZmI4MDZiNWU5IiwiYXBwRGVmSWQiOiIxM2QyMWM2My1iNWVjLTU5MTItODM5Ny1jM2E1ZGRiMjdhOTciLCJtZXRhU2l0ZUlkIjoiNWRlZGI3ZDAtYzBmNi00OGFhLTg3M2YtNGUyMjg2MTc4ZGVmIiwic2lnbkRhdGUiOiIyMDE5LTAxLTAyVDEwOjE5OjU1LjIxOVoiLCJ1aWQiOm51bGwsImlwQW5kUG9ydCI6IjkxLjE5OS4xMTkuMjU0LzQwMDc0IiwidmVuZG9yUHJvZHVjdElkIjoiV2l4Qm9va2luZ3NVbmxpbWl0ZWQiLCJkZW1vTW9kZSI6ZmFsc2UsImFpZCI6ImU3N2IzYmYwLWQ4MzAtNDdkMy04YTUzLTE2NjFiNWM5NTgyYiIsImJpVG9rZW4iOiJkOGZjZDI5YS1hY2FkLTAwMjQtMDJjNC1hYzFkM2UxMTM4MDYiLCJzaXRlT3duZXJJZCI6IjRlNjYzNmQzLTE3OTMtNGQ0Yi05ZDk0LTBkNDY0MjJiZmVhYSJ9';
        this.siteColors = fakeTpaResponse ? fakeTpaResponse.res.siteColors : [];
        this.siteTextPresets = fakeTpaResponse
            ? fakeTpaResponse.res.siteTextPresets
            : {};
        this.styleParams = fakeTpaResponse
            ? fakeTpaResponse.res.style
            : { numbers: {} };
        this.queue = [];
    }
    WixSDKFakeAdapter.prototype.refreshApp = function (event) {
        //
    };
    WixSDKFakeAdapter.prototype.forceSaveSite = function () {
        return tslib_es6["__awaiter"](this, void 0, void 0, function () {
            return tslib_es6["__generator"](this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(WixSDKFakeAdapter.prototype, "instanceId", {
        get: function () {
            return 'instanceId';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WixSDKFakeAdapter.prototype, "isOverEditor", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WixSDKFakeAdapter.prototype, "isOwner", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WixSDKFakeAdapter.prototype, "biToken", {
        get: function () {
            return 'biToken';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WixSDKFakeAdapter.prototype, "contactId", {
        get: function () {
            return 'contactId';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WixSDKFakeAdapter.prototype, "visitorId", {
        get: function () {
            return 'visitorId';
        },
        enumerable: true,
        configurable: true
    });
    WixSDKFakeAdapter.prototype.setColor = function (key, value) {
        return tslib_es6["__awaiter"](this, void 0, void 0, function () {
            return tslib_es6["__generator"](this, function (_a) {
                return [2 /*return*/, 'setColor Done'];
            });
        });
    };
    WixSDKFakeAdapter.prototype.setFont = function (key, value) {
        return tslib_es6["__awaiter"](this, void 0, void 0, function () {
            return tslib_es6["__generator"](this, function (_a) {
                return [2 /*return*/, 'setFont Done'];
            });
        });
    };
    WixSDKFakeAdapter.prototype.getDashboardBaseUrl = function () {
        return 'htts://wix.com/biz-mgr/234234-3434/';
    };
    WixSDKFakeAdapter.prototype.getComponentInfo = function () {
        return 'componentInfo';
    };
    WixSDKFakeAdapter.prototype.getCurrentPageId = function (callback) {
        callback({});
    };
    WixSDKFakeAdapter.prototype.pushState = function () {
        //
    };
    WixSDKFakeAdapter.prototype.replaceSectionState = function () {
        //
    };
    WixSDKFakeAdapter.prototype.resizeComponent = function () {
        //
    };
    WixSDKFakeAdapter.prototype.openPackagePicker = function (referrer) {
        //
    };
    WixSDKFakeAdapter.prototype.openBackOfficeFrom = function (deepLink) {
        return tslib_es6["__awaiter"](this, void 0, void 0, function () {
            return tslib_es6["__generator"](this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    WixSDKFakeAdapter.prototype.isPremium = function () {
        return true;
    };
    Object.defineProperty(WixSDKFakeAdapter.prototype, "isFullWidth", {
        get: function () {
            return new Promise(function (resolve) { return resolve(true); });
        },
        enumerable: true,
        configurable: true
    });
    WixSDKFakeAdapter.prototype.navigate = function (sectionId) {
        console.log('Navigating to: ', sectionId);
    };
    WixSDKFakeAdapter.prototype.closeSettingsPanel = function () {
        console.log('closing settings panel');
    };
    WixSDKFakeAdapter.prototype.isAppSectionInstalled = function (sectionId, options, cb) {
        cb(sectionId === 'bookings_member_area' || sectionId === 'book_checkout');
    };
    WixSDKFakeAdapter.prototype.getSiteInfo = function (callback) {
        callback({
            pageTitle: 'Local Server',
            pageTitleOnly: 'Home',
            referer: '',
            siteDescription: 'Local server',
            siteKeywords: 'Good things happen when everything connects',
            url: window.location.href,
            baseUrl: window.location.href,
        });
    };
    WixSDKFakeAdapter.prototype.setHeight = function () {
        return null;
    };
    WixSDKFakeAdapter.prototype.getExternalId = function (callback) {
        callback(null);
    };
    WixSDKFakeAdapter.prototype.setHelpArticleId = function (articleId) {
        return null;
    };
    WixSDKFakeAdapter.prototype.getDeviceType = function () {
        return WixSDKFakeAdapter_getCurrentDeviceType();
    };
    return WixSDKFakeAdapter;
}());

//# sourceMappingURL=WixSDKFakeAdapter.js.map
// CONCATENATED MODULE: ../node_modules/@wix/bookings-adapter-wix-sdk/dist/es/src/index.js
/* concated harmony reexport WixSDKAdapter */__webpack_require__.d(__webpack_exports__, "WixSDKAdapter", function() { return WixSDKAdapter_WixSDKAdapter; });
/* concated harmony reexport DeepLink */__webpack_require__.d(__webpack_exports__, "DeepLink", function() { return DeepLink; });
/* concated harmony reexport WixMock */__webpack_require__.d(__webpack_exports__, "WixMock", function() { return WixMock_WixMock; });
/* concated harmony reexport wixSDKDemoValues */__webpack_require__.d(__webpack_exports__, "wixSDKDemoValues", function() { return wixSDKDemoValues; });
/* concated harmony reexport WixSDKFakeAdapter */__webpack_require__.d(__webpack_exports__, "WixSDKFakeAdapter", function() { return WixSDKFakeAdapter_WixSDKFakeAdapter; });





//# sourceMappingURL=index.js.map

/***/ }),

/***/ 35:
/*!************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/offerings/base-offering.dto.builder.js ***!
  \************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var date_time_1 = __webpack_require__(/*! ../constants/date-time */ 42);
var offering_dto_1 = __webpack_require__(/*! ./offering.dto */ 16);
var moment = __webpack_require__(/*! moment */ 30);
var offering_payment_dto_buillder_1 = __webpack_require__(/*! ../entities/offering-payment/offering-payment.dto.buillder */ 66);
var offering_location_dto_builder_1 = __webpack_require__(/*! ../entities/offering-location/offering-location.dto.builder */ 86);
var offering_info_dto_builder_1 = __webpack_require__(/*! ../entities/offering-info/offering-info.dto.builder */ 67);
var offering_schedule_policy_dto_builder_1 = __webpack_require__(/*! ../entities/offering-schedule-policy/offering-schedule-policy.dto.builder */ 88);
var BaseOfferingDtoBuilder = /** @class */ (function () {
    function BaseOfferingDtoBuilder() {
        this.idGenerator = function () { return "offering-id-" + Math.random(); };
        this.offering = this.validOfferingDto();
    }
    BaseOfferingDtoBuilder.prototype.validWeekHours = function () {
        return {
            sun: null,
            mon: {
                workingHours: [
                    {
                        id: this.idGenerator(),
                        workingHour: { startTime: '12:00', endTime: '13:00' },
                        staffId: null,
                    },
                ],
            },
            tue: {
                workingHours: [
                    {
                        id: this.idGenerator(),
                        workingHour: { startTime: '14:00', endTime: '15:00' },
                        staffId: null,
                    },
                    {
                        id: this.idGenerator(),
                        workingHour: { startTime: '16:00', endTime: '18:30' },
                        staffId: null,
                    },
                ],
            },
        };
    };
    BaseOfferingDtoBuilder.prototype.withPricePlan = function (pricingPlanName) {
        this.offering.offeredAs = [offering_dto_1.OfferedAsType.PRICING_PLAN];
        this.offering.pricingPlanInfo = {
            displayText: "in pricing plan: " + pricingPlanName,
            pricingPlans: [{ id: '1', name: pricingPlanName }],
        };
        return this;
    };
    BaseOfferingDtoBuilder.prototype.validOfferingDto = function () {
        var dateFormatInSchedule = new date_time_1.DateDefaultsConst().DATE_FORMAT;
        var now = moment();
        return {
            id: this.idGenerator(),
            categoryId: this.idGenerator(),
            order: 0,
            type: this.getOfferingType(),
            urlName: 'offering-id-0',
            offeredAs: [offering_dto_1.OfferedAsType.ONE_TIME],
            pricingPlanInfo: {
                displayText: null,
                pricingPlans: [],
            },
            info: new offering_info_dto_builder_1.OfferingInfoDtoBuilder().build(),
            location: new offering_location_dto_builder_1.OfferingLocationDtoBuilder().build(),
            payment: new offering_payment_dto_buillder_1.OfferingPaymentDtoBuilder().build(),
            schedulePolicy: new offering_schedule_policy_dto_builder_1.OfferingSchedulePolicyDtoBuilder().build(),
            schedule: {
                startDate: now
                    .clone()
                    .add(20, 'days')
                    .format(dateFormatInSchedule),
                endDate: now
                    .clone()
                    .add(100, 'days')
                    .format(dateFormatInSchedule),
            },
        };
    };
    BaseOfferingDtoBuilder.prototype.withStartDate = function (momentDate) {
        this.offering.schedule.startDate = momentDate
            .clone()
            .format(new date_time_1.DateDefaultsConst().DATE_FORMAT);
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withEndDate = function (momentDate) {
        this.offering.schedule.endDate = momentDate
            .clone()
            .format(new date_time_1.DateDefaultsConst().DATE_FORMAT);
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withExpired = function () {
        var now = moment();
        return this.withStartDate(now.clone().add(-20, 'days')).withEndDate(now.clone().add(-10, 'days'));
    };
    BaseOfferingDtoBuilder.prototype.withId = function (id) {
        this.offering.id = id;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withDummyIndication = function () {
        this.offering.dummy = true;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withUrlName = function (urlName) {
        this.offering.urlName = urlName;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withIdGenerator = function (idGenerator) {
        this.idGenerator = idGenerator;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withCategoryId = function (cid) {
        this.offering.categoryId = cid;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withLocation = function (location) {
        this.offering.location.type = location.type;
        this.offering.location.locationText = location.locationText;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withName = function (name) {
        this.offering.info.name = name;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withPaymentType = function (type) {
        this.offering.payment.paymentType = type;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withDescription = function (description) {
        this.offering.info.description = description;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withTagLine = function (tagLine) {
        this.offering.info.tagLine = tagLine;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withCapacity = function (capacity) {
        this.offering.schedulePolicy.capacity = capacity;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withNameSuffix = function (name) {
        this.offering.info.name += name;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withImages = function (images) {
        this.offering.info.images = images;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withInfo = function (info) {
        this.offering.info = info;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withOrder = function (order) {
        this.offering.order = order;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withPayment = function (payment) {
        this.offering.payment = payment;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.withHidden = function (hide) {
        this.offering.schedulePolicy.uouHidden = hide;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.asDisplayOnly = function () {
        this.offering.schedulePolicy.displayOnlyNoBookFlow = true;
        return this;
    };
    BaseOfferingDtoBuilder.prototype.build = function () {
        return this.offering;
    };
    return BaseOfferingDtoBuilder;
}());
exports.BaseOfferingDtoBuilder = BaseOfferingDtoBuilder;
//# sourceMappingURL=base-offering.dto.builder.js.map

/***/ }),

/***/ 354:
/*!****************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-adapters-reporting/dist/src/sentry/sentry.const.js ***!
  \****************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SENTRY_BOOKINGS_VIEWER_SCRIPT_DNS = 'https://590d4d7ac1594ef8a4201c7c5e82d8da@sentry.io/1399205';
exports.SENTRY_BOOKINGS_RUNNING_ENVIRONMENT = 'ooi-viewer-script';
//# sourceMappingURL=sentry.const.js.map

/***/ }),

/***/ 355:
/*!************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-adapter-ooi-wix-sdk/dist/src/bookings.const.js ***!
  \************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PRICING_PLAN_APP_DEF_ID = '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3';
exports.PRICING_PLAN_SECTION_ID = 'membership_plan_picker_tpa';
exports.RTL_LANGUAGES = ['ar', 'fa', 'he'];
//# sourceMappingURL=bookings.const.js.map

/***/ }),

/***/ 356:
/*!************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/logger-factory.js ***!
  \************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.phasesConfig = undefined;
exports.create = create;
exports.setFactory = setFactory;

var _env = __webpack_require__(/*! ./env */ 48);

var _conf = __webpack_require__(/*! ./conf */ 94);

var _reporter = __webpack_require__(/*! ./reporter/reporter */ 220);

var _reporter2 = _interopRequireDefault(_reporter);

var _baseLogger = __webpack_require__(/*! ./base-logger */ 361);

var _baseLogger2 = _interopRequireDefault(_baseLogger);

var _appData = __webpack_require__(/*! ./app-data/app-data */ 133);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReporterFactory = void 0;

function getAppVersion() {
  return (0, _env.env)().__CI_APP_VERSION__ || _conf.DEFAULT_APP_VERSION;
}

/*
 * @param baseUrl
 * @param appId
 * @param disableAutoLoadFinish
 * @param interactionTimeout
 * @param timeoutHook
 * @param startHook
 * @param endHook
 * @param biLoggerFactory
 */
function create(appName) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!appName) {
    return null;
  }

  (0, _appData.initializeGlobal)(appName);
  var reporter = createReporterInstance(params);
  return new _baseLogger2.default(appName, getAppVersion(), reporter, params);
}

function setFactory(factory) {
  ReporterFactory = factory;
}

function createReporterInstance(_ref) {
  var biLoggerFactory = _ref.biLoggerFactory,
      baseUrl = _ref.baseUrl;

  if (!ReporterFactory) {
    return new _reporter2.default(biLoggerFactory, baseUrl);
  } else {
    return ReporterFactory(biLoggerFactory, baseUrl);
  }
}

var phasesConfig = exports.phasesConfig = _baseLogger.phasesConfigValues;

/***/ }),

/***/ 357:
/*!*********************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/node_modules/@wix/web-bi-logger/dist/src/logger.js ***!
  \*********************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var wix_bi_logger_client_1 = __importDefault(__webpack_require__(/*! @wix/wix-bi-logger-client */ 108));
var assert = __importStar(__webpack_require__(/*! ./lib/assert */ 358));
var publishers_1 = __webpack_require__(/*! ./lib/publishers */ 359);
var utils_1 = __webpack_require__(/*! ./lib/utils */ 221);
var constants_1 = __webpack_require__(/*! ./constants */ 95);
var constants_2 = __webpack_require__(/*! ./constants */ 95);
exports.PublishMethods = constants_2.PublishMethods;
var env_1 = __webpack_require__(/*! ./lib/env */ 132);
exports.setHost = env_1.setHost;
var filterContext = function (context) {
    return Object.keys(context).reduce(function (res, key) {
        if (constants_1.EventContextMap[key]) {
            res[constants_1.EventContextMap[key]] = context[key];
        }
        return res;
    }, {});
};
var getUserContextFromCookies = function () {
    return utils_1.getCookies({
        clientId: '_wixCIDX',
        uuid: {
            name: '_wixUIDX',
            transform: function (value) { return typeof value === 'string' && value.split('|')[1]; },
        },
    });
};
var validatePublishMethod = function (publishMethod) {
    return (Object.keys(constants_1.PublishMethods)
        .map(function (key) { return constants_1.PublishMethods[key]; })
        .indexOf(publishMethod) !== -1);
};
var Factory = /** @class */ (function () {
    function Factory(options) {
        if (options === void 0) { options = {}; }
        this.options = options;
        this.initialized = false;
        this.muted = false;
        assert.ok(!options.publishMethod || validatePublishMethod(options.publishMethod), "Unsupported publish method \"" + options.publishMethod + "\"");
        this.loggerClientFactory = wix_bi_logger_client_1.default.factory(options);
        this.withUserContext(getUserContextFromCookies());
    }
    Factory.prototype.initFactory = function () {
        if (this.initialized) {
            return this.loggerClientFactory;
        }
        this.initialized = true;
        var publisher = publishers_1.getPublisher(this.options, this.transformer, this.publishFunctions);
        return this.loggerClientFactory.addPublisher(publisher);
    };
    Factory.prototype.withTransformer = function (transformer) {
        assert.defined(transformer, 'Transformer must be provided');
        assert.ok(typeof transformer === 'function' ||
            (transformer && typeof transformer.postMessage === 'function'), 'Valid transformer must be provided');
        this.transformer = transformer;
        return this;
    };
    Factory.prototype.withPublishFunction = function (publishFunctions) {
        assert.defined(publishFunctions, 'Publish function must be provided');
        assert.ok(publishFunctions && typeof publishFunctions.postMessage === 'function', 'Valid publish function must be provided');
        this.publishFunctions = publishFunctions;
        return this;
    };
    Factory.prototype.withUserContext = function (context) {
        assert.defined(context, 'User context object must be provided');
        this.updateDefaults(filterContext(context));
        return this;
    };
    Factory.prototype.withUoUContext = function (context) {
        assert.defined(context, 'UoU context object must be provided');
        this.updateDefaults(filterContext(context));
        return this;
    };
    Factory.prototype.updateDefaults = function (params) {
        this.loggerClientFactory.updateDefaults(params);
        return this;
    };
    Factory.prototype.setMuted = function (muted) {
        this.muted = muted;
        return this;
    };
    Factory.prototype.onError = function (handler) {
        this.loggerClientFactory.setPublisherFailHandler(handler);
        return this;
    };
    Factory.prototype.logger = function (options) {
        if (options === void 0) { options = {}; }
        var self = this;
        var useBatch = typeof options.useBatch !== 'undefined'
            ? options.useBatch
            : this.options.useBatch;
        var logger = this.initFactory().logger(__assign({}, options, { useBatch: useBatch }));
        return {
            log: function (params, context) {
                if (self.muted) {
                    return Promise.resolve();
                }
                return logger.log(params, context);
            },
        };
    };
    return Factory;
}());
exports.Factory = Factory;
exports.factory = function (options) {
    if (options === void 0) { options = {}; }
    return new Factory(options);
};
//# sourceMappingURL=logger.js.map

/***/ }),

/***/ 358:
/*!*************************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/node_modules/@wix/web-bi-logger/dist/src/lib/assert.js ***!
  \*************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var errors_1 = __webpack_require__(/*! ./errors */ 130);
exports.defined = function (target, message) {
    if (target === undefined) {
        throw new errors_1.AssertionError(message);
    }
};
exports.object = function (target, message) {
    if (target !== undefined &&
        (typeof target !== 'object' || Array.isArray(target) || target === null)) {
        throw new errors_1.AssertionError(message);
    }
};
exports.ok = function (target, message) {
    if (!target) {
        throw new errors_1.AssertionError(message);
    }
};
//# sourceMappingURL=assert.js.map

/***/ }),

/***/ 359:
/*!*****************************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/node_modules/@wix/web-bi-logger/dist/src/lib/publishers.js ***!
  \*****************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(/*! ./utils */ 221);
var env_1 = __webpack_require__(/*! ./env */ 132);
var constants_1 = __webpack_require__(/*! ../constants */ 95);
var errors_1 = __webpack_require__(/*! ./errors */ 130);
var browser_1 = __webpack_require__(/*! ./browser */ 131);
var transport_1 = __webpack_require__(/*! ./transport */ 360);
var baseTransformer = function (params) {
    if (params === void 0) { params = {}; }
    params.ms = Math.round(browser_1.now());
    params._lv = constants_1.LoggerVersion;
    return params;
};
var resolveTransformer = function (options, transformer) {
    if (transformer) {
        if (typeof transformer !== 'function' &&
            transformer.postMessage &&
            options.publishMethod === constants_1.PublishMethods.PostMessage) {
            transformer = transformer.postMessage;
        }
        else if (typeof transformer !== 'function') {
            transformer = null;
        }
    }
    var resolvedTransformer = transformer
        ? function (p) { return transformer(baseTransformer(p)); }
        : baseTransformer;
    return function (params, context) {
        if (context.useBatch) {
            params.e = params.e.map(function (e) { return (__assign({}, e, { f: resolvedTransformer(e.f) })); });
            return params;
        }
        return resolvedTransformer(params);
    };
};
function imagePublisher(options) {
    if (options === void 0) { options = {}; }
    return function image(params, context) {
        if (context === void 0) { context = {}; }
        if (context.useBatch) {
            throw new errors_1.APINotSupportedError("Can't use image publisher to send batched events.");
        }
        var url = utils_1.buildBiUrl(options, params, context);
        return transport_1.pixelTransport(url, context.image);
    };
}
exports.imagePublisher = imagePublisher;
function beaconPublisher(options) {
    if (options === void 0) { options = {}; }
    return function beacon(params, context) {
        if (context === void 0) { context = {}; }
        var url = utils_1.buildBiUrl(options, params, context);
        return transport_1.beaconTransport(url, params, !!context.useBatch).catch(function () {
            return transport_1.pixelTransport(url, context.image);
        });
    };
}
exports.beaconPublisher = beaconPublisher;
function fetchPublisher(options) {
    if (options === void 0) { options = {}; }
    return function fetch(params, context) {
        if (context === void 0) { context = {}; }
        var url = utils_1.buildBiUrl(options, params, context);
        var method = context.useBatch ? 'POST' : 'GET';
        return transport_1.fetchTransport(url, params, method).catch(function (error) {
            return error instanceof errors_1.APINotSupportedError
                ? transport_1.xhrTransport(url, params, method)
                : Promise.reject(error);
        });
    };
}
exports.fetchPublisher = fetchPublisher;
function xhrPublisher(options) {
    if (options === void 0) { options = {}; }
    return function xhr(params, context) {
        if (context === void 0) { context = {}; }
        var url = utils_1.buildBiUrl(options, params, context);
        var method = context.useBatch ? 'POST' : 'GET';
        return transport_1.xhrTransport(url, params, method);
    };
}
exports.xhrPublisher = xhrPublisher;
function postMessagePublisher(options, publishFunction) {
    if (options === void 0) { options = {}; }
    return function postMessage(params) {
        return transport_1.postMessageTransport(params, publishFunction);
    };
}
exports.postMessagePublisher = postMessagePublisher;
exports.resolvePublisher = function (options, publishFunctions) {
    var publisherFactory;
    var publishFunction;
    if (options.publishMethod === constants_1.PublishMethods.PostMessage) {
        publisherFactory = postMessagePublisher;
        publishFunction = publishFunctions && publishFunctions.postMessage;
    }
    else if (env_1.isWebWorker()) {
        publisherFactory = fetchPublisher;
    }
    else {
        publisherFactory = beaconPublisher;
    }
    return publisherFactory(options, publishFunction);
};
function getPublisher(options, paramTransformer, publishFunctions) {
    var publisher = exports.resolvePublisher(options, publishFunctions);
    var transformer = resolveTransformer(options, paramTransformer);
    return function (params, context) { return publisher(transformer(params, context), context); };
}
exports.getPublisher = getPublisher;
//# sourceMappingURL=publishers.js.map

/***/ }),

/***/ 360:
/*!****************************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/node_modules/@wix/web-bi-logger/dist/src/lib/transport.js ***!
  \****************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var browser_1 = __webpack_require__(/*! ./browser */ 131);
var errors_1 = __webpack_require__(/*! ./errors */ 130);
function beaconTransport(url, params, sendInBody) {
    if (sendInBody === void 0) { sendInBody = false; }
    return new Promise(function (resolve, reject) {
        return browser_1.sendBeacon(url, sendInBody ? JSON.stringify(params) : undefined)
            ? resolve()
            : reject(new Error('Transport Error: Cannot send bi using beacon'));
    });
}
exports.beaconTransport = beaconTransport;
function pixelTransport(url, image) {
    return new Promise(function (resolve, reject) {
        var biImage = image || new window.Image(0, 0);
        biImage.onload = function () { return resolve(); };
        biImage.onerror = function () {
            return reject(new Error('Transport Error: Cannot send bi using pixel'));
        };
        biImage.src = url;
    });
}
exports.pixelTransport = pixelTransport;
function fetchTransport(url, params, method) {
    if (method === void 0) { method = 'GET'; }
    if (typeof fetch === 'undefined') {
        return Promise.reject(new errors_1.APINotSupportedError('fetch'));
    }
    var options = {
        method: method,
        credentials: 'include',
    };
    if (method === 'POST') {
        options.body = JSON.stringify(params);
    }
    else {
        options.keepalive = true;
    }
    return fetch(url, options).then(function (response) {
        if (!response.ok) {
            throw Error("Transport Error: Cannot send bi using fetch. Status: " + response.status);
        }
    });
}
exports.fetchTransport = fetchTransport;
function xhrTransport(url, params, method) {
    if (method === void 0) { method = 'GET'; }
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open(method, location.protocol + ":" + url);
        xhr.onload = resolve;
        xhr.onerror = function () {
            reject(new Error("Transport Error: Cannot send bi using xhr."));
        };
        xhr.withCredentials = true;
        if (method === 'POST') {
            xhr.send(JSON.stringify(params));
        }
        else {
            xhr.send();
        }
    });
}
exports.xhrTransport = xhrTransport;
function postMessageTransport(message, postMesasage) {
    if (postMesasage === void 0) { postMesasage = self.postMessage; }
    var messageArgs = [message];
    // when not in a web worker...
    if (typeof WorkerGlobalScope === 'undefined') {
        messageArgs.push('*');
    }
    return postMesasage.apply(self, messageArgs);
}
exports.postMessageTransport = postMessageTransport;
//# sourceMappingURL=transport.js.map

/***/ }),

/***/ 361:
/*!*********************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/base-logger.js ***!
  \*********************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.phasesConfigValues = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _env = __webpack_require__(/*! ./env */ 48);

var _performance = __webpack_require__(/*! ./performance/performance */ 75);

var _performance2 = _interopRequireDefault(_performance);

var _times = __webpack_require__(/*! ./times/times */ 362);

var _times2 = _interopRequireDefault(_times);

var _dataSource = __webpack_require__(/*! ./data-source/data-source */ 363);

var _dataSource2 = _interopRequireDefault(_dataSource);

var _dataItem = __webpack_require__(/*! ./data-items/common/data-item */ 49);

var _dataItem2 = _interopRequireDefault(_dataItem);

var _resourceItem = __webpack_require__(/*! ./data-items/resource/resource-item */ 364);

var _resourceItem2 = _interopRequireDefault(_resourceItem);

var _biLoadStartItem = __webpack_require__(/*! ./data-items/app-load/bi-load-start-item */ 365);

var _biLoadStartItem2 = _interopRequireDefault(_biLoadStartItem);

var _biLoadPhaseItem = __webpack_require__(/*! ./data-items/phases/bi-load-phase-item */ 366);

var _biLoadPhaseItem2 = _interopRequireDefault(_biLoadPhaseItem);

var _durationItem = __webpack_require__(/*! ./data-items/duration/duration-item */ 367);

var _durationItem2 = _interopRequireDefault(_durationItem);

var _biErrorItem = __webpack_require__(/*! ./data-items/common/bi-error-item */ 368);

var _biErrorItem2 = _interopRequireDefault(_biErrorItem);

var _loadingPhaseItem = __webpack_require__(/*! ./data-items/phases/loading-phase-item */ 223);

var _loadingPhaseItem2 = _interopRequireDefault(_loadingPhaseItem);

var _loadingPhaseItemPrefixed = __webpack_require__(/*! ./data-items/phases/loading-phase-item-prefixed */ 369);

var _loadingPhaseItemPrefixed2 = _interopRequireDefault(_loadingPhaseItemPrefixed);

var _loadingPhaseCollectionItem = __webpack_require__(/*! ./data-items/phases/loading-phase-collection-item */ 370);

var _loadingPhaseCollectionItem2 = _interopRequireDefault(_loadingPhaseCollectionItem);

var _biLoadFinishItem = __webpack_require__(/*! ./data-items/app-load/bi-load-finish-item */ 371);

var _biLoadFinishItem2 = _interopRequireDefault(_biLoadFinishItem);

var _biInteractionStartItem = __webpack_require__(/*! ./data-items/interaction/bi-interaction-start-item */ 372);

var _biInteractionStartItem2 = _interopRequireDefault(_biInteractionStartItem);

var _biInteractionEndItem = __webpack_require__(/*! ./data-items/interaction/bi-interaction-end-item */ 373);

var _biInteractionEndItem2 = _interopRequireDefault(_biInteractionEndItem);

var _biAppContextItem = __webpack_require__(/*! ./data-items/common/bi-app-context-item */ 374);

var _biAppContextItem2 = _interopRequireDefault(_biAppContextItem);

var _sessionManager = __webpack_require__(/*! ./session-manager/session-manager */ 375);

var _sessionManager2 = _interopRequireDefault(_sessionManager);

var _loadingPhases = __webpack_require__(/*! ./loading-phases/loading-phases */ 377);

var _loadingPhases2 = _interopRequireDefault(_loadingPhases);

var _reporter = __webpack_require__(/*! ./reporter/reporter */ 220);

var _reporter2 = _interopRequireDefault(_reporter);

var _conf = __webpack_require__(/*! ./conf */ 94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var callHook = function callHook(hook, hookArgs) {
  if (hook) {
    return hook(hookArgs);
  }
};

/**
 * Base Logger
 * @param appName
 * @param appVersion
 * @param reporter
 *
 * Params object properties:
 * @param baseUrl
 * @param appId
 * @param disableAutoLoadFinish
 * @param phasesConfig
 * @param interactionTimeout
 * @param timeoutHook
 * @param startHook
 * @param endHook
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */

var BaseLogger = function () {
  function BaseLogger(appName, appVersion, reporter, params) {
    _classCallCheck(this, BaseLogger);

    var defaultParams = {
      appId: null,
      widgetId: null,
      metasiteId: null,
      sessionId: _sessionManager2.default.getSessionId(),
      isServerSide: null,
      disableAutoLoadFinish: false,
      phasesConfig: phasesConfigValues.SEND_ON_START,
      interactionTimeout: null,
      timeoutHook: null,
      startHook: null,
      endHook: null,
      isPersistent: false
    };

    var paramsWithDefaults = Object.assign({}, defaultParams, params);
    this.appName = appName;
    this.appVersion = appVersion;
    this.appId = paramsWithDefaults.appId;
    this.widgetId = paramsWithDefaults.widgetId;
    this.metasiteId = paramsWithDefaults.metasiteId;

    this.isServerSide = paramsWithDefaults.isServerSide;
    this.params = { sessionId: paramsWithDefaults.sessionId };
    this.disableAutoLoadFinish = paramsWithDefaults.disableAutoLoadFinish;
    this.phasesConfig = paramsWithDefaults.phasesConfig;
    this._appLoadedCalled = {};

    this.reporter = reporter || new _reporter2.default();
    this.loadingPhases = new _loadingPhases2.default(appName);
    this.dataSourceBase = new _dataSource2.default({ appName: appName });

    this._outgoingInteractions = {};
    this.interactionTimeout = paramsWithDefaults.interactionTimeout;
    this.timeoutHook = paramsWithDefaults.timeoutHook;
    this.startHook = paramsWithDefaults.startHook;
    this.endHook = paramsWithDefaults.endHook;
    this.isPersistent = paramsWithDefaults.isPersistent;

    this.times = new _times2.default(appName);
  }

  BaseLogger.prototype._report = function _report(dataSource, reporterEndpoint) {
    return this.reporter.report(dataSource.mergeItems(), reporterEndpoint);
  };

  BaseLogger.prototype.getAppName = function getAppName() {
    return this.appName;
  };

  BaseLogger.prototype.getAppVersion = function getAppVersion() {
    return this.appVersion;
  };

  BaseLogger.prototype.getReporter = function getReporter() {
    return this.reporter;
  };

  BaseLogger.prototype.getParam = function getParam(paramName) {
    return this.params[paramName];
  };

  BaseLogger.prototype._isDisableAutoLoadFinish = function _isDisableAutoLoadFinish() {
    return this.disableAutoLoadFinish;
  };

  BaseLogger.prototype.isDisableAutoLoadFinish = function isDisableAutoLoadFinish() {
    return this._isDisableAutoLoadFinish();
  };

  BaseLogger.prototype.reportNetworkAnalysis = function reportNetworkAnalysis() {
    var _this = this;

    var resources = _performance2.default.getResources();
    setTimeout(function () {
      try {
        var resourceDataItem = new _resourceItem2.default(_this.sessionId);

        var analysis = resourceDataItem.performNetworkAnalysis(resources);
        if (!analysis) {
          return;
        }
        var dataSource = _this.dataSource.addItem(resourceDataItem).addItem(analysis);

        _this._report(dataSource);
      } catch (e) {
        console.error('[fedops] Failed to report resource metrics', e);
      }
    }, 1000);
  };

  /**
   * Manual report for widget load start - Should only be used if your widget doesn't have its own .vm / .ejs file
   * Call this method at the earliest point possible when your widget starts loading.
   */


  BaseLogger.prototype.appLoadStarted = function appLoadStarted() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        appId = _ref.appId;

    this.times.setLoadStarted();

    var dataSource = this.dataSource.addItem(new _biLoadStartItem2.default(this.sessionId)).addItem(new _biAppContextItem2.default({
      appId: appId || this.appId,
      widgetId: this.widgetId,
      isServerSide: this.isServerSide
    }));

    if (appId) {
      dataSource.addItem(new _dataItem2.default({ appName: appId }));
    }

    return this._report(dataSource, this.isPersistent ? _conf.PERFORMANCE_BI_ENPOINT : _conf.FEDOPS_BI_ENDPOINT);
  };

  /**
   * Final phase.
   * Call this method when your application finishes loading and after all custom phases.
   * @param appId
   */


  BaseLogger.prototype.appLoaded = function appLoaded() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        appId = _ref2.appId;

    if (this._appLoadedCalled[appId] || this._appLoadedCalled[this.appName]) {
      return;
    }

    BaseLogger._clearLoadTimeout();
    BaseLogger._markAndMeasureAppLoad();
    this._appLoadedCalled[appId || this.appName] = true;

    this._sendLastAppLoadPhaseIfNeeded();
    this.reportNetworkAnalysis();

    var dataSource = this.dataSource.addItem(new _biLoadFinishItem2.default(this.sessionId)).addItem(new _biAppContextItem2.default({
      appId: appId || this.appId,
      widgetId: this.widgetId,
      isServerSide: this.isServerSide
    })).addItem(new _durationItem2.default(this.times.getAppLoadTime()).setFirstRequestDuration(this.times.getFirstRequestDuration()));

    if (appId) {
      dataSource.addItem(new _dataItem2.default({ appName: appId }));
    }

    if (this.phasesConfig === phasesConfigValues.SEND_ON_APP_LOADED) {
      var phasesOfApp = this.loadingPhases.getPhases({ appId: appId });
      if (phasesOfApp.length > 0) {
        dataSource.addItem(new _loadingPhaseCollectionItem2.default(phasesOfApp));
      }
    }

    return this._report(dataSource, this.isPersistent ? _conf.PERFORMANCE_BI_ENPOINT : _conf.FEDOPS_BI_ENDPOINT);
  };

  /**
   * Start of an app loading phase, reports end of previous phase if configured
   * Sends phase event (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13)
   * @param name of the step
   * @param appId that the step belongs to
   * @param widgetId that the step belongs to
   */


  BaseLogger.prototype.appLoadingPhaseStart = function appLoadingPhaseStart(name) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        appId = _ref3.appId,
        widgetId = _ref3.widgetId;

    if (this.phasesConfig === phasesConfigValues.SEND_ON_START) {
      this.loadingPhases.createCodeParsingPhaseIfNotExist({ appId: appId, widgetId: widgetId });
    }

    this.loadingPhases.saveLoadingPhase({ name: name, appId: appId, widgetId: widgetId });
    var previousPhase = this.loadingPhases.getPhasePreviousTo({
      name: name,
      appId: appId,
      widgetId: widgetId
    });

    if (this.phasesConfig === phasesConfigValues.SEND_ON_START) {
      var loadingPhaseDataItem = new _loadingPhaseItemPrefixed2.default(previousPhase);
      var loadingPhaseBiItem = new _biLoadPhaseItem2.default(this.sessionId);

      var dataSource = this.dataSource.addItem(loadingPhaseDataItem).addItem(loadingPhaseBiItem);

      return this._report(dataSource);
    }
  };

  /**
   * End of an app loading phase, reports end of previous phase
   * Sends phase event (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13)
   * @param name of the step
   * @param appId that the step belongs to
   * @param widgetId that the step belongs to
   * @param widgetArray that are related to this step
   */


  BaseLogger.prototype.appLoadingPhaseFinish = function appLoadingPhaseFinish(name) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        appId = _ref4.appId,
        widgetId = _ref4.widgetId,
        widgetArray = _ref4.widgetArray;

    if (this.phasesConfig === phasesConfigValues.SEND_ON_START) {
      throw new Error('To use appLoadingPhaseFinish you must create the logger with the "phasesConfig: SEND_ON_FINISH or SEND_ON_APP_LOADED" param');
    }

    if (this.phasesConfig === phasesConfigValues.SEND_ON_APP_LOADED) {
      this.loadingPhases.endLoadingPhase({
        name: name,
        appId: appId,
        widgetId: widgetId,
        widgetArray: widgetArray
      });
    } else {
      var loadingPhase = this.loadingPhases.getAppLoadingPhaseData({
        name: name,
        appId: appId,
        widgetId: widgetId
      });

      if (!loadingPhase) {
        throw new Error('Cannot report end of a phase that wasn\'t started. Phase ' + name + ' doesn\'t exist');
      }

      var loadingPhaseDataItem = new _loadingPhaseItem2.default(loadingPhase);
      var loadingPhaseBiItem = new _biLoadPhaseItem2.default(this.sessionId);
      var eventContextDataItem = new _biAppContextItem2.default({
        appId: appId,
        widgetId: widgetId,
        widgetArray: widgetArray,
        isServerSide: this.isServerSide
      });

      var dataSource = this.dataSource.addItem(loadingPhaseDataItem).addItem(loadingPhaseBiItem).addItem(eventContextDataItem);

      return this._report(dataSource, this.isPersistent ? _conf.PERFORMANCE_BI_ENPOINT : _conf.FEDOPS_BI_ENDPOINT);
    }
  };

  BaseLogger.prototype._sendLastAppLoadPhaseIfNeeded = function _sendLastAppLoadPhaseIfNeeded() {
    var appLoadingPhase = this.loadingPhases.getNextPhaseToReport();
    var shouldReportLastPhase = this.phasesConfig === phasesConfigValues.SEND_ON_START && appLoadingPhase && appLoadingPhase.name !== _loadingPhases.CODE_PARSING_PHASE_NAME;

    if (shouldReportLastPhase) {
      this._report(this.dataSource.addItem(new _loadingPhaseItemPrefixed2.default(appLoadingPhase)).addItem(new _biLoadPhaseItem2.default(this.sessionId)));
    }
  };

  BaseLogger._clearLoadTimeout = function _clearLoadTimeout() {
    if ((0, _env.env)() && (0, _env.env)().fedops && typeof (0, _env.env)().fedops.clearLoadTimeout === 'function') {
      (0, _env.env)().fedops.clearLoadTimeout();
    }
  };

  BaseLogger.prototype.clearResourceTimings = function clearResourceTimings() {
    _performance2.default.clearResourceTimings();
  };

  BaseLogger._markAndMeasureAppLoad = function _markAndMeasureAppLoad() {
    _performance2.default.mark('[fedops] app-loaded');
    _performance2.default.measure('[fedops] app-loaded', 'navigationStart', '[fedops] app-loaded');
  };

  /**
   * Custom interaction start (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/15)
   * @param {String} interactionName  interaction name
   */


  BaseLogger.prototype.interactionStarted = function interactionStarted(interactionName) {
    var _this2 = this;

    var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        interactionTimeout = _ref5.interactionTimeout,
        startHook = _ref5.startHook,
        timeoutHook = _ref5.timeoutHook;

    _performance2.default.mark(interactionName + ' started');
    var scheduleTimeoutEvent = function scheduleTimeoutEvent() {
      if (interactionTimeout || _this2.interactionTimeout) {
        return setTimeout(function () {
          var dataSource = _this2.dataSource.addItem({ interactionName: interactionName }).addItem({ errorType: 'timeout' }).addItem(new _biErrorItem2.default(_this2.sessionId));

          _this2._report(dataSource);
          callHook(timeoutHook || _this2.timeoutHook, {
            name: interactionName,
            timeout: interactionTimeout || _this2.interactionTimeout
          });
        }, interactionTimeout || _this2.interactionTimeout);
      }
    };

    var dataSource = this.dataSource.addItem({ name: interactionName }).addItem(new _biInteractionStartItem2.default(this.sessionId));

    this._outgoingInteractions[interactionName] = {
      timestamp: _performance2.default.now(),
      timeout: interactionTimeout || this.interactionTimeout
    };
    this._report(dataSource);
    callHook(startHook || this.startHook, { name: interactionName });

    var timeoutId = scheduleTimeoutEvent();
    return {
      timeoutId: timeoutId
    };
  };

  /**
   * Custom interaction end (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/16)
   * @param {String} interactionName  interaction name
   */


  BaseLogger.prototype.interactionEnded = function interactionEnded(interactionName) {
    var _this3 = this;

    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        timeoutId = _ref6.timeoutId,
        endHook = _ref6.endHook;

    _performance2.default.mark(interactionName + ' ended');
    _performance2.default.measure(interactionName + ' duration', interactionName + ' started', interactionName + ' ended');

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    var getInteractionFromWindowIfPresent = function getInteractionFromWindowIfPresent(actualEnv) {
      return actualEnv.fedops && actualEnv.fedops.apps && actualEnv.fedops.apps[_this3.appName] && actualEnv.fedops.apps[_this3.appName].interactions && actualEnv.fedops.apps[_this3.appName].interactions[interactionName];
    };

    var interaction = this._outgoingInteractions[interactionName] || getInteractionFromWindowIfPresent((0, _env.env)());
    var duration = interaction ? Math.floor(_performance2.default.now() - interaction.timestamp) : '';

    callHook(endHook || this.endHook, {
      name: interactionName,
      duration: duration,
      timeout: this._outgoingInteractions[interactionName] && this._outgoingInteractions[interactionName].timeout
    });

    var dataSource = this.dataSource.addItem({ name: interactionName }).addItem({ duration: duration }).addItem(new _biInteractionEndItem2.default(this.sessionId));

    delete this._outgoingInteractions[interactionName];

    this._report(dataSource);
  };

  BaseLogger.prototype.getLoggerForWidget = function getLoggerForWidget(_ref7) {
    var appName = _ref7.appName,
        appId = _ref7.appId,
        widgetId = _ref7.widgetId,
        version = _ref7.version;

    var widgetAppName = appName || appId + '_' + widgetId;
    var widgetVersion = version || this.getAppVersion();
    var reporter = new _reporter2.default(this.reporter.factory);

    var config = {
      isServerSide: this.isServerSide,
      appId: appId,
      widgetId: widgetId,
      sessionId: this.sessionId,
      phasesConfig: phasesConfigValues.SEND_ON_APP_LOADED,
      isPersistent: this.isPersistent
    };

    return new BaseLogger(widgetAppName, widgetVersion, reporter, config);
  };

  _createClass(BaseLogger, [{
    key: 'dataSource',
    get: function get() {
      return this.dataSourceBase.clone();
    }
  }, {
    key: 'sessionId',
    get: function get() {
      return this.getParam('sessionId');
    }
  }]);

  return BaseLogger;
}();

exports.default = BaseLogger;
var phasesConfigValues = exports.phasesConfigValues = {
  SEND_ON_START: 'SEND_ON_START',
  SEND_ON_FINISH: 'SEND_ON_FINISH',
  SEND_ON_APP_LOADED: 'SEND_ON_APP_LOADED'
};

/***/ }),

/***/ 362:
/*!*********************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/times/times.js ***!
  \*********************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _appData = __webpack_require__(/*! ../app-data/app-data */ 133);

var _performance = __webpack_require__(/*! ../performance/performance */ 75);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Times = function () {
  function Times(appName) {
    _classCallCheck(this, Times);

    this.appName = appName;
    this.apps = {};
    this.apps[appName] = {};
  }

  Times.prototype._getKeyForApp = function _getKeyForApp() {
    var appId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.appName;
    var widgetId = arguments[1];

    return widgetId ? appId + '_' + widgetId : appId;
  };

  Times.prototype.setLoadStarted = function setLoadStarted() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        appId = _ref.appId,
        widgetId = _ref.widgetId;

    var key = this._getKeyForApp(appId, widgetId);

    if (!this.apps[key]) {
      this.apps[key] = {};
    }

    this.apps[key].startLoadTime = _performance2.default.now();
  };

  Times.prototype.getLoadStartTime = function getLoadStartTime() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        appId = _ref2.appId,
        widgetId = _ref2.widgetId;

    var key = this._getKeyForApp(appId, widgetId);
    return Math.floor(this.apps[key] && this.apps[key].startLoadTime || (0, _appData.getStartLoadTime)(key) || 0);
  };

  Times.prototype.getAppLoadTime = function getAppLoadTime() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        appId = _ref3.appId,
        widgetId = _ref3.widgetId;

    var key = this._getKeyForApp(appId, widgetId);
    return Math.floor(_performance2.default.now() - this.getLoadStartTime(key));
  };

  Times.prototype.getFirstRequestDuration = function getFirstRequestDuration() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        appId = _ref4.appId,
        widgetId = _ref4.widgetId;

    return this.getLoadStartTime({ appId: appId, widgetId: widgetId });
  };

  return Times;
}();

exports.default = Times;

/***/ }),

/***/ 363:
/*!*********************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/data-source/data-source.js ***!
  \*********************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dataItem = __webpack_require__(/*! ../data-items/common/data-item */ 49);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Data accumulator
 */
var DataSource = function () {
  function DataSource() {
    var _this = this;

    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, DataSource);

    this.items = [];

    if (item) {
      (typeof item.length === 'undefined' ? [item] : item).forEach(function (item) {
        return _this.addItem(item);
      });
    }
  }

  /**
   * Creates a new DataSource instance and clones internal state.
   *
   * @returns {DataSource}
   */


  DataSource.prototype.clone = function clone() {
    return new DataSource(this.items.slice());
  };

  /**
   * Adds a new item.
   *
   * @param {Object | DataItem} item
   *
   * @return {DataSource} self
   */


  DataSource.prototype.addItem = function addItem(item) {
    this.items.push(item instanceof _dataItem2.default ? item : new _dataItem2.default(item));

    return this;
  };

  /**
   * Merges all added items into one plain object.
   *
   * @returns {Object}
   */


  DataSource.prototype.mergeItems = function mergeItems() {
    var res = {};

    for (var i = 0; i < this.items.length; i++) {
      var item = this.items[i];

      if (!item.isActive()) {
        res = null;
        break;
      }

      var data = item.export();

      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          // eslint-disable-line
          res[key] = data[key];
        }
      }
    }

    return res;
  };

  return DataSource;
}();

exports.default = DataSource;

/***/ }),

/***/ 364:
/*!*******************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/data-items/resource/resource-item.js ***!
  \*******************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _biBaseItem = __webpack_require__(/*! ../common/bi-base-item */ 50);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

var _location = __webpack_require__(/*! ../../app-data/location */ 222);

var _location2 = _interopRequireDefault(_location);

var _performance = __webpack_require__(/*! ../../performance/performance */ 75);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESOURCES_TYPES = {
  xmlhttprequest: {
    count: 'countXhr',
    unsupported: 'unsprtXhr',
    duration: 'timeXhr',
    total: 'sizeXhr',
    longest: 'longXhr',
    http2: 'h2Xhr'
  },
  script: {
    count: 'countJs',
    unsupported: 'unsprtJs',
    duration: 'timeJs',
    total: 'sizeJs',
    cached: 'cachedJs',
    http2: 'h2Js'
  },
  link: {
    // css
    count: 'countCss',
    unsupported: 'unsprtCss',
    duration: 'timeCss',
    total: 'sizeCss',
    cached: 'cachedCss',
    http2: 'h2Css'
  },
  img: {
    count: 'countImg',
    unsupported: 'unsprtImg',
    duration: 'timeImg',
    total: 'sizeImg',
    cached: 'cachedImages',
    http2: 'h2Images'
  }
};

var CUSTOM_VALIDATORS = {
  link: function link(resource) {
    return (/(.\.css$|.\.css?.)/g.test(resource.name)
    );
  }
};

var durationOf = function durationOf(item) {
  return item.responseEnd - item.startTime;
};

function filterResourcesByType(resources, type) {
  var validator = CUSTOM_VALIDATORS[type];
  return resources.filter(function (r) {
    return type === r.initiatorType && (validator ? validator(r) : true);
  });
}

function calculateTotalSizeOfResource(resources) {
  return resources.reduce(function (totalSize, resource) {
    return totalSize + resource.transferSize;
  }, 0);
}

function calculateResourceLoadLongestDuration(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var longest = resources.reduce(function (acc, cur) {
    return durationOf(cur) >= durationOf(acc) ? cur : acc;
  });
  return durationOf(longest);
}

function calculateResourceLoadDuration(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var loadStartStop = {
    startTime: Infinity,
    responseEnd: 0
  };
  resources.forEach(function (r) {
    if (loadStartStop.startTime > r.startTime) {
      loadStartStop.startTime = r.startTime;
    }
    if (loadStartStop.responseEnd < r.responseEnd) {
      loadStartStop.responseEnd = r.responseEnd;
    }
  });
  return loadStartStop.responseEnd - loadStartStop.startTime;
}

function calculatePercentageOfUnsupportedResources(resources) {
  var totalCount = resources.length;
  if (totalCount === 0) {
    return 0;
  }
  var unsupportedCount = resources.filter(isResourceUnsupported).length;
  return Math.round(unsupportedCount / totalCount * 100);
}

function calculateCachedResourcesPercentage(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var cached = resources.filter(function (r) {
    return r.transferSize === 0;
  });
  return Math.round(cached.length / resources.length * 100);
}

function calculatePercentageOfHttp2(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var supported = false;
  var res = Math.round(resources.filter(function (r) {
    supported = supported || 'nextHopProtocol' in r;
    return r.nextHopProtocol === 'h2';
  }).length / resources.length * 100);
  return supported ? res : NaN;
}

function isResourceRelevant(resource) {
  return !resource.name.match(/http(s)?:\/\/frog.wix.com\//);
}

function isResourceUnsupported(resource) {
  return isCORS(resource.name) && resource.transferSize === 0 && resource.requestStart === 0;
}

function isCORS(resourceName) {
  var host = _location2.default.getHost();
  return host && resourceName.indexOf(host) === -1;
}

function normalizeValues(analysis) {
  return Object.keys(analysis).reduce(function (result, key) {
    var n = parseInt(analysis[key]);
    if (!isNaN(n) && typeof n === 'number') {
      result[key] = n;
    }
    return result;
  }, {});
}

function countAllResourcesByType(resources) {
  var supportedResources = resources.filter(function (r) {
    return !isResourceUnsupported(r);
  });
  return Object.keys(RESOURCES_TYPES).reduce(function (result, currentType) {
    var allSameTypeResources = filterResourcesByType(resources, currentType);
    var supportedSameTypeResources = filterResourcesByType(supportedResources, currentType);
    var type = RESOURCES_TYPES[currentType];
    result[type.count] = supportedSameTypeResources.length;
    result[type.duration] = calculateResourceLoadDuration(supportedSameTypeResources);
    result[type.total] = calculateTotalSizeOfResource(supportedSameTypeResources);
    result[type.unsupported] = calculatePercentageOfUnsupportedResources(allSameTypeResources);
    result[type.http2] = calculatePercentageOfHttp2(allSameTypeResources);
    if (type.longest) {
      result[type.longest] = calculateResourceLoadLongestDuration(supportedSameTypeResources);
    }
    if (type.cached) {
      result[type.cached] = calculateCachedResourcesPercentage(supportedSameTypeResources);
    }
    return result;
  }, {});
}

function extractResourceMetrics(resource) {
  return {
    url: resource.name,
    downloadDuration: resource.responseEnd - resource.startTime,
    bytesTransferred: resource.transferSize,
    isHTTP2: resource.nextHopProtocol === 'h2'
  };
}

function getResourcesBreakdown(resources) {
  var resourcesPartition = resources.reduce(function (result, r) {
    if (isResourceUnsupported(r)) {
      result.unsupported.push(r);
    } else {
      result.supported.push(r);
    }
    return result;
  }, { supported: [], unsupported: [] });
  return Object.keys(RESOURCES_TYPES).reduce(function (result, currentType) {
    result[currentType] = {};
    result[currentType].supported = filterResourcesByType(resourcesPartition.supported, currentType).map(function (r) {
      return extractResourceMetrics(r);
    });
    result[currentType].unsupported = filterResourcesByType(resourcesPartition.unsupported, currentType).map(function (r) {
      return extractResourceMetrics(r);
    });
    return result;
  }, {});
}

var ResourceDataItem = function (_BiBaseDataItem) {
  _inherits(ResourceDataItem, _BiBaseDataItem);

  function ResourceDataItem(sessionId) {
    _classCallCheck(this, ResourceDataItem);

    return _possibleConstructorReturn(this, _BiBaseDataItem.call(this, 18, sessionId));
  }

  ResourceDataItem.prototype.performNetworkAnalysis = function performNetworkAnalysis(resources) {
    if (resources.length === 0) {
      return null;
    }
    var t0 = _performance2.default.now();
    var resourcesToHandle = resources.filter(isResourceRelevant);
    var analysis = countAllResourcesByType(resourcesToHandle);
    analysis.overhead = _performance2.default.now() - t0;
    var result = normalizeValues(analysis);
    if (console.debug && _location2.default.isFedopsDev()) {
      var resourcesBreakdown = getResourcesBreakdown(resourcesToHandle);
      console.debug('[fedops network analysis] [bytes analysis]\n' + JSON.stringify(result, null, 4));
      console.debug('[fedops network analysis] [resources breakdown]\n', resourcesBreakdown);
    }
    return result;
  };

  return ResourceDataItem;
}(_biBaseItem2.default);

exports.default = ResourceDataItem;

/***/ }),

/***/ 365:
/*!************************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/data-items/app-load/bi-load-start-item.js ***!
  \************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.APP_LOAD_START_EVID = undefined;

var _biBaseItem = __webpack_require__(/*! ../common/bi-base-item */ 50);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var APP_LOAD_START_EVID = exports.APP_LOAD_START_EVID = 14;

/**
 * Represents the "load started" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/14
 *
 * It should be used to monitor the initial application load.
 */

var BiLoadStartDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadStartDataItem, _BiBaseDataItem);

  function BiLoadStartDataItem(sessionId) {
    _classCallCheck(this, BiLoadStartDataItem);

    return _possibleConstructorReturn(this, _BiBaseDataItem.call(this, APP_LOAD_START_EVID, sessionId));
  }

  return BiLoadStartDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadStartDataItem;

/***/ }),

/***/ 366:
/*!**********************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/data-items/phases/bi-load-phase-item.js ***!
  \**********************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PHASE_END_EVID = undefined;

var _biBaseItem = __webpack_require__(/*! ../common/bi-base-item */ 50);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PHASE_END_EVID = exports.PHASE_END_EVID = 13;

/**
 * Represents the "load phase" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13
 *
 * It should be used to monitor custom application load phases.
 */

var BiLoadPhaseDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadPhaseDataItem, _BiBaseDataItem);

  function BiLoadPhaseDataItem(sessionId) {
    _classCallCheck(this, BiLoadPhaseDataItem);

    return _possibleConstructorReturn(this, _BiBaseDataItem.call(this, PHASE_END_EVID, sessionId));
  }

  return BiLoadPhaseDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadPhaseDataItem;

/***/ }),

/***/ 367:
/*!*******************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/data-items/duration/duration-item.js ***!
  \*******************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dataItem = __webpack_require__(/*! ../common/data-item */ 49);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DurationDataItem = function (_DataItem) {
  _inherits(DurationDataItem, _DataItem);

  function DurationDataItem(duration) {
    _classCallCheck(this, DurationDataItem);

    return _possibleConstructorReturn(this, _DataItem.call(this, {
      duration: duration
    }));
  }

  DurationDataItem.prototype.setFirstRequestDuration = function setFirstRequestDuration(firstRequestDuration) {
    this.data.frd = firstRequestDuration;
    return this;
  };

  return DurationDataItem;
}(_dataItem2.default);

exports.default = DurationDataItem;

/***/ }),

/***/ 368:
/*!*****************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/data-items/common/bi-error-item.js ***!
  \*****************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EVID = undefined;

var _biBaseItem = __webpack_require__(/*! ./bi-base-item */ 50);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EVID = exports.EVID = 17;
/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiErrorItem = function (_BiBaseDataItem) {
  _inherits(BiErrorItem, _BiBaseDataItem);

  function BiErrorItem(sessionId) {
    _classCallCheck(this, BiErrorItem);

    return _possibleConstructorReturn(this, _BiBaseDataItem.call(this, EVID, sessionId));
  }

  return BiErrorItem;
}(_biBaseItem2.default);

exports.default = BiErrorItem;

/***/ }),

/***/ 369:
/*!*******************************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/data-items/phases/loading-phase-item-prefixed.js ***!
  \*******************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _loadingPhaseItem = __webpack_require__(/*! ./loading-phase-item */ 223);

var _loadingPhaseItem2 = _interopRequireDefault(_loadingPhaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var prefix = function prefix(name, index) {
  return ('0' + index).slice(-2) + '_' + name;
};

var LoadingPhaseItemPrefixed = function (_LoadingPhaseItem) {
  _inherits(LoadingPhaseItemPrefixed, _LoadingPhaseItem);

  function LoadingPhaseItemPrefixed(_ref) {
    var name = _ref.name,
        index = _ref.index,
        phaseStartTime = _ref.phaseStartTime;

    _classCallCheck(this, LoadingPhaseItemPrefixed);

    var _this = _possibleConstructorReturn(this, _LoadingPhaseItem.call(this, { name: name, index: index, phaseStartTime: phaseStartTime }));

    _this.data.name = prefix(name, index);
    return _this;
  }

  return LoadingPhaseItemPrefixed;
}(_loadingPhaseItem2.default);

exports.default = LoadingPhaseItemPrefixed;

/***/ }),

/***/ 370:
/*!*********************************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/data-items/phases/loading-phase-collection-item.js ***!
  \*********************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dataItem = __webpack_require__(/*! ../common/data-item */ 49);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingPhaseCollectionItem = function (_DataItem) {
  _inherits(LoadingPhaseCollectionItem, _DataItem);

  function LoadingPhaseCollectionItem(phasesOfApp) {
    _classCallCheck(this, LoadingPhaseCollectionItem);

    var _this = _possibleConstructorReturn(this, _DataItem.call(this, {}));

    _this.data.phases = LoadingPhaseCollectionItem.mergePhasesWithoutIndex(phasesOfApp);
    _this.data.phases = JSON.stringify(_this.data.phases);
    return _this;
  }

  LoadingPhaseCollectionItem.mergePhasesWithoutIndex = function mergePhasesWithoutIndex(phasesOfApp) {
    var phases = {};
    for (var _iterator = phasesOfApp, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var phase = _ref;

      LoadingPhaseCollectionItem.deleteIndexFrom(phase);
      phases = Object.assign(phases, phase);
    }
    return phases;
  };

  LoadingPhaseCollectionItem.deleteIndexFrom = function deleteIndexFrom(phase) {
    delete phase[Object.getOwnPropertyNames(phase)[0]].index;
  };

  return LoadingPhaseCollectionItem;
}(_dataItem2.default);

exports.default = LoadingPhaseCollectionItem;

/***/ }),

/***/ 371:
/*!*************************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/data-items/app-load/bi-load-finish-item.js ***!
  \*************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.APP_LOAD_FINISH_EVID = undefined;

var _biBaseItem = __webpack_require__(/*! ../common/bi-base-item */ 50);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var APP_LOAD_FINISH_EVID = exports.APP_LOAD_FINISH_EVID = 11;

/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiLoadFinishDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadFinishDataItem, _BiBaseDataItem);

  function BiLoadFinishDataItem(sessionId) {
    _classCallCheck(this, BiLoadFinishDataItem);

    return _possibleConstructorReturn(this, _BiBaseDataItem.call(this, APP_LOAD_FINISH_EVID, sessionId));
  }

  return BiLoadFinishDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadFinishDataItem;

/***/ }),

/***/ 372:
/*!**********************************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/data-items/interaction/bi-interaction-start-item.js ***!
  \**********************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.INTERACTION_START_EVID = undefined;

var _biBaseItem = __webpack_require__(/*! ../common/bi-base-item */ 50);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INTERACTION_START_EVID = exports.INTERACTION_START_EVID = 15;
/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiInteractionStartDataItem = function (_BiBaseDataItem) {
  _inherits(BiInteractionStartDataItem, _BiBaseDataItem);

  function BiInteractionStartDataItem(sessionId) {
    _classCallCheck(this, BiInteractionStartDataItem);

    return _possibleConstructorReturn(this, _BiBaseDataItem.call(this, INTERACTION_START_EVID, sessionId));
  }

  return BiInteractionStartDataItem;
}(_biBaseItem2.default);

exports.default = BiInteractionStartDataItem;

/***/ }),

/***/ 373:
/*!********************************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/data-items/interaction/bi-interaction-end-item.js ***!
  \********************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.INTERACTION_END_EVID = undefined;

var _biBaseItem = __webpack_require__(/*! ../common/bi-base-item */ 50);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INTERACTION_END_EVID = exports.INTERACTION_END_EVID = 16;

/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiInteractionEndDataItem = function (_BiBaseDataItem) {
  _inherits(BiInteractionEndDataItem, _BiBaseDataItem);

  function BiInteractionEndDataItem(sessionId) {
    _classCallCheck(this, BiInteractionEndDataItem);

    return _possibleConstructorReturn(this, _BiBaseDataItem.call(this, INTERACTION_END_EVID, sessionId));
  }

  return BiInteractionEndDataItem;
}(_biBaseItem2.default);

exports.default = BiInteractionEndDataItem;

/***/ }),

/***/ 374:
/*!***********************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/data-items/common/bi-app-context-item.js ***!
  \***********************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dataItem = __webpack_require__(/*! ./data-item */ 49);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BiAppContextDataItem = function (_DataItem) {
  _inherits(BiAppContextDataItem, _DataItem);

  function BiAppContextDataItem(_ref) {
    var appId = _ref.appId,
        widgetId = _ref.widgetId,
        isServerSide = _ref.isServerSide,
        widgetArray = _ref.widgetArray;

    _classCallCheck(this, BiAppContextDataItem);

    var _this = _possibleConstructorReturn(this, _DataItem.call(this));

    _this.data = _this._filterUndefined({
      appId: appId,
      widgetId: widgetId,
      isServerSide: isServerSide,
      widgetArray: widgetArray
    });
    return _this;
  }

  BiAppContextDataItem.prototype._filterUndefined = function _filterUndefined(contextData) {
    var definedValues = {};
    Object.keys(contextData).forEach(function (key) {
      if (contextData[key]) {
        definedValues[key] = contextData[key];
      }
    });
    return definedValues;
  };

  return BiAppContextDataItem;
}(_dataItem2.default);

exports.default = BiAppContextDataItem;

/***/ }),

/***/ 375:
/*!*****************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/session-manager/session-manager.js ***!
  \*****************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _storage = __webpack_require__(/*! ../storage/storage */ 376);

var _storage2 = _interopRequireDefault(_storage);

var _conf = __webpack_require__(/*! ../conf */ 94);

var _env = __webpack_require__(/*! ../env */ 48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sessionManager = {
  getSessionId: function getSessionId() {
    var res = typeof (0, _env.env)() !== 'undefined' && (0, _env.env)().fedops && (0, _env.env)().fedops.sessionId;

    res = res || _storage2.default.getItem(_conf.SESSION_ID_STORAGE_KEY);
    res = res || this.generateGuid();

    _storage2.default.setItem(_conf.SESSION_ID_STORAGE_KEY, res);
    return res;
  },
  generateGuid: function generateGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c === 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line
      return v.toString(16);
    });
  }
};

exports.default = sessionManager;

/***/ }),

/***/ 376:
/*!*************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/storage/storage.js ***!
  \*************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _env = __webpack_require__(/*! ../env */ 48);

/**
 * Local storage wrapper (for tests mainly)
 */
exports.default = {
  getItem: function getItem(key) {
    try {
      return (0, _env.env)().localStorage && (0, _env.env)().localStorage.getItem(key);
    } catch (e) {}
  },
  setItem: function setItem(key, value) {
    try {
      return (0, _env.env)().localStorage && (0, _env.env)().localStorage.setItem(key, value);
    } catch (e) {}
  }
};

/***/ }),

/***/ 377:
/*!***************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/loading-phases/loading-phases.js ***!
  \***************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.CODE_PARSING_PHASE_NAME = undefined;

var _appData = __webpack_require__(/*! ../app-data/app-data */ 133);

var _performance = __webpack_require__(/*! ../performance/performance */ 75);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CODE_PARSING_PHASE_NAME = exports.CODE_PARSING_PHASE_NAME = 'codeParsingPhase';

var LoadingPhases = function () {
  function LoadingPhases(appName) {
    _classCallCheck(this, LoadingPhases);

    this.appName = appName;
    this.phases = new Map();
    this.indexToKey = new Map();
  }

  LoadingPhases._getIndexForPhase = function _getIndexForPhase(_ref) {
    var name = _ref.name,
        _ref$appId = _ref.appId,
        appId = _ref$appId === undefined ? '' : _ref$appId,
        _ref$widgetId = _ref.widgetId,
        widgetId = _ref$widgetId === undefined ? '' : _ref$widgetId;

    return name + '_' + appId + '_' + widgetId;
  };

  LoadingPhases.prototype.getAppLoadingPhaseData = function getAppLoadingPhaseData(_ref2) {
    var name = _ref2.name,
        appId = _ref2.appId,
        widgetId = _ref2.widgetId;

    return this.phases.get(LoadingPhases._getIndexForPhase({ name: name, appId: appId, widgetId: widgetId }));
  };

  LoadingPhases.prototype.saveLoadingPhase = function saveLoadingPhase(_ref3) {
    var name = _ref3.name,
        appId = _ref3.appId,
        widgetId = _ref3.widgetId;

    var phaseKey = LoadingPhases._getIndexForPhase({ name: name, appId: appId, widgetId: widgetId });

    if (!this.phases.has(phaseKey)) {
      var index = this.phases.size;
      this.phases.set(phaseKey, {
        name: name,
        phaseStartTime: _performance2.default.now(),
        index: index
      });

      this.indexToKey.set(index, phaseKey);
    }
  };

  LoadingPhases.prototype.endLoadingPhase = function endLoadingPhase(_ref4) {
    var name = _ref4.name,
        appId = _ref4.appId,
        widgetId = _ref4.widgetId,
        widgetArray = _ref4.widgetArray;

    var phaseKey = LoadingPhases._getIndexForPhase({ name: name, appId: appId, widgetId: widgetId });
    if (!this.phases.has(phaseKey) || this.phases.get(phaseKey).duration) {
      return;
    }

    var phase = this.phases.get(phaseKey);
    phase.duration = _performance2.default.now() - phase.phaseStartTime;

    if (widgetArray) {
      phase.widgetArray = widgetArray;
    }
    if (widgetId) {
      phase.widgetId = widgetId;
    }

    this.phases.set(phaseKey, phase);
  };

  LoadingPhases.prototype.getNextPhaseToReport = function getNextPhaseToReport() {
    var latestStepIndex = this.phases.size - 1;
    var lastPhaseKey = this.indexToKey.get(latestStepIndex);
    return this.phases.get(lastPhaseKey);
  };

  LoadingPhases.prototype.getPhasePreviousTo = function getPhasePreviousTo(_ref5) {
    var name = _ref5.name,
        appId = _ref5.appId,
        widgetId = _ref5.widgetId;

    var currentPhase = this.phases.get(LoadingPhases._getIndexForPhase({ name: name, appId: appId, widgetId: widgetId }));
    var previousPhaseIndex = this.indexToKey.get(currentPhase.index - 1);
    return this.phases.get(previousPhaseIndex);
  };

  LoadingPhases.prototype.getPhases = function getPhases() {
    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        appId = _ref6.appId;

    var phaseToNamedPhaseObject = function phaseToNamedPhaseObject(phase) {
      var _ref7;

      return _ref7 = {}, _ref7[phase.name] = phase, _ref7;
    };

    return Array.from(this.phases).filter(function (_ref8) {
      var phaseKey = _ref8[0];

      var _phaseKey$split = phaseKey.split('_'),
          appIdOfPhase = _phaseKey$split[1];

      return appId && appIdOfPhase === appId || !appId;
    }).map(function (_ref9) {
      var phase = _ref9[1];
      return phaseToNamedPhaseObject(phase);
    });
  };

  LoadingPhases.prototype.createCodeParsingPhaseIfNotExist = function createCodeParsingPhaseIfNotExist() {
    var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        appId = _ref10.appId,
        widgetId = _ref10.widgetId;

    var phaseKey = LoadingPhases._getIndexForPhase({
      name: CODE_PARSING_PHASE_NAME,
      appId: appId,
      widgetId: widgetId
    });

    if (!this.phases.has(phaseKey)) {
      this.phases.set(phaseKey, {
        phaseStartTime: (0, _appData.getStartLoadTime)(this.appName),
        index: 0,
        name: CODE_PARSING_PHASE_NAME
      });

      this.indexToKey.set(0, phaseKey);
    }
  };

  return LoadingPhases;
}();

exports.default = LoadingPhases;

/***/ }),

/***/ 378:
/*!****************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-adapters-reporting/dist/src/fedops/fedops.const.js ***!
  \****************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.FEDOPS_APP_NAME_OOI_SUFFIX = '-ooi';
exports.FEDOPS_APP_NAME_SSR_SUFFIX = '-ssr';
//# sourceMappingURL=fedops.const.js.map

/***/ }),

/***/ 379:
/*!*****************************************************************************!*\
  !*** ../node_modules/data-capsule/dist/src/utils/frame-storage-listener.js ***!
  \*****************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var listenerMessageChannel = __webpack_require__(/*! message-channel/listener */ 380);
var greedySplit = __webpack_require__(/*! greedy-split */ 229);
var BaseStorage = __webpack_require__(/*! ../base-storage */ 40);
var LocalStorageStrategy = __webpack_require__(/*! ../strategies/local-storage */ 135);

var FrameStorageListener = function () {
  function FrameStorageListener() {
    var strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new LocalStorageStrategy();

    _classCallCheck(this, FrameStorageListener);

    this.storageStrategy = BaseStorage.verify(strategy);
    this.stopListener;
  }

  _createClass(FrameStorageListener, [{
    key: 'start',
    value: function start(verifier, interceptor) {
      if (!verifier || typeof verifier !== 'function') {
        throw new Error('start function must get a verifier function as a first argument');
      }

      if (interceptor && typeof interceptor !== 'function') {
        throw new Error('the interceptor must be a function');
      }

      var storageStrategy = BaseStorage.verify(this.storageStrategy);
      this.stopListener = listenerMessageChannel('data-capsule', messageHandler);

      function messageHandler(e, reply) {
        if (typeof e.data !== 'string') {
          return;
        }

        var _greedySplit = greedySplit(e.data, '|', 3),
            _greedySplit2 = _slicedToArray(_greedySplit, 3),
            token = _greedySplit2[0],
            method = _greedySplit2[1],
            payload = _greedySplit2[2];

        var respond = function respond(status, data) {
          if (status === 'resolve') {
            var _response = [status, JSON.stringify({ data: data })].join('|');
            return reply(_response);
          }

          var response = [status, data].join('|');
          return reply(response);
        };

        if (!verifier(e.source, e.origin, token)) {
          return respond('reject', 'message was not authorized');
        }

        var invoke = storageStrategy[method].bind(storageStrategy);

        var params = JSON.parse(payload).data;
        var options = params[params.length - 1];

        var modifiedOptions = interceptor ? interceptor(options, e.source, e.origin, token) : options;
        params[params.length - 1] = modifiedOptions;

        return invoke.apply(undefined, _toConsumableArray(params)).then(function (result) {
          return respond('resolve', result);
        }).catch(function (error) {
          return respond('reject', error.message || error);
        });
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.stopListener && this.stopListener();
    }
  }]);

  return FrameStorageListener;
}();

module.exports = FrameStorageListener;

/***/ }),

/***/ 380:
/*!***************************************************!*\
  !*** ../node_modules/message-channel/listener.js ***!
  \***************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./dist/src/listener/listener */ 381);


/***/ }),

/***/ 381:
/*!*********************************************************************!*\
  !*** ../node_modules/message-channel/dist/src/listener/listener.js ***!
  \*********************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _constants = __webpack_require__(/*! ../constants */ 134);

var _utils = __webpack_require__(/*! ../utils */ 96);

var _listenFactory = __webpack_require__(/*! ./listen-factory */ 382);

var _listenFactory2 = _interopRequireDefault(_listenFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isMessageRelevant(message, scope) {
  try {
    return (0, _utils.parseConnectionMessage)(message) === scope;
  } catch (e) {
    return false;
  }
}

function getMessagePort(e) {
  try {
    return e.ports[0];
  } catch (e) {}
}

function authorizeConnection(port) {
  port.postMessage(_constants.connectionSuccessMsg);
}

var noop = function noop() {};

function listener(scope) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

  if (!scope || typeof scope !== 'string') {
    throw new Error('listener function expects to recieve a scope<string> as a first argument');
  }

  var _listener = function _listener(e) {
    if (isMessageRelevant(e.data, scope)) {
      var port = getMessagePort(e);
      if (port) {
        authorizeConnection(port);
        (0, _listenFactory2.default)(port, callback);
      }
    }
  };

  window.addEventListener('message', _listener);
  return function () {
    return window.removeEventListener('message', _listener);
  };
}

module.exports = listener;

/***/ }),

/***/ 382:
/*!***************************************************************************!*\
  !*** ../node_modules/message-channel/dist/src/listener/listen-factory.js ***!
  \***************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = listenFactory;

var _utils = __webpack_require__(/*! ../utils */ 96);

function listenFactory(port, callback) {
  port.onmessage = function (e) {
    var originalMessage = e.data;

    var _parseChannelMessage = (0, _utils.parseChannelMessage)(originalMessage),
        id = _parseChannelMessage.id,
        payload = _parseChannelMessage.payload;

    var reply = function reply(replyMessage) {
      port.postMessage((0, _utils.constructChannelMessage)(replyMessage, id));
    };

    var modifiedEvent = {
      data: payload,
      origin: e.origin,
      lastEventId: e.lastEventId,
      source: e.source,
      ports: e.ports
    };

    callback(modifiedEvent, reply);
  };
}

/***/ }),

/***/ 383:
/*!****************************************************************************!*\
  !*** ../node_modules/data-capsule/dist/src/utils/local-storage-cleaner.js ***!
  \****************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global localStorage */


var _require = __webpack_require__(/*! ./record-utils */ 230),
    getCacheRecords = _require.getCacheRecords,
    isExpired = _require.isExpired;

function deleteRecord(cleaner) {
  var record = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : cleaner.records[0];

  localStorage.removeItem(record.originalKey);
  return {
    records: record === cleaner.records[0] ? cleaner.records.slice(1) : cleaner.records.filter(function (_ref) {
      var originalKey = _ref.originalKey;
      return originalKey !== record.originalKey;
    }),
    requiredSpace: cleaner.requiredSpace - record.size
  };
}

function deleteExpired(cleaner) {
  var expiredRecords = cleaner.records.filter(function (record) {
    return isExpired(record);
  });
  expiredRecords.forEach(function (record) {
    return cleaner = deleteRecord(cleaner, record);
  });
  return cleaner;
}

function lastUsedSort(a, b) {
  return a.lastUsed - b.lastUsed;
}

function canClean(cleaner) {
  return cleaner.records.length > 0 && cleaner.requiredSpace > 0;
}

function deleteOld(cleaner) {
  cleaner.records.sort(lastUsedSort);
  while (canClean(cleaner)) {
    cleaner = deleteRecord(cleaner);
  }
  return cleaner;
}

function localStorageCleaner(requiredSpace) {
  var cleaner = { records: getCacheRecords(), requiredSpace: requiredSpace };
  cleaner = deleteExpired(cleaner);
  deleteOld(cleaner);
}

module.exports = localStorageCleaner;

/***/ }),

/***/ 384:
/*!*************************************************************************!*\
  !*** ../node_modules/data-capsule/dist/src/strategies/frame-storage.js ***!
  \*************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var greedySplit = __webpack_require__(/*! greedy-split */ 229);
var connectMessageChannel = __webpack_require__(/*! message-channel/connect */ 385);
var BaseStorage = __webpack_require__(/*! ../base-storage */ 40);

var _require = __webpack_require__(/*! ../utils/constants */ 51),
    CONNECTION_MAX_TIMEOUT = _require.CONNECTION_MAX_TIMEOUT,
    MESSAGE_MAX_TIMEOUT = _require.MESSAGE_MAX_TIMEOUT,
    toError = _require.toError;

var FrameStorageStrategy = function (_BaseStorage) {
  _inherits(FrameStorageStrategy, _BaseStorage);

  function FrameStorageStrategy(target, origin, token) {
    var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, FrameStorageStrategy);

    var _this = _possibleConstructorReturn(this, (FrameStorageStrategy.__proto__ || Object.getPrototypeOf(FrameStorageStrategy)).call(this));

    _this.target = target;
    _this.origin = origin;
    _this.token = token;
    _this.channel;
    _this.opts = opts;
    var _this$opts = _this.opts,
        _this$opts$connection = _this$opts.connectionMaxTimeout,
        connectionMaxTimeout = _this$opts$connection === undefined ? CONNECTION_MAX_TIMEOUT : _this$opts$connection,
        _this$opts$messageMax = _this$opts.messageMaxTimeout,
        messageMaxTimeout = _this$opts$messageMax === undefined ? MESSAGE_MAX_TIMEOUT : _this$opts$messageMax;

    _this.connectionMaxTimeout = connectionMaxTimeout;
    _this.messageMaxTimeout = messageMaxTimeout;
    return _this;
  }

  _createClass(FrameStorageStrategy, [{
    key: 'getChannel',
    value: function getChannel() {
      var _this2 = this;

      if (this.channel) {
        return Promise.resolve(this.channel);
      }

      return connectMessageChannel('data-capsule', {
        target: this.target,
        origin: this.origin,
        connectionMaxTimeout: this.connectionMaxTimeout,
        messageMaxTimeout: this.messageMaxTimeout
      }).then(function (channel) {
        _this2.channel = channel;
        return channel;
      });
    }
  }, {
    key: 'sendCommand',
    value: function sendCommand(method, params) {
      var _this3 = this;

      var payload = { data: params };

      return this.getChannel().then(function (sendToChannel) {
        var message = [_this3.token, method, JSON.stringify(payload)].join('|');

        return sendToChannel(message).then(function (e) {
          var _greedySplit = greedySplit(e.data, '|', 2),
              _greedySplit2 = _slicedToArray(_greedySplit, 2),
              status = _greedySplit2[0],
              payload = _greedySplit2[1];

          if (status === 'reject') {
            throw toError(payload);
          }

          return JSON.parse(payload).data;
        });
      });
    }
  }, {
    key: 'setItem',
    value: function setItem() {
      for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      return this.sendCommand('setItem', params);
    }
  }, {
    key: 'getItem',
    value: function getItem() {
      for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        params[_key2] = arguments[_key2];
      }

      return this.sendCommand('getItem', params);
    }
  }, {
    key: 'removeItem',
    value: function removeItem() {
      for (var _len3 = arguments.length, params = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        params[_key3] = arguments[_key3];
      }

      return this.sendCommand('removeItem', params);
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems() {
      for (var _len4 = arguments.length, params = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        params[_key4] = arguments[_key4];
      }

      return this.sendCommand('getAllItems', params);
    }
  }]);

  return FrameStorageStrategy;
}(BaseStorage);

module.exports = FrameStorageStrategy;

/***/ }),

/***/ 385:
/*!**************************************************!*\
  !*** ../node_modules/message-channel/connect.js ***!
  \**************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./dist/src/connect/connect */ 386);


/***/ }),

/***/ 386:
/*!*******************************************************************!*\
  !*** ../node_modules/message-channel/dist/src/connect/connect.js ***!
  \*******************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _constants = __webpack_require__(/*! ../constants */ 134);

var _utils = __webpack_require__(/*! ../utils */ 96);

var _sendFactory = __webpack_require__(/*! ./send-factory */ 387);

var _sendFactory2 = _interopRequireDefault(_sendFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function connect(scope) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$targetOrigin = options.targetOrigin,
      targetOrigin = _options$targetOrigin === undefined ? '*' : _options$targetOrigin,
      _options$connectionMa = options.connectionMaxTimeout,
      connectionMaxTimeout = _options$connectionMa === undefined ? _constants.deafultConnectionMaxTimeout : _options$connectionMa,
      _options$messageMaxTi = options.messageMaxTimeout,
      messageMaxTimeout = _options$messageMaxTi === undefined ? _constants.deafultMessageMaxTimeout : _options$messageMaxTi;


  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      reject(new Error('max timeout of ' + connectionMaxTimeout + 'ms exceeded'));
    }, connectionMaxTimeout);

    var channel = new window.MessageChannel();

    channel.port1.onmessage = function (e) {
      if (e.data === _constants.connectionSuccessMsg) {
        return resolve((0, _sendFactory2.default)(channel.port1, { messageMaxTimeout: messageMaxTimeout }));
      } else {
        reject(new Error('connection could not establise'));
      }
    };

    var connectionMessage = (0, _utils.constructConnectionMessage)(scope);
    window.parent.postMessage(connectionMessage, targetOrigin, [channel.port2]);
  });
}

module.exports = connect;

/***/ }),

/***/ 387:
/*!************************************************************************!*\
  !*** ../node_modules/message-channel/dist/src/connect/send-factory.js ***!
  \************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sendFactory;

var _utils = __webpack_require__(/*! ../utils */ 96);

var _v = __webpack_require__(/*! uuid/v4 */ 83);

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sendFactory(port, options) {
  var messageMaxTimeout = options.messageMaxTimeout;

  var messages = {};

  port.onmessage = function (e) {
    var _parseChannelMessage = (0, _utils.parseChannelMessage)(e.data),
        id = _parseChannelMessage.id,
        payload = _parseChannelMessage.payload;

    if (messages[id]) {
      var modifiedEvent = {
        data: payload,
        origin: e.origin,
        lastEventId: e.lastEventId,
        source: e.source,
        ports: e.ports
      };

      messages[id](modifiedEvent);
    }
  };

  return function (message, transferList) {
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        reject(new Error('max timeout of ' + messageMaxTimeout + 'ms exceeded'));
      }, messageMaxTimeout);

      var messageId = (0, _v2.default)();
      var packaged = (0, _utils.constructChannelMessage)(message, messageId);
      messages[messageId] = resolve;
      return port.postMessage(packaged, transferList);
    });
  };
}

/***/ }),

/***/ 388:
/*!***********************************************************************!*\
  !*** ../node_modules/data-capsule/dist/src/strategies/wix-storage.js ***!
  \***********************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global document */


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var axios = __webpack_require__(/*! axios */ 193);
var BaseStorage = __webpack_require__(/*! ../base-storage */ 40);

var _require = __webpack_require__(/*! ../utils/constants */ 51),
    NOT_FOUND = _require.NOT_FOUND,
    SERVER_ERROR = _require.SERVER_ERROR;

function getCookieValue(name) {
  if (typeof document === 'undefined') {
    return '';
  } else {
    return (document.cookie.match(name + '=([^;]*)') || ['']).pop();
  }
}

function getUserId() {
  var wixClient = getCookieValue('wixClient').split('|');
  return wixClient[6] || getCookieValue('_wixCIDX');
}

var WixStorageStrategy = function (_BaseStorage) {
  _inherits(WixStorageStrategy, _BaseStorage);

  function WixStorageStrategy() {
    _classCallCheck(this, WixStorageStrategy);

    return _possibleConstructorReturn(this, (WixStorageStrategy.__proto__ || Object.getPrototypeOf(WixStorageStrategy)).apply(this, arguments));
  }

  _createClass(WixStorageStrategy, [{
    key: 'extendScope',
    value: function extendScope(scope) {
      scope = typeof scope === 'string' ? { siteId: scope } : scope;
      return Object.assign({ userId: getUserId() }, scope);
    }
  }, {
    key: 'setItem',
    value: function setItem(key, value, options) {
      var payload = {
        nameSpace: options.namespace,
        key: key,
        blob: value
      };
      if (options.scope && options.scope.siteId) {
        payload.siteId = options.scope.siteId;
      }
      if (options.expiration) {
        payload.TTLInDays = Math.ceil(options.expiration / (60 * 60 * 24));
      }
      return axios.post('/_api/wix-user-preferences-webapp/set', payload).then(function () {
        return undefined;
      }).catch(function () {
        throw SERVER_ERROR;
      });
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key, options) {
      var payload = {
        nameSpace: options.namespace,
        key: key
      };
      if (options.scope && options.scope.siteId) {
        payload.siteId = options.scope.siteId;
      }
      return axios.post('/_api/wix-user-preferences-webapp/delete', payload).then(function () {
        return undefined;
      }).catch(function () {
        throw SERVER_ERROR;
      });
    }
  }, {
    key: 'getItem',
    value: function getItem(key, options) {
      var siteId = options.scope && options.scope.siteId;
      var path = siteId ? 'getVolatilePrefForSite' : 'getVolatilePrefForKey';
      var url = ['/_api/wix-user-preferences-webapp', path, options.namespace, siteId, key].filter(function (x) {
        return x;
      }).join('/');

      return axios.get(url).then(function (res) {
        return res.data[key];
      }).catch(function (err) {
        throw err.response.status === 404 ? NOT_FOUND : SERVER_ERROR;
      });
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems(options) {
      var siteId = options.scope && options.scope.siteId;
      var path = siteId ? 'getVolatilePrefsForSite' : 'getVolatilePrefs';
      var url = ['/_api/wix-user-preferences-webapp', path, options.namespace, siteId].filter(function (x) {
        return x;
      }).join('/');

      return axios.get(url).then(function (res) {
        return res.data;
      }).catch(function () {
        throw SERVER_ERROR;
      });
    }
  }]);

  return WixStorageStrategy;
}(BaseStorage);

module.exports = WixStorageStrategy;

/***/ }),

/***/ 389:
/*!**************************************************************************!*\
  !*** ../node_modules/data-capsule/dist/src/strategies/cached-storage.js ***!
  \**************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(/*! ../utils/constants */ 51),
    NOT_FOUND = _require.NOT_FOUND;

var BaseStorage = __webpack_require__(/*! ../base-storage */ 40);
var LocalStorageStrategy = __webpack_require__(/*! ./local-storage */ 135);
var DELETED = '___DELETED___';

var CachedStorageStrategy = function (_BaseStorage) {
  _inherits(CachedStorageStrategy, _BaseStorage);

  function CachedStorageStrategy(_ref) {
    var remoteStrategy = _ref.remoteStrategy,
        _ref$localStrategy = _ref.localStrategy,
        localStrategy = _ref$localStrategy === undefined ? new LocalStorageStrategy() : _ref$localStrategy;

    _classCallCheck(this, CachedStorageStrategy);

    var _this = _possibleConstructorReturn(this, (CachedStorageStrategy.__proto__ || Object.getPrototypeOf(CachedStorageStrategy)).call(this));

    _this.remoteStrategy = BaseStorage.verify(remoteStrategy);
    _this.localStrategy = BaseStorage.verify(localStrategy);
    return _this;
  }

  _createClass(CachedStorageStrategy, [{
    key: 'extendScope',
    value: function extendScope(scope) {
      return this.remoteStrategy.extendScope(scope);
    }
  }, {
    key: '_cacheItem',
    value: function _cacheItem(key, value, options) {
      return this.localStrategy.setItem(key, value, Object.assign(options, { expiration: 3600 }));
    }
  }, {
    key: 'setItem',
    value: function setItem(key, value, options) {
      var _this2 = this;

      return this.remoteStrategy.setItem(key, value, options).then(function () {
        return _this2._cacheItem(key, value, options);
      });
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key, options) {
      var _this3 = this;

      return this.remoteStrategy.removeItem(key, options).then(function () {
        return _this3._cacheItem(key, DELETED, options);
      });
    }
  }, {
    key: '_getRemoteAndCache',
    value: function _getRemoteAndCache(key, options) {
      var _this4 = this;

      return this.remoteStrategy.getItem(key, options).then(function (value) {
        return _this4._cacheItem(key, value, options).then(function () {
          return value;
        });
      }).catch(function (e) {
        if (e === NOT_FOUND) {
          return _this4._cacheItem(key, DELETED, options).then(function () {
            throw e;
          });
        }
        throw e;
      });
    }
  }, {
    key: 'getItem',
    value: function getItem(key, options) {
      var _this5 = this;

      function throwIfDeletedOrReturn(value) {
        if (value === DELETED) {
          throw NOT_FOUND;
        }

        return value;
      }

      return this.localStrategy.getItem(key, options).catch(function () {
        return _this5._getRemoteAndCache(key, options);
      }).then(throwIfDeletedOrReturn);
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems(options) {
      var _this6 = this;

      return this.remoteStrategy.getAllItems(options).then(function (items) {
        return Promise.all(Object.keys(items).map(function (key) {
          return _this6._cacheItem(key, items[key], options);
        })).then(function () {
          return items;
        });
      });
    }
  }]);

  return CachedStorageStrategy;
}(BaseStorage);

module.exports = CachedStorageStrategy;

/***/ }),

/***/ 39:
/*!**************************************************************!*\
  !*** ../node_modules/@wix/web-bi-logger/dist/src/lib/env.js ***!
  \**************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHost = setHost;
exports.getHost = getHost;
exports.isWebWorker = isWebWorker;
exports.requestWindow = requestWindow;
var host = 'frog.wix.com';

function setHost(_host) {
  host = _host;
}

function getHost() {
  return host;
}

function isWebWorker() {
  /* global WorkerGlobalScope */

  //At the moment, this is the most reliable way of detecting if current code is run in a worker
  //Taken from here: https://stackoverflow.com/a/18002694
  return typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
}

/**
 * Provides a window object to the callback iff current window is the topmost one
 * Otherwise returns null
 */
function requestWindow(cb) {
  if (typeof window !== 'undefined' && window) {
    try {
      return window.top === window.self ? cb ? cb(window) : window : null;
    } catch (e) {
      return null;
    }
  }

  return null;
}

/***/ }),

/***/ 390:
/*!*****************************************************************************!*\
  !*** ../node_modules/data-capsule/dist/src/strategies/in-memory-storage.js ***!
  \*****************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(/*! ../utils/constants */ 51),
    NOT_FOUND = _require.NOT_FOUND;

var BaseStorage = __webpack_require__(/*! ../base-storage */ 40);

var InMemoryStrategy = exports.InMemoryStrategy = function (_BaseStorage) {
  _inherits(InMemoryStrategy, _BaseStorage);

  function InMemoryStrategy() {
    _classCallCheck(this, InMemoryStrategy);

    var _this = _possibleConstructorReturn(this, (InMemoryStrategy.__proto__ || Object.getPrototypeOf(InMemoryStrategy)).call(this));

    _this.memoryMap = {};
    return _this;
  }

  _createClass(InMemoryStrategy, [{
    key: 'setItem',
    value: function setItem(key, value) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (typeof this.memoryMap[options.namespace] === 'undefined') {
        this.memoryMap[options.namespace] = {};
      }
      this.memoryMap[options.namespace][key] = value;
      return Promise.resolve();
    }
  }, {
    key: 'getItem',
    value: function getItem(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var data = this.memoryMap[options.namespace] && this.memoryMap[options.namespace][key];
      return typeof data !== 'undefined' ? Promise.resolve(data) : Promise.reject(NOT_FOUND);
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      delete this.memoryMap[options.namespace][key];
      return Promise.resolve();
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return Promise.resolve(this.memoryMap[options.namespace]);
    }
  }]);

  return InMemoryStrategy;
}(BaseStorage);

module.exports = InMemoryStrategy;

/***/ }),

/***/ 391:
/*!*************************************************************!*\
  !*** ../node_modules/data-capsule/dist/src/data-capsule.js ***!
  \*************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStorage = __webpack_require__(/*! ./base-storage */ 40);

function validateNamespace(options) {
  if (!options.namespace) {
    throw new Error('namespace is required');
  } else if (typeof options.namespace !== 'string') {
    throw new Error('namespace should be a string');
  }
}

var DataCapsule = function (_BaseStorage) {
  _inherits(DataCapsule, _BaseStorage);

  function DataCapsule(_ref) {
    var strategy = _ref.strategy,
        namespace = _ref.namespace,
        scope = _ref.scope;

    _classCallCheck(this, DataCapsule);

    var _this = _possibleConstructorReturn(this, (DataCapsule.__proto__ || Object.getPrototypeOf(DataCapsule)).call(this));

    _this.storageStrategy = BaseStorage.verify(strategy);
    _this._options = { namespace: namespace, scope: scope };
    return _this;
  }

  _createClass(DataCapsule, [{
    key: '_buildValidateOptions',
    value: function _buildValidateOptions(capsuleOptions, options) {
      options = Object.assign({}, capsuleOptions, options);
      options.scope = this.storageStrategy.extendScope(options.scope);
      validateNamespace(options);
      return options;
    }
  }, {
    key: 'setItem',
    value: function setItem(key, value, options) {
      options = this._buildValidateOptions(this._options, options);
      return this.storageStrategy.setItem(key, value, options);
    }
  }, {
    key: 'getItem',
    value: function getItem(key, options) {
      options = this._buildValidateOptions(this._options, options);
      return this.storageStrategy.getItem(key, options);
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key, options) {
      options = this._buildValidateOptions(this._options, options);
      return this.storageStrategy.removeItem(key, options);
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems(options) {
      options = this._buildValidateOptions(this._options, options);
      return this.storageStrategy.getAllItems(options);
    }
  }]);

  return DataCapsule;
}(BaseStorage);

module.exports = DataCapsule;

/***/ }),

/***/ 4:
/*!*************************************************************************************!*\
  !*** external {"amd":"lodash","commonjs":"lodash","commonjs2":"lodash","root":"_"} ***!
  \*************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 40:
/*!*************************************************************!*\
  !*** ../node_modules/data-capsule/dist/src/base-storage.js ***!
  \*************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseStorage = function () {
  function BaseStorage() {
    var _this = this;

    _classCallCheck(this, BaseStorage);

    ['setItem', 'getItem', 'removeItem', 'getAllItems'].forEach(function (method) {
      if (_this[method] === BaseStorage.prototype[method]) {
        throw new Error('BaseStorage method [' + method + '] must be overriden!');
      }
    });
  }

  _createClass(BaseStorage, [{
    key: 'extendScope',
    value: function extendScope(scope) {
      return scope;
    }
  }, {
    key: 'setItem',
    value: function setItem(key, value, options) {
      throw options;
    }
  }, {
    key: 'getItem',
    value: function getItem(key, options) {
      throw options;
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key, options) {
      throw options;
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems(options) {
      throw options;
    }
  }], [{
    key: 'verify',
    value: function verify(strategy) {
      if (strategy instanceof BaseStorage) {
        return strategy;
      } else {
        throw new Error('This class must extend BaseStorage!');
      }
    }
  }]);

  return BaseStorage;
}();

module.exports = BaseStorage;

/***/ }),

/***/ 42:
/*!********************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/constants/date-time.js ***!
  \********************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TimeOfDay = /** @class */ (function () {
    function TimeOfDay() {
        this.MORNING = 'morning';
        this.AFTERNOON = 'afternoon';
        this.EVENING = 'evening';
    }
    return TimeOfDay;
}());
exports.TimeOfDay = TimeOfDay;
var TimeOfDayBounds = /** @class */ (function () {
    function TimeOfDayBounds() {
        this.MORNING = 12;
        this.AFTERNOON = 17;
        this.EVENING = 23;
    }
    return TimeOfDayBounds;
}());
exports.TimeOfDayBounds = TimeOfDayBounds;
var DateDefaultsConst = /** @class */ (function () {
    function DateDefaultsConst() {
        this.DATE_FORMAT = 'YYYY-MM-DD';
        this.TIME_FORMAT = 'HH:mm:ss.SSS';
        this.DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS';
    }
    return DateDefaultsConst;
}());
exports.DateDefaultsConst = DateDefaultsConst;
//# sourceMappingURL=date-time.js.map

/***/ }),

/***/ 45:
/*!*********************************************************************************!*\
  !*** ../node_modules/@wix/app-settings-client/dist/es/src/index.js + 9 modules ***!
  \*********************************************************************************/
/*! exports provided: settingsClient, appClient, adapters, SettingsClient, AppClient, JsSdkAdapter, Scope */
/*! exports used: Scope, appClient, settingsClient */
/*! ModuleConcatenation bailout: Cannot concat with ../node_modules/@wix/js-sdk-wrapper/dist/src/create-wix-sdk-wrapper.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ../node_modules/query-string/index.js (<- Module is not an ECMAScript module) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/query-string/index.js
var query_string = __webpack_require__(126);

// EXTERNAL MODULE: ../node_modules/uuid/v4.js
var v4 = __webpack_require__(83);

// CONCATENATED MODULE: ../node_modules/@wix/app-settings-client/dist/es/src/utils/generate-id.js

function generate() {
    return v4();
}
/* harmony default export */ var generate_id = (generate);
//# sourceMappingURL=generate-id.js.map
// CONCATENATED MODULE: ../node_modules/@wix/app-settings-client/dist/es/src/utils/delay.js
function delay(timeout) {
    return new Promise(function (resolve) {
        setTimeout(resolve, timeout);
    });
}
//# sourceMappingURL=delay.js.map
// CONCATENATED MODULE: ../node_modules/@wix/app-settings-client/dist/es/src/settings-client.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var settings_client_SettingsClient = /** @class */ (function () {
    function SettingsClient(_a) {
        var apiClient = _a.apiClient, scope = _a.scope, adapter = _a.adapter, data = _a.data, _b = _a.generateId, generateId = _b === void 0 ? generate_id : _b, _c = _a.wait, wait = _c === void 0 ? delay : _c;
        this.firstTime = true;
        this.apiClient = apiClient;
        this.scope = scope;
        this.adapter = adapter;
        this.data = data;
        this.generateId = generateId;
        this.instance = adapter.signedInstance;
        this.queue = [];
        this.wait = wait;
    }
    SettingsClient.prototype.getAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SettingsClient.prototype.get = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, key ? this.data[key] : this.data];
                }
            });
        });
    };
    SettingsClient.prototype.set = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadData()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.update(key, value)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SettingsClient.prototype.delete = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadData()];
                    case 1:
                        _a.sent();
                        if (!this.data[key]) {
                            throw new Error("'" + key + "' doesn't exist in settings");
                        }
                        return [4 /*yield*/, this.update(key, null)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SettingsClient.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.getPromise) {
                            this.getPromise = this.resolveData();
                        }
                        return [4 /*yield*/, this.getPromise];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SettingsClient.prototype.resolveData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var externalId, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getExternalId()];
                    case 1:
                        externalId = _b.sent();
                        if (!(!this.data && externalId)) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, this.apiClient.get(this.instance, externalId, this.scope)];
                    case 2:
                        _a.data = _b.sent();
                        this.firstTime = false;
                        return [3 /*break*/, 4];
                    case 3:
                        if (!this.data) {
                            this.data = {};
                        }
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SettingsClient.prototype.update = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.data[key] = value;
                        this.adapter.triggerSettingsUpdated(this.data, this.scope);
                        this.queue.push({ key: key, value: value });
                        if (!this.flushPromise) {
                            this.flushPromise = this.flushQueue();
                        }
                        return [4 /*yield*/, this.flushPromise];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SettingsClient.prototype.flushQueue = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wait(100)];
                    case 1:
                        _a.sent();
                        queue = this.queue.slice();
                        this.queue = [];
                        this.flushPromise = null;
                        return [4 /*yield*/, this.saveChanges(queue)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SettingsClient.prototype.saveChanges = function (queue) {
        return __awaiter(this, void 0, void 0, function () {
            var changes, newExternalId, newExternalId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        changes = queue.reduce(function (acc, item) {
                            acc[item.key] = item.value;
                            return acc;
                        }, {});
                        if (!this.firstTime) return [3 /*break*/, 3];
                        newExternalId = this.generateId();
                        return [4 /*yield*/, this.apiClient.set(this.instance, newExternalId, this.scope, changes)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.setExternalId(newExternalId)];
                    case 2:
                        _a.sent();
                        this.firstTime = false;
                        return [3 /*break*/, 6];
                    case 3: return [4 /*yield*/, this.apiClient.update(this.instance, this.externalId, this.scope, changes)];
                    case 4:
                        newExternalId = _a.sent();
                        return [4 /*yield*/, this.setExternalId(newExternalId)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    SettingsClient.prototype.setExternalId = function (externalId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adapter.setExternalId(externalId)];
                    case 1:
                        _a.sent();
                        this.externalId = externalId;
                        return [2 /*return*/];
                }
            });
        });
    };
    SettingsClient.prototype.getExternalId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.externalId) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.adapter.getExternalId()];
                    case 1:
                        _a.externalId = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, this.externalId];
                }
            });
        });
    };
    return SettingsClient;
}());

//# sourceMappingURL=settings-client.js.map
// CONCATENATED MODULE: ../node_modules/@wix/app-settings-client/dist/es/src/app-client.js
var app_client_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var app_client_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var AppClient = /** @class */ (function () {
    function AppClient(_a) {
        var _this = this;
        var adapter = _a.adapter, scope = _a.scope, cdnClient = _a.cdnClient, data = _a.data;
        this.adapter = adapter;
        this.scope = scope;
        this.cdnClient = cdnClient;
        this.data = data;
        this.listeners = [];
        //TODO: what happens if data is not loaded?
        this.adapter.onSettingsUpdated(scope, function (data) {
            _this.data = data;
            _this.listeners.forEach(function (l) { return l(_this.data); });
        });
    }
    AppClient.prototype.getAll = function () {
        return app_client_awaiter(this, void 0, void 0, function () {
            return app_client_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AppClient.prototype.get = function (key) {
        return app_client_awaiter(this, void 0, void 0, function () {
            return app_client_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, key ? this.data[key] : this.data];
                }
            });
        });
    };
    AppClient.prototype.onChange = function (cb) {
        this.listeners.push(cb);
    };
    AppClient.prototype.loadData = function () {
        return app_client_awaiter(this, void 0, void 0, function () {
            return app_client_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.getPromise) {
                            this.getPromise = this.resolveData();
                        }
                        return [4 /*yield*/, this.getPromise];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AppClient.prototype.resolveData = function () {
        return app_client_awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return app_client_generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.getExternalId()];
                    case 1:
                        _a.externalId = _c.sent();
                        if (!(!this.data && this.externalId)) return [3 /*break*/, 3];
                        _b = this;
                        return [4 /*yield*/, this.cdnClient.get(this.adapter.getAppDefId(), this.adapter.getInstanceId(), this.externalId, this.scope)];
                    case 2:
                        _b.data = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        if (!this.data) {
                            this.data = {};
                        }
                        _c.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AppClient.prototype.getExternalId = function () {
        return app_client_awaiter(this, void 0, void 0, function () {
            var _a;
            return app_client_generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.externalId;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.adapter.getExternalId()];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2: return [2 /*return*/, _a];
                }
            });
        });
    };
    return AppClient;
}());

//# sourceMappingURL=app-client.js.map
// EXTERNAL MODULE: ../node_modules/@wix/js-sdk-wrapper/dist/src/create-wix-sdk-wrapper.js
var create_wix_sdk_wrapper = __webpack_require__(127);

// CONCATENATED MODULE: ../node_modules/@wix/app-settings-client/dist/es/src/js-sdk-adapter.js
var js_sdk_adapter_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var js_sdk_adapter_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var js_sdk_adapter_JsSdkAdapter = /** @class */ (function () {
    function JsSdkAdapter(_a) {
        var jsSdkInstance = _a.jsSdkInstance, signedInstance = _a.signedInstance;
        this.jsSdkWrapper = Object(create_wix_sdk_wrapper["wixSdk"])(jsSdkInstance);
        this.originalJsSdk = jsSdkInstance;
        this.signedInstance = signedInstance;
    }
    JsSdkAdapter.prototype.getAppDefId = function () {
        return this.jsSdkWrapper.Utils.getInstanceValue('appDefId');
    };
    JsSdkAdapter.prototype.getInstanceId = function () {
        var metaSiteId = this.jsSdkWrapper.Utils.getInstanceValue('metaSiteId');
        var originInstanceId = this.jsSdkWrapper.Utils.getInstanceValue('originInstanceId');
        // pre-save mode; ex: when editing a template, the instanceId is not persisted YET,
        // so data does not exists for that instanceId. Hence, we need to take the data that is saved
        // on the template (originInstanceId).
        if (!metaSiteId && originInstanceId) {
            return originInstanceId;
        }
        else {
            return this.jsSdkWrapper.Utils.getInstanceId();
        }
    };
    JsSdkAdapter.prototype.getExternalId = function () {
        return js_sdk_adapter_awaiter(this, void 0, void 0, function () {
            return js_sdk_adapter_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.jsSdkWrapper.getExternalId()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JsSdkAdapter.prototype.setExternalId = function (id) {
        return js_sdk_adapter_awaiter(this, void 0, void 0, function () {
            var _this = this;
            return js_sdk_adapter_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    //TODO: once js-sdk version released update signature in js-sdk-wrapper
                    return [4 /*yield*/, new Promise(function (resolve, reject) { return _this.originalJsSdk.Settings.setExternalId(id, resolve, reject, true); })];
                    case 1:
                        //TODO: once js-sdk version released update signature in js-sdk-wrapper
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    JsSdkAdapter.prototype.triggerSettingsUpdated = function (data, scope) {
        var message = {
            scope: scope,
            payload: data,
            source: 'app-settings'
        };
        this.jsSdkWrapper.Settings.triggerSettingsUpdatedEvent(message, this.jsSdkWrapper.Utils.getOrigCompId());
    };
    JsSdkAdapter.prototype.onSettingsUpdated = function (scope, cb) {
        this.jsSdkWrapper.addEventListener('SETTINGS_UPDATED', function (data) {
            if (data && data.source === 'app-settings' && data.scope === scope) {
                cb(data.payload);
            }
        });
    };
    return JsSdkAdapter;
}());

//# sourceMappingURL=js-sdk-adapter.js.map
// EXTERNAL MODULE: ../node_modules/fetch-ponyfill/build/fetch-browser.js
var fetch_browser = __webpack_require__(64);

// CONCATENATED MODULE: ../node_modules/@wix/app-settings-client/dist/es/src/domain.js
var Scope;
(function (Scope) {
    Scope["APP"] = "APP";
    Scope["COMPONENT"] = "COMPONENT";
})(Scope || (Scope = {}));
//# sourceMappingURL=domain.js.map
// CONCATENATED MODULE: ../node_modules/@wix/app-settings-client/dist/es/src/http-api-client.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var http_api_client_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var http_api_client_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var fetch = fetch_browser().fetch;
var http_api_client_HttpApiClient = /** @class */ (function () {
    function HttpApiClient(apiUrl) {
        this.apiUrl = apiUrl.replace(/\/$/, '');
    }
    HttpApiClient.prototype.get = function (signedInstance, externalId, scope) {
        return http_api_client_awaiter(this, void 0, void 0, function () {
            var url, json;
            return http_api_client_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.apiUrl + "/v1/settings?external_" + scope.toLowerCase() + "_id=" + externalId;
                        return [4 /*yield*/, this.requestJson({ signedInstance: signedInstance, url: url, method: 'GET' })];
                    case 1:
                        json = _a.sent();
                        return [2 /*return*/, scope === Scope.APP ? json.appSettings : json.componentSettings];
                }
            });
        });
    };
    HttpApiClient.prototype.set = function (signedInstance, externalId, scope, data) {
        return http_api_client_awaiter(this, void 0, void 0, function () {
            var url;
            return http_api_client_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.apiUrl + "/v1/settings/" + scope + "/" + externalId;
                        return [4 /*yield*/, this.requestJson({ signedInstance: signedInstance, url: url, requestBody: { data: data }, method: 'PUT' })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HttpApiClient.prototype.update = function (signedInstance, externalId, scope, data) {
        return http_api_client_awaiter(this, void 0, void 0, function () {
            var url, _a, fields, sanitizedData, requestBody, newExternalId;
            return http_api_client_generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = this.apiUrl + "/v1/settings/" + scope + "/" + externalId;
                        _a = buildForUpdate(data), fields = _a.fields, sanitizedData = _a.sanitizedData;
                        requestBody = { data: sanitizedData, fields: fields };
                        return [4 /*yield*/, this.requestJson({ signedInstance: signedInstance, url: url, requestBody: requestBody, method: 'PATCH' })];
                    case 1:
                        newExternalId = (_b.sent()).newExternalId;
                        return [2 /*return*/, newExternalId];
                }
            });
        });
    };
    HttpApiClient.prototype.requestJson = function (_a) {
        var signedInstance = _a.signedInstance, _b = _a.method, method = _b === void 0 ? 'GET' : _b, requestBody = _a.requestBody, url = _a.url;
        return http_api_client_awaiter(this, void 0, void 0, function () {
            var additionalHeaders, response;
            return http_api_client_generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        additionalHeaders = signedInstance ? { Authorization: signedInstance } : {};
                        return [4 /*yield*/, fetch(url, {
                                method: method,
                                body: JSON.stringify(requestBody),
                                headers: __assign({ 'Content-Type': 'application/json' }, additionalHeaders)
                            })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    return HttpApiClient;
}());
function buildForUpdate(data) {
    var cloned = __assign({}, data);
    var fields = Object.keys(cloned);
    Object.keys(cloned).forEach(function (key) {
        (cloned[key] === null || cloned[key] === undefined) && delete cloned[key];
    });
    return { fields: fields, sanitizedData: cloned };
}

//# sourceMappingURL=http-api-client.js.map
// CONCATENATED MODULE: ../node_modules/@wix/app-settings-client/dist/es/src/utils/checks.js
function assert(expr, message) {
    if (!Boolean(expr)) {
        throw new Error(message);
    }
}
function resolve(primary, backup, message) {
    var result = primary || backup();
    assert(result !== undefined, message);
    return result;
}

//# sourceMappingURL=checks.js.map
// CONCATENATED MODULE: ../node_modules/@wix/app-settings-client/dist/es/src/cdn-api-client.js
var cdn_api_client_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var cdn_api_client_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var pony = fetch_browser();
var CdnApiClient = /** @class */ (function () {
    function CdnApiClient(_a) {
        var baseCdnUrl = _a.baseCdnUrl, fetch = _a.fetch;
        this.cdnUrl = (baseCdnUrl || 'https://settings.parastorage.com/').replace(/\/$/, '');
        this.fetch = fetch || pony.fetch;
    }
    CdnApiClient.prototype.get = function (appDefId, instanceId, externalId, scope) {
        return cdn_api_client_awaiter(this, void 0, void 0, function () {
            var url, response;
            return cdn_api_client_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.cdnUrl + "/v1/settings/" + appDefId + "/" + instanceId + "/" + scope + "/" + externalId;
                        return [4 /*yield*/, this.fetch(url, {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return CdnApiClient;
}());

//# sourceMappingURL=cdn-api-client.js.map
// CONCATENATED MODULE: ../node_modules/@wix/app-settings-client/dist/es/src/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return settingsClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return appClient; });
/* unused harmony export adapters */
/* unused concated harmony import SettingsClient */
/* unused concated harmony import AppClient */
/* unused concated harmony import JsSdkAdapter */
/* concated harmony reexport Scope */__webpack_require__.d(__webpack_exports__, "a", function() { return Scope; });








function settingsClient(opts) {
    assertClientInput(opts);
    var scope = opts.scope, data = opts.data;
    var adapter = opts.adapter || adapters.wixSdk();
    var settingsApiUrl = resolve(opts.apiUrl, getApiUrl, 'could not resolve apiUrl - please provide it explicitly');
    return new settings_client_SettingsClient({
        adapter: adapter,
        scope: scope,
        data: data,
        apiClient: new http_api_client_HttpApiClient(settingsApiUrl)
    });
}
function appClient(opts) {
    assertClientInput(opts);
    var scope = opts.scope, data = opts.data;
    var adapter = opts.adapter || adapters.wixSdk();
    var settingsApiUrl = opts.cdnUrl;
    return new AppClient({
        adapter: adapter,
        scope: scope,
        data: data,
        cdnClient: new CdnApiClient({ baseCdnUrl: settingsApiUrl })
    });
}
var adapters = {
    wixSdk: function (_a) {
        var _b = _a === void 0 ? {} : _a, jsSdkInstance = _b.jsSdkInstance, signedInstance = _b.signedInstance;
        return new js_sdk_adapter_JsSdkAdapter({
            jsSdkInstance: resolve(jsSdkInstance, getWixSdk, 'window.Wix is undefined, please specify jsSdkInstance'),
            signedInstance: resolve(signedInstance, getInstance, 'no instance in query parameters, please specify signedInstance'),
        });
    }
};
function assertClientInput(opts) {
    assert(opts !== undefined, 'opts is mandatory');
    assert(opts.scope !== undefined, 'scope is mandatory');
    assert(opts.scope === Scope.COMPONENT || opts.scope === Scope.APP, 'scope must be APP or COMPONENT');
    assert(opts.scope === Scope.COMPONENT, 'APP scope is not supported');
}
function getWixSdk() {
    return window.Wix;
}
function getInstance() {
    return Object(query_string["parse"])(window.location.search).instance;
}
function getApiUrl() {
    return window.location.origin + "/_api/app-settings-service";
}

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 47:
/*!**************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/constants/bookings.consts.js ***!
  \**************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BOOKINGS_APP_DEF_ID = '13d21c63-b5ec-5912-8397-c3a5ddb27a97';
exports.BOOKINGS_WIDGET_ID = '14756c3d-f10a-45fc-4df1-808f22aabe80';
exports.BOOKINGS_OFFERING_LIST_WIDGET_ID = 'cc882051-73c9-41a6-8f90-f6ebc9f10fe1';
exports.BOOKINGS_MAIN_PAGE_ID = '13d27016-697f-b82f-7512-8e20854c09f6';
exports.BOOKINGS_LIST_PAGE_ID = '621bc837-5943-4c76-a7ce-a0e38185301f';
exports.BOOKINGS_CHECKOUT_SECTION_ID = 'book_checkout';
exports.BOOKINGS_SCHEDULER_SECTION_ID = 'scheduler';
exports.BOOKINGS_LIST_SECTION_ID = 'bookings_list';
//# sourceMappingURL=bookings.consts.js.map

/***/ }),

/***/ 48:
/*!*************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/env.js ***!
  \*************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

exports.__esModule = true;
var envFallback = {};

var env = function env() {
  if (typeof window !== 'undefined') {
    return window;
  } else if (typeof global !== 'undefined') {
    return global;
  } else if (typeof WorkerGlobalScope !== 'undefined') {
    /* global WorkerGlobalScope */
    return WorkerGlobalScope;
  } else {
    return envFallback;
  }
};

exports.env = env;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../../webpack/buildin/global.js */ 21)))

/***/ }),

/***/ 49:
/*!*************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/data-items/common/data-item.js ***!
  \*************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataItem = function () {
  function DataItem() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    _classCallCheck(this, DataItem);

    this.data = data;
  }

  DataItem.prototype.isActive = function isActive() {
    return true;
  };

  DataItem.prototype.export = function _export() {
    return this.data;
  };

  return DataItem;
}();

exports.default = DataItem;

/***/ }),

/***/ 50:
/*!****************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/data-items/common/bi-base-item.js ***!
  \****************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dataItem = __webpack_require__(/*! ./data-item */ 49);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents bi events from the "fed monitoring" source:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
var BiBaseDataItem = function (_DataItem) {
  _inherits(BiBaseDataItem, _DataItem);

  function BiBaseDataItem(evid, sessionId) {
    _classCallCheck(this, BiBaseDataItem);

    return _possibleConstructorReturn(this, _DataItem.call(this, {
      src: 72,
      evid: evid,
      session_id: sessionId, // eslint-disable-line
      _: new Date().getTime() // cache buster
    }));
  }

  return BiBaseDataItem;
}(_dataItem2.default);

exports.default = BiBaseDataItem;

/***/ }),

/***/ 51:
/*!****************************************************************!*\
  !*** ../node_modules/data-capsule/dist/src/utils/constants.js ***!
  \****************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var errors = {
  NOT_FOUND: new Error('Key was not found in capsule'),
  SERVER_ERROR: new Error('Failed to perform operarion on server')
};

function toError(str) {
  return Object.keys(errors).map(function (key) {
    return errors[key];
  }).find(function (err) {
    return err.message === str;
  }) || new Error(str);
}

module.exports = {
  PREFIX_SEPARATOR: '|',
  KEY_SEPARATOR: '#',
  STORAGE_PREFIX: 'capsule',
  NOT_FOUND: errors.NOT_FOUND,
  CONNECTION_MAX_TIMEOUT: 2000,
  MESSAGE_MAX_TIMEOUT: 8000,
  SERVER_ERROR: errors.SERVER_ERROR,
  toError: toError
};

/***/ }),

/***/ 56:
/*!**************************************************!*\
  !*** ./WidgetApp/constants/environment.const.ts ***!
  \**************************************************/
/*! exports provided: FormFactor */
/*! exports used: FormFactor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormFactor; });
var FormFactor;
(function (FormFactor) {
    FormFactor["DESKTOP"] = "Desktop";
    FormFactor["MOBILE"] = "Mobile";
})(FormFactor || (FormFactor = {}));


/***/ }),

/***/ 59:
/*!*************************************************!*\
  !*** ../node_modules/webpack/buildin/module.js ***!
  \*************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ 64:
/*!*************************************************************!*\
  !*** ../node_modules/fetch-ponyfill/build/fetch-browser.js ***!
  \*************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_RESULT__;(function (self) {
  'use strict';

  function fetchPonyfill(options) {
    var Promise = options && options.Promise || self.Promise;
    var XMLHttpRequest = options && options.XMLHttpRequest || self.XMLHttpRequest;
    var global = self;

    return (function () {
      var self = Object.create(global, {
        fetch: {
          value: undefined,
          writable: true
        }
      });

      (function(self) {
        'use strict';

        if (self.fetch) {
          return
        }

        var support = {
          searchParams: 'URLSearchParams' in self,
          iterable: 'Symbol' in self && 'iterator' in Symbol,
          blob: 'FileReader' in self && 'Blob' in self && (function() {
            try {
              new Blob()
              return true
            } catch(e) {
              return false
            }
          })(),
          formData: 'FormData' in self,
          arrayBuffer: 'ArrayBuffer' in self
        }

        if (support.arrayBuffer) {
          var viewClasses = [
            '[object Int8Array]',
            '[object Uint8Array]',
            '[object Uint8ClampedArray]',
            '[object Int16Array]',
            '[object Uint16Array]',
            '[object Int32Array]',
            '[object Uint32Array]',
            '[object Float32Array]',
            '[object Float64Array]'
          ]

          var isDataView = function(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj)
          }

          var isArrayBufferView = ArrayBuffer.isView || function(obj) {
            return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
          }
        }

        function normalizeName(name) {
          if (typeof name !== 'string') {
            name = String(name)
          }
          if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
            throw new TypeError('Invalid character in header field name')
          }
          return name.toLowerCase()
        }

        function normalizeValue(value) {
          if (typeof value !== 'string') {
            value = String(value)
          }
          return value
        }

        // Build a destructive iterator for the value list
        function iteratorFor(items) {
          var iterator = {
            next: function() {
              var value = items.shift()
              return {done: value === undefined, value: value}
            }
          }

          if (support.iterable) {
            iterator[Symbol.iterator] = function() {
              return iterator
            }
          }

          return iterator
        }

        function Headers(headers) {
          this.map = {}

          if (headers instanceof Headers) {
            headers.forEach(function(value, name) {
              this.append(name, value)
            }, this)
          } else if (Array.isArray(headers)) {
            headers.forEach(function(header) {
              this.append(header[0], header[1])
            }, this)
          } else if (headers) {
            Object.getOwnPropertyNames(headers).forEach(function(name) {
              this.append(name, headers[name])
            }, this)
          }
        }

        Headers.prototype.append = function(name, value) {
          name = normalizeName(name)
          value = normalizeValue(value)
          var oldValue = this.map[name]
          this.map[name] = oldValue ? oldValue+','+value : value
        }

        Headers.prototype['delete'] = function(name) {
          delete this.map[normalizeName(name)]
        }

        Headers.prototype.get = function(name) {
          name = normalizeName(name)
          return this.has(name) ? this.map[name] : null
        }

        Headers.prototype.has = function(name) {
          return this.map.hasOwnProperty(normalizeName(name))
        }

        Headers.prototype.set = function(name, value) {
          this.map[normalizeName(name)] = normalizeValue(value)
        }

        Headers.prototype.forEach = function(callback, thisArg) {
          for (var name in this.map) {
            if (this.map.hasOwnProperty(name)) {
              callback.call(thisArg, this.map[name], name, this)
            }
          }
        }

        Headers.prototype.keys = function() {
          var items = []
          this.forEach(function(value, name) { items.push(name) })
          return iteratorFor(items)
        }

        Headers.prototype.values = function() {
          var items = []
          this.forEach(function(value) { items.push(value) })
          return iteratorFor(items)
        }

        Headers.prototype.entries = function() {
          var items = []
          this.forEach(function(value, name) { items.push([name, value]) })
          return iteratorFor(items)
        }

        if (support.iterable) {
          Headers.prototype[Symbol.iterator] = Headers.prototype.entries
        }

        function consumed(body) {
          if (body.bodyUsed) {
            return Promise.reject(new TypeError('Already read'))
          }
          body.bodyUsed = true
        }

        function fileReaderReady(reader) {
          return new Promise(function(resolve, reject) {
            reader.onload = function() {
              resolve(reader.result)
            }
            reader.onerror = function() {
              reject(reader.error)
            }
          })
        }

        function readBlobAsArrayBuffer(blob) {
          var reader = new FileReader()
          var promise = fileReaderReady(reader)
          reader.readAsArrayBuffer(blob)
          return promise
        }

        function readBlobAsText(blob) {
          var reader = new FileReader()
          var promise = fileReaderReady(reader)
          reader.readAsText(blob)
          return promise
        }

        function readArrayBufferAsText(buf) {
          var view = new Uint8Array(buf)
          var chars = new Array(view.length)

          for (var i = 0; i < view.length; i++) {
            chars[i] = String.fromCharCode(view[i])
          }
          return chars.join('')
        }

        function bufferClone(buf) {
          if (buf.slice) {
            return buf.slice(0)
          } else {
            var view = new Uint8Array(buf.byteLength)
            view.set(new Uint8Array(buf))
            return view.buffer
          }
        }

        function Body() {
          this.bodyUsed = false

          this._initBody = function(body) {
            this._bodyInit = body
            if (!body) {
              this._bodyText = ''
            } else if (typeof body === 'string') {
              this._bodyText = body
            } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
              this._bodyBlob = body
            } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
              this._bodyFormData = body
            } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
              this._bodyText = body.toString()
            } else if (support.arrayBuffer && support.blob && isDataView(body)) {
              this._bodyArrayBuffer = bufferClone(body.buffer)
              // IE 10-11 can't handle a DataView body.
              this._bodyInit = new Blob([this._bodyArrayBuffer])
            } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
              this._bodyArrayBuffer = bufferClone(body)
            } else {
              throw new Error('unsupported BodyInit type')
            }

            if (!this.headers.get('content-type')) {
              if (typeof body === 'string') {
                this.headers.set('content-type', 'text/plain;charset=UTF-8')
              } else if (this._bodyBlob && this._bodyBlob.type) {
                this.headers.set('content-type', this._bodyBlob.type)
              } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
              }
            }
          }

          if (support.blob) {
            this.blob = function() {
              var rejected = consumed(this)
              if (rejected) {
                return rejected
              }

              if (this._bodyBlob) {
                return Promise.resolve(this._bodyBlob)
              } else if (this._bodyArrayBuffer) {
                return Promise.resolve(new Blob([this._bodyArrayBuffer]))
              } else if (this._bodyFormData) {
                throw new Error('could not read FormData body as blob')
              } else {
                return Promise.resolve(new Blob([this._bodyText]))
              }
            }

            this.arrayBuffer = function() {
              if (this._bodyArrayBuffer) {
                return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
              } else {
                return this.blob().then(readBlobAsArrayBuffer)
              }
            }
          }

          this.text = function() {
            var rejected = consumed(this)
            if (rejected) {
              return rejected
            }

            if (this._bodyBlob) {
              return readBlobAsText(this._bodyBlob)
            } else if (this._bodyArrayBuffer) {
              return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
            } else if (this._bodyFormData) {
              throw new Error('could not read FormData body as text')
            } else {
              return Promise.resolve(this._bodyText)
            }
          }

          if (support.formData) {
            this.formData = function() {
              return this.text().then(decode)
            }
          }

          this.json = function() {
            return this.text().then(JSON.parse)
          }

          return this
        }

        // HTTP methods whose capitalization should be normalized
        var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

        function normalizeMethod(method) {
          var upcased = method.toUpperCase()
          return (methods.indexOf(upcased) > -1) ? upcased : method
        }

        function Request(input, options) {
          options = options || {}
          var body = options.body

          if (input instanceof Request) {
            if (input.bodyUsed) {
              throw new TypeError('Already read')
            }
            this.url = input.url
            this.credentials = input.credentials
            if (!options.headers) {
              this.headers = new Headers(input.headers)
            }
            this.method = input.method
            this.mode = input.mode
            if (!body && input._bodyInit != null) {
              body = input._bodyInit
              input.bodyUsed = true
            }
          } else {
            this.url = String(input)
          }

          this.credentials = options.credentials || this.credentials || 'omit'
          if (options.headers || !this.headers) {
            this.headers = new Headers(options.headers)
          }
          this.method = normalizeMethod(options.method || this.method || 'GET')
          this.mode = options.mode || this.mode || null
          this.referrer = null

          if ((this.method === 'GET' || this.method === 'HEAD') && body) {
            throw new TypeError('Body not allowed for GET or HEAD requests')
          }
          this._initBody(body)
        }

        Request.prototype.clone = function() {
          return new Request(this, { body: this._bodyInit })
        }

        function decode(body) {
          var form = new FormData()
          body.trim().split('&').forEach(function(bytes) {
            if (bytes) {
              var split = bytes.split('=')
              var name = split.shift().replace(/\+/g, ' ')
              var value = split.join('=').replace(/\+/g, ' ')
              form.append(decodeURIComponent(name), decodeURIComponent(value))
            }
          })
          return form
        }

        function parseHeaders(rawHeaders) {
          var headers = new Headers()
          // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
          // https://tools.ietf.org/html/rfc7230#section-3.2
          var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
          preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
            var parts = line.split(':')
            var key = parts.shift().trim()
            if (key) {
              var value = parts.join(':').trim()
              headers.append(key, value)
            }
          })
          return headers
        }

        Body.call(Request.prototype)

        function Response(bodyInit, options) {
          if (!options) {
            options = {}
          }

          this.type = 'default'
          this.status = options.status === undefined ? 200 : options.status
          this.ok = this.status >= 200 && this.status < 300
          this.statusText = 'statusText' in options ? options.statusText : 'OK'
          this.headers = new Headers(options.headers)
          this.url = options.url || ''
          this._initBody(bodyInit)
        }

        Body.call(Response.prototype)

        Response.prototype.clone = function() {
          return new Response(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new Headers(this.headers),
            url: this.url
          })
        }

        Response.error = function() {
          var response = new Response(null, {status: 0, statusText: ''})
          response.type = 'error'
          return response
        }

        var redirectStatuses = [301, 302, 303, 307, 308]

        Response.redirect = function(url, status) {
          if (redirectStatuses.indexOf(status) === -1) {
            throw new RangeError('Invalid status code')
          }

          return new Response(null, {status: status, headers: {location: url}})
        }

        self.Headers = Headers
        self.Request = Request
        self.Response = Response

        self.fetch = function(input, init) {
          return new Promise(function(resolve, reject) {
            var request = new Request(input, init)
            var xhr = new XMLHttpRequest()

            xhr.onload = function() {
              var options = {
                status: xhr.status,
                statusText: xhr.statusText,
                headers: parseHeaders(xhr.getAllResponseHeaders() || '')
              }
              options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
              var body = 'response' in xhr ? xhr.response : xhr.responseText
              resolve(new Response(body, options))
            }

            xhr.onerror = function() {
              reject(new TypeError('Network request failed'))
            }

            xhr.ontimeout = function() {
              reject(new TypeError('Network request failed'))
            }

            xhr.open(request.method, request.url, true)

            if (request.credentials === 'include') {
              xhr.withCredentials = true
            } else if (request.credentials === 'omit') {
              xhr.withCredentials = false
            }

            if ('responseType' in xhr && support.blob) {
              xhr.responseType = 'blob'
            }

            request.headers.forEach(function(value, name) {
              xhr.setRequestHeader(name, value)
            })

            xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
          })
        }
        self.fetch.polyfill = true
      })(typeof self !== 'undefined' ? self : this);


      return {
        fetch: self.fetch,
        Headers: self.Headers,
        Request: self.Request,
        Response: self.Response
      };
    }());
  }

  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return fetchPonyfill;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : typeof global !== 'undefined' ? global : this));


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../webpack/buildin/global.js */ 21)))

/***/ }),

/***/ 65:
/*!***********************************************!*\
  !*** ./WidgetApp/constants/bookings.const.ts ***!
  \***********************************************/
/*! exports provided: FEDOPS_WIDGET_APP_NAME, FEDOPS_MAIN_PAGE_NAME, SENTRY_BOOKINGS_WIDGET_DSN */
/*! exports used: FEDOPS_MAIN_PAGE_NAME, FEDOPS_WIDGET_APP_NAME, SENTRY_BOOKINGS_WIDGET_DSN */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FEDOPS_WIDGET_APP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FEDOPS_MAIN_PAGE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SENTRY_BOOKINGS_WIDGET_DSN; });
var FEDOPS_WIDGET_APP_NAME = 'bookings-widget-phase-one';
var FEDOPS_MAIN_PAGE_NAME = 'bookings-main-page';
var SENTRY_BOOKINGS_WIDGET_DSN = 'https://87168827af6c40f29992e0213f5c86b4@sentry.io/1401356';


/***/ }),

/***/ 66:
/*!********************************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/entities/offering-payment/offering-payment.dto.buillder.js ***!
  \********************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var offering_payment_type_1 = __webpack_require__(/*! ./offering-payment-type */ 85);
var OfferingPaymentDtoBuilder = /** @class */ (function () {
    function OfferingPaymentDtoBuilder() {
        this.payment = {
            currency: 'USD',
            price: 123,
            isFree: false,
            priceText: 'price text',
            minCharge: 0,
            paymentType: offering_payment_type_1.PaymentType.OFFLINE,
        };
    }
    OfferingPaymentDtoBuilder.prototype.withCurrency = function (currency) {
        this.payment.currency = currency;
        return this;
    };
    OfferingPaymentDtoBuilder.prototype.withPrice = function (price) {
        this.payment.price = price;
        return this;
    };
    OfferingPaymentDtoBuilder.prototype.withIsFree = function (isFree) {
        this.payment.isFree = isFree;
        return this;
    };
    OfferingPaymentDtoBuilder.prototype.withPriceText = function (priceText) {
        this.payment.priceText = priceText;
        return this;
    };
    OfferingPaymentDtoBuilder.prototype.withMinCharge = function (minCharge) {
        this.payment.minCharge = minCharge;
        return this;
    };
    OfferingPaymentDtoBuilder.prototype.withPaymentType = function (paymentType) {
        this.payment.paymentType = paymentType;
        return this;
    };
    OfferingPaymentDtoBuilder.prototype.build = function () {
        return this.payment;
    };
    return OfferingPaymentDtoBuilder;
}());
exports.OfferingPaymentDtoBuilder = OfferingPaymentDtoBuilder;
//# sourceMappingURL=offering-payment.dto.buillder.js.map

/***/ }),

/***/ 67:
/*!*************************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/entities/offering-info/offering-info.dto.builder.js ***!
  \*************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OfferingInfoDtoBuilder = /** @class */ (function () {
    function OfferingInfoDtoBuilder() {
        this.info = {
            name: 'Nice Offering',
            description: 'This offering is awesome',
            tagLine: 'Service, Offering, Serlass',
            images: [new ImageDtoBuilder().build()],
        };
    }
    OfferingInfoDtoBuilder.prototype.withName = function (name) {
        this.info.name = name;
        return this;
    };
    OfferingInfoDtoBuilder.prototype.withDescription = function (description) {
        this.info.description = description;
        return this;
    };
    OfferingInfoDtoBuilder.prototype.withTagLine = function (tagLine) {
        this.info.tagLine = tagLine;
        return this;
    };
    OfferingInfoDtoBuilder.prototype.withImages = function (image) {
        this.info.images = [image];
        return this;
    };
    OfferingInfoDtoBuilder.prototype.build = function () {
        return this.info;
    };
    return OfferingInfoDtoBuilder;
}());
exports.OfferingInfoDtoBuilder = OfferingInfoDtoBuilder;
var ImageDtoBuilder = /** @class */ (function () {
    function ImageDtoBuilder() {
        this.image = {
            width: 1000,
            height: 1000,
            relativeUri: 'e320d0_a08d5b3e1b124f6cb9a5c38182079dc6~mv2.jpg',
        };
    }
    ImageDtoBuilder.prototype.withFileName = function (fileName) {
        this.image.fileName = fileName;
        return this;
    };
    ImageDtoBuilder.prototype.withRelativeUri = function (relativeUri) {
        this.image.relativeUri = relativeUri;
        return this;
    };
    ImageDtoBuilder.prototype.withHeight = function (height) {
        this.image.height = height;
        return this;
    };
    ImageDtoBuilder.prototype.withWidth = function (width) {
        this.image.width = width;
        return this;
    };
    ImageDtoBuilder.prototype.build = function () {
        return this.image;
    };
    return ImageDtoBuilder;
}());
exports.ImageDtoBuilder = ImageDtoBuilder;
//# sourceMappingURL=offering-info.dto.builder.js.map

/***/ }),

/***/ 68:
/*!******************************************!*\
  !*** ../node_modules/process/browser.js ***!
  \******************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 74:
/*!******************************************************************!*\
  !*** ../node_modules/@wix/web-bi-logger/dist/src/lib/browser.js ***!
  \******************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.now = now;
exports.getDesktopSize = getDesktopSize;
exports.getWindowSize = getWindowSize;
exports.sendBeacon = sendBeacon;
exports.readCookie = readCookie;
function now() {
  return typeof performance !== 'undefined' && performance && performance.now ? performance.now() : -1;
}

function getDesktopSize(window) {
  var width = window.screen && window.screen.width || 0;
  var height = window.screen && window.screen.height || 0;

  return width + 'x' + height;
}

function getWindowSize(window) {
  var width = 0;
  var height = 0;

  if (window.innerWidth) {
    width = window.innerWidth;
    height = window.innerHeight;
  } else if (window.document) {
    if (window.document.documentElement && window.document.documentElement.clientWidth) {
      width = window.document.documentElement.clientWidth;
      height = window.document.documentElement.clientHeight;
    } else if (window.document.body && window.document.body.clientWidth) {
      width = window.document.body.clientWidth;
      height = window.document.body.clientHeight;
    }
  }

  return width + 'x' + height;
}

function sendBeacon(url) {
  if (typeof navigator === 'undefined' || !navigator || !navigator.sendBeacon) {
    return false;
  }

  return navigator.sendBeacon(url);
}

function readCookie(cookieName) {
  if (typeof document === 'undefined') {
    return null;
  }

  var cookies = document.cookie.split(';');

  for (var i = 0; i < cookies.length; i++) {
    var _cookies$i$split = cookies[i].split('='),
        _cookies$i$split2 = _slicedToArray(_cookies$i$split, 2),
        name = _cookies$i$split2[0],
        value = _cookies$i$split2[1];

    while (name[0] === ' ') {
      name = name.substr(1);
    }

    if (name === cookieName) {
      return value;
    }
  }

  return '';
}

/***/ }),

/***/ 75:
/*!*********************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/performance/performance.js ***!
  \*********************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _location = __webpack_require__(/*! ../app-data/location */ 222);

var _location2 = _interopRequireDefault(_location);

var _env = __webpack_require__(/*! ../env */ 48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * env().performance wrappers
 */
exports.default = {
  getNavigation: function getNavigation() {
    return typeof (0, _env.env)() !== 'undefined' && (0, _env.env)().performance ? (0, _env.env)().performance.navigation : {};
  },


  /**
   * get all loaded resources
   */
  getResources: function getResources() {
    var emptyVal = [];
    try {
      return (0, _env.env)() && (0, _env.env)().performance && (0, _env.env)().performance.getEntriesByType && (0, _env.env)().performance.getEntriesByType('resource') || emptyVal;
    } catch (e) {
      return emptyVal;
    }
  },
  getTiming: function getTiming() {
    return (0, _env.env)() && (0, _env.env)().performance ? (0, _env.env)().performance.timing : {};
  },
  clearResourceTimings: function clearResourceTimings() {
    (0, _env.env)() && (0, _env.env)().performance && (0, _env.env)().performance.clearResourceTimings && (0, _env.env)().performance.clearResourceTimings();
  },


  /**
   * Duration relative to navigation start (env().performance.timing.navigationStart)
   * fallback to: performance.now -> now (nodejs) -> getTime()
   */
  now: function now() {
    if ((0, _env.env)() && (0, _env.env)().performance && (0, _env.env)().performance.now) {
      return (0, _env.env)().performance.now();
    } else if (typeof performance !== 'undefined' && performance && performance.now) {
      return performance.now();
    }

    return new Date().getTime();
  },


  /**
   * Create a performance timestamp
   */
  mark: function mark(name) {
    if (_location2.default.isFedopsDev()) {
      (0, _env.env)() && (0, _env.env)().performance && (0, _env.env)().performance.mark && (0, _env.env)().performance.mark(name);
    }
  },


  /**
   * Record a performance measurement
   */
  measure: function measure(name, startMark, endMark) {
    if (_location2.default.isFedopsDev()) {
      (0, _env.env)() && (0, _env.env)().performance && (0, _env.env)().performance.measure && (0, _env.env)().performance.measure(name, startMark, endMark);
    }
  }
};

/***/ }),

/***/ 80:
/*!****************************************************************************!*\
  !*** ./WidgetApp/platform/offering-list-widget-controller.ts + 14 modules ***!
  \****************************************************************************/
/*! exports provided: getMockedProps, createControllerFactory, createOfferingListWidgetController, createMainPageController */
/*! all exports used */
/*! ModuleConcatenation bailout: Cannot concat with ../node_modules/@wix/app-settings-client/dist/es/src/index.js */
/*! ModuleConcatenation bailout: Cannot concat with ../node_modules/@wix/bookings-adapter-ooi-wix-sdk/dist/src/WixOOISDKAdapter.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/bi-logger-adapter.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/bookings-bi-defaults.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ../node_modules/@wix/bookings-adapters-reporting/dist/src/fedops/fedops-adapter.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ../node_modules/@wix/bookings-adapters-reporting/dist/src/sentry/sentry-adapter.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ../node_modules/@wix/bookings-uou-domain/dist/src/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ../node_modules/data-capsule/dist/src/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./Shared/appKeys/DefaultSettings.ts */
/*! ModuleConcatenation bailout: Cannot concat with ./Shared/utils.ts */
/*! ModuleConcatenation bailout: Cannot concat with ./WidgetApp/adapters/reporting/bi-logger/bi.const.ts */
/*! ModuleConcatenation bailout: Cannot concat with ./WidgetApp/constants/bookings.const.ts */
/*! ModuleConcatenation bailout: Cannot concat with ./WidgetApp/platform/navigation/navigation.const.ts */
/*! ModuleConcatenation bailout: Cannot concat with ../node_modules/tslib/tslib.es6.js (<- Module is referenced from these modules with unsupported syntax: ../node_modules/@wix/bookings-adapter-ooi-wix-sdk/dist/src/WixOOISDKAdapter.js (referenced with cjs require), ../node_modules/@wix/bookings-adapter-wix-sdk/dist/src/WixMock.js (referenced with cjs require), ../node_modules/@wix/bookings-adapter-wix-sdk/dist/src/WixSDKAdapter.js (referenced with cjs require), ../node_modules/@wix/bookings-adapter-wix-sdk/dist/src/WixSDKFakeAdapter.js (referenced with cjs require), ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/bookings-bi-defaults.js (referenced with cjs require), ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/ssr-logger/SSRLogger.js (referenced with cjs require), ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/web-logger/bookings-bi-defaults.js (referenced with cjs require), ../node_modules/@wix/bookings-viewer-ui/dist/src/assets/icons/dist/components/CloseIcon.js (referenced with cjs require), ../node_modules/@wix/bookings-viewer-ui/dist/src/components/Modal/TpaModal.js (referenced with cjs require), ../node_modules/@wix/bookings-viewer-ui/dist/src/components/UserMessage/UserMessage.js (referenced with cjs require), ../node_modules/@wix/js-sdk-wrapper/dist/src/create-wix-sdk-wrapper.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/button-next/button-next.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/checkbox/Checkbox.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/deprecated/button/Button.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/input/Input.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/popover/Popover.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/popover/index.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/popover/modifiers.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/toggle-switch/ToggleSwitch.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/tooltip/Tooltip.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/components/tooltip/index.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/hocs/Focusable/FocusableHOC.js (referenced with cjs require), ../node_modules/wix-ui-core/dist/src/utils/withStylable/withStylable.js (referenced with cjs require)) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// CONCATENATED MODULE: ../node_modules/@wix/bookings-adapter-http-api/dist/es/src/api/http-adapter.js

var XSRF_HEADER_NAME = 'X-XSRF-TOKEN';
function handleRawResponse(rawResponse, expectResponseData) {
    if (rawResponse.status !== 200) {
        var urlWithoutDomain = rawResponse.url && rawResponse.url.replace(/^.*\/\/[^\/]+/, '');
        throw new Error("Got " + rawResponse.statusText + " (" + rawResponse.status + ") when requested: " + urlWithoutDomain);
    }
    return expectResponseData ? rawResponse.json() : {};
}
function createHttpCall(method, url, config, expectResponse, data) {
    var init = tslib_es6["__assign"]({}, config, { method: method });
    if (data) {
        init.body = JSON.stringify(data);
    }
    return fetch(url, init).then(function (res) { return handleRawResponse(res, expectResponse); });
}
function httpAdapterFactory(instance, revision, csrfToken) {
    var getConfig = function (csrfTokenNeeded) {
        if (csrfTokenNeeded === void 0) { csrfTokenNeeded = false; }
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'x-wix-scheduler-instance': instance,
                'x-wix-site-revision': revision,
                authorization: instance,
            },
        };
        if (csrfTokenNeeded && csrfToken) {
            config.headers[XSRF_HEADER_NAME] = csrfToken;
        }
        return config;
    };
    return {
        get: function (url, specificConfig) {
            if (specificConfig === void 0) { specificConfig = getConfig(); }
            return createHttpCall('get', url, specificConfig, true);
        },
        put: function (url, data, expectResponse) {
            if (expectResponse === void 0) { expectResponse = false; }
            return createHttpCall('put', url, getConfig(true), expectResponse, data);
        },
        post: function (url, data, expectResponse) {
            if (expectResponse === void 0) { expectResponse = false; }
            return createHttpCall('post', url, getConfig(true), expectResponse, data);
        },
        delete: function (url, expectResponse) {
            if (expectResponse === void 0) { expectResponse = false; }
            return createHttpCall('delete', url, getConfig(true), expectResponse);
        },
        getBookingsServerName: function (serverBaseUrl) {
            if (serverBaseUrl === void 0) { serverBaseUrl = '/'; }
            return createHttpCall('get', serverBaseUrl + "_api/bookings-backend-migration-manager/v2/migration/business", getConfig(), true).then(function (data) {
                return data.platform === 'NEW' ? 'bookings-viewer' : 'scheduler-server';
            });
        },
    };
}
//# sourceMappingURL=http-adapter.js.map
// CONCATENATED MODULE: ../node_modules/@wix/bookings-adapter-http-api/dist/es/src/index.js

//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./WidgetApp/platform/api/bookingsAPI.ts


var bookingsAPI_BookingsAPI = /** @class */ (function () {
    function BookingsAPI(instance, staticsBaseUrl, serverBaseUrl, siteRevision, csrfToken) {
        if (siteRevision === void 0) { siteRevision = null; }
        if (csrfToken === void 0) { csrfToken = null; }
        var _this = this;
        this.staticsBaseUrl = staticsBaseUrl;
        this.serverBaseUrl = serverBaseUrl;
        this.siteRevision = siteRevision;
        this.csrfToken = csrfToken;
        this.notifyOwnerNonPricingPlanEnrollmentAttempt = function (data) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
            var base;
            return tslib_es6["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBookingsPrefixUrl()];
                    case 1:
                        base = _a.sent();
                        return [2 /*return*/, this.httpAdapter.post(base + "/pricing-plans/invalidSetup", data)];
                }
            });
        }); };
        this.notifyOwnerNonPremiumEnrollmentAttempt = function () { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
            var base;
            return tslib_es6["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBookingsPrefixUrl()];
                    case 1:
                        base = _a.sent();
                        return [2 /*return*/, this.httpAdapter.post(base + "/classes/nonPremium", '')];
                }
            });
        }); };
        this.httpAdapter = httpAdapterFactory(instance, siteRevision, csrfToken);
    }
    BookingsAPI.prototype.getTranslations = function (locale) {
        return tslib_es6["__awaiter"](this, void 0, void 0, function () {
            return tslib_es6["__generator"](this, function (_a) {
                return [2 /*return*/, this.httpAdapter.get(this.staticsBaseUrl + "assets/locales/WidgetApp/messages_" + locale + ".json", null)];
            });
        });
    };
    BookingsAPI.prototype.getWidgetData = function (externalId, allowInjection) {
        if (allowInjection === void 0) { allowInjection = true; }
        return tslib_es6["__awaiter"](this, void 0, Promise, function () {
            return tslib_es6["__generator"](this, function (_a) {
                return [2 /*return*/, this.canUseInjectedData(allowInjection)
                        ? this.getWidgetDataFromWindow()
                        : this.httpAdapter.get(this.serverBaseUrl + "_api/bookings-widget/config" + (externalId ? "?externalId=" + externalId : ''))];
            });
        });
    };
    BookingsAPI.prototype.getBookingsPrefixUrl = function () {
        return tslib_es6["__awaiter"](this, void 0, void 0, function () {
            var serverName;
            return tslib_es6["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpAdapter.getBookingsServerName(this.serverBaseUrl)];
                    case 1:
                        serverName = _a.sent();
                        return [2 /*return*/, this.serverBaseUrl + "_api/" + serverName + "/visitor"];
                }
            });
        });
    };
    BookingsAPI.prototype.canUseInjectedData = function (allowInjection) {
        return (allowInjection &&
            typeof window !== 'undefined' &&
            window.__OFFERINGS__ &&
            window.__CATEGORIES__ &&
            window.__ACTIVE_FEATURES__ &&
            window.__BUSINESS_INFO__ &&
            window.__EXPERIMENTS__ &&
            window.__LOCALE__);
    };
    BookingsAPI.prototype.getWidgetDataFromWindow = function () {
        return tslib_es6["__awaiter"](this, void 0, Promise, function () {
            return tslib_es6["__generator"](this, function (_a) {
                return [2 /*return*/, {
                        offerings: JSON.parse(window.__OFFERINGS__),
                        categories: JSON.parse(window.__CATEGORIES__),
                        config: {
                            resourcesFiltered: false,
                            businessInfo: JSON.parse(window.__BUSINESS_INFO__),
                            activeFeatures: window.__ACTIVE_FEATURES__,
                            experiments: JSON.parse(window.__EXPERIMENTS__),
                            locale: window.__LOCALE__,
                        },
                    }];
            });
        });
    };
    return BookingsAPI;
}());


// EXTERNAL MODULE: ./WidgetApp/adapters/reporting/bi-logger/bi.const.ts
var bi_const = __webpack_require__(27);

// EXTERNAL MODULE: ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/bi-logger-adapter.js
var bi_logger_adapter = __webpack_require__(157);

// EXTERNAL MODULE: ../node_modules/@wix/bookings-adapters-reporting/dist/src/bi-logger/bookings-bi-defaults.js
var bookings_bi_defaults = __webpack_require__(304);

// CONCATENATED MODULE: ./WidgetApp/adapters/reporting/bi-logger/bi-logger.ts




var bi_logger_BiLogger = /** @class */ (function () {
    function BiLogger(wixSdkAdapter, experiments) {
        if (experiments === void 0) { experiments = {}; }
        this.wixSdkAdapter = wixSdkAdapter;
        var biLoggerDefaultConfigurations = Object(bookings_bi_defaults["getWebBiLoggerDefaultsConfigForViewer"])(wixSdkAdapter, bi_const["c" /* WIDGET_NAME_PHASE_1 */]);
        this.biLoggerAdapter = new bi_logger_adapter["BiLoggerAdapterBuilder"]()
            .withLogger({
            biLoggerDefaultConfigurations: biLoggerDefaultConfigurations,
            wixSdkAdapter: wixSdkAdapter,
            experiments: experiments,
        })
            .build();
    }
    BiLogger.prototype.sendWidgetClick = function (service_id, type, referralInfo) {
        return tslib_es6["__awaiter"](this, void 0, Promise, function () {
            var data;
            return tslib_es6["__generator"](this, function (_a) {
                data = tslib_es6["__assign"]({}, bi_const["d" /* WidgetViewerEvents */].WIDGET_VIEWER_CLICK, { referralInfo: referralInfo,
                    service_id: service_id, type: bi_const["a" /* BI_OFFERING_TYPE */][type] || type });
                return [2 /*return*/, this.biLoggerAdapter.log(data)];
            });
        });
    };
    BiLogger.prototype.sendViewerOpened = function (numOfServices) {
        return tslib_es6["__awaiter"](this, void 0, Promise, function () {
            var data;
            return tslib_es6["__generator"](this, function (_a) {
                if (!this.wixSdkAdapter.isEditorMode()) {
                    data = tslib_es6["__assign"]({ numOfServices: numOfServices }, bi_const["d" /* WidgetViewerEvents */].WIDGET_VIEWER_PAGE_LOADED);
                    return [2 /*return*/, this.biLoggerAdapter.log(data)];
                }
                return [2 /*return*/];
            });
        });
    };
    BiLogger.prototype.sendCantBookGroup = function () {
        return tslib_es6["__awaiter"](this, void 0, Promise, function () {
            var data;
            return tslib_es6["__generator"](this, function (_a) {
                data = tslib_es6["__assign"]({}, bi_const["d" /* WidgetViewerEvents */].WIDGET_CANT_BOOK_GROUPS, { referralInfo: bi_const["b" /* WIDGET_BI_REFERRAL */].WIDGET });
                return [2 /*return*/, this.biLoggerAdapter.log(data)];
            });
        });
    };
    return BiLogger;
}());


// EXTERNAL MODULE: ../node_modules/@wix/bookings-adapter-ooi-wix-sdk/dist/src/WixOOISDKAdapter.js
var WixOOISDKAdapter = __webpack_require__(305);

// EXTERNAL MODULE: ../node_modules/@wix/bookings-uou-domain/dist/src/index.js
var src = __webpack_require__(3);

// EXTERNAL MODULE: ./Shared/appKeys/DefaultSettings.ts
var DefaultSettings = __webpack_require__(19);

// CONCATENATED MODULE: ./WidgetApp/domain/dummy-category-dto.ts


var DUMMY_CATEGORY_1 = 'dummy-category-id-1';
var DUMMY_CATEGORY_2 = 'dummy-category-id-2';
var DUMMY_CATEGORY_3 = 'dummy-category-id-3';
var createDummyCategoriesDto = function (presetId) {
    if (presetId === DefaultSettings["a" /* BOOKINGS_MAIN_PAGE_PRESET_ID */]) {
        return [
            new src["OfferingCategoryDtoBuilder"]()
                .withCategoryId(DUMMY_CATEGORY_1)
                .withName('dummy.category-1.bookings.main.page.name')
                .build(),
            new src["OfferingCategoryDtoBuilder"]()
                .withCategoryId(DUMMY_CATEGORY_2)
                .withName('dummy.category-2.bookings.main.page.name')
                .build(),
            new src["OfferingCategoryDtoBuilder"]()
                .withCategoryId(DUMMY_CATEGORY_3)
                .withName('dummy.category-3.bookings.main.page.name')
                .build(),
        ];
    }
    return [
        new src["OfferingCategoryDtoBuilder"]()
            .withCategoryId(DUMMY_CATEGORY_1)
            .withName('dummy.category-1.bookings.main.page.name')
            .build(),
    ];
};

// CONCATENATED MODULE: ./WidgetApp/domain/dummy-offering-dto.ts



var createDummyOfferingsDto = function (presetId) {
    var _a;
    var dummyMap = (_a = {},
        _a[DefaultSettings["b" /* CLASSIC_PRESET_ID */]] = createClassicDummyOfferingsDto,
        _a[DefaultSettings["d" /* OVERLAPPING_PRESET_ID */]] = createOverlappingDummyOfferingsDto,
        _a[DefaultSettings["e" /* STRIP_PRESET_ID */]] = createStripDummyOfferingsDto,
        _a[DefaultSettings["c" /* GRID_PRESET_ID */]] = createGridDummyOfferingsDto,
        _a[DefaultSettings["a" /* BOOKINGS_MAIN_PAGE_PRESET_ID */]] = createBookingsMainPageDummyOfferingsDto,
        _a);
    return dummyMap[presetId]();
};
var createClassicDummyOfferingsDto = function () {
    var dummyOfferings = [];
    var dummyOffering1 = new src["CatalogOfferingDtoBuilder"]()
        .withType(src["OfferingType"].INDIVIDUAL)
        .withId('classic-offering-1')
        .withCategoryId(DUMMY_CATEGORY_1)
        .withPayment(new src["OfferingPaymentDtoBuilder"]().withPrice(65).build())
        .withScheduleHeader(new src["OfferingScheduleHeaderDtoBuilder"]().withDurationInMinutes(60).build())
        .withInfo(new src["OfferingInfoDtoBuilder"]()
        .withImages({
        fileName: 'e320d0_9627064079e24613a681d754a8f9d12a~mv2_d_5161_3492_s_4_2.jpg',
        relativeUri: 'e320d0_9627064079e24613a681d754a8f9d12a~mv2_d_5161_3492_s_4_2.jpg',
        width: 5161,
        height: 3492,
    })
        .withName('dummy.offering-1.classic.name')
        .withTagLine('dummy.offering-1.classic.tagLine')
        .build())
        .withDummyIndication()
        .build();
    var dummyOffering2 = new src["CatalogOfferingDtoBuilder"]()
        .withType(src["OfferingType"].GROUP)
        .withId('classic-offering-2')
        .withCategoryId(DUMMY_CATEGORY_1)
        .withScheduleHeader(new src["OfferingScheduleHeaderDtoBuilder"]()
        .withDurationInMinutes(60)
        .withDays([src["WeekDay"].MONDAY, src["WeekDay"].WEDNESDAY])
        .build())
        .withPayment(new src["OfferingPaymentDtoBuilder"]()
        .withPriceText('dummy.offering-2.classic.price')
        .withIsFree(true)
        .build())
        .withInfo(new src["OfferingInfoDtoBuilder"]()
        .withImages({
        fileName: 'e320d0_162c0c4c748f4dac9b8dfc615224f084~mv2_d_8688_5792_s_4_2.jpg',
        relativeUri: 'e320d0_162c0c4c748f4dac9b8dfc615224f084~mv2_d_8688_5792_s_4_2.jpg',
        width: 8688,
        height: 5792,
    })
        .withName('dummy.offering-2.classic.name')
        .withTagLine('dummy.offering-2.classic.tagLine')
        .build())
        .withDummyIndication()
        .build();
    var dummyOffering3 = new src["CatalogOfferingDtoBuilder"]()
        .withType(src["OfferingType"].GROUP)
        .withId('classic-offering-3')
        .withCategoryId(DUMMY_CATEGORY_1)
        .withScheduleHeader(new src["OfferingScheduleHeaderDtoBuilder"]()
        .withDurationInMinutes(60)
        .withDays([
        src["WeekDay"].SUNDAY,
        src["WeekDay"].MONDAY,
        src["WeekDay"].TUESDAY,
        src["WeekDay"].WEDNESDAY,
        src["WeekDay"].THURSDAY,
        src["WeekDay"].FRIDAY,
        src["WeekDay"].SATURDAY,
    ])
        .build())
        .withPayment(new src["OfferingPaymentDtoBuilder"]().withPrice(30).build())
        .withInfo(new src["OfferingInfoDtoBuilder"]()
        .withImages({
        fileName: 'e320d0_605a7d8912fa41e399a403b35473df21~mv2_d_5256_3504_s_4_2.jpg',
        relativeUri: 'e320d0_605a7d8912fa41e399a403b35473df21~mv2_d_5256_3504_s_4_2.jpg',
        width: 5256,
        height: 3504,
    })
        .withName('dummy.offering-3.classic.name')
        .withTagLine('dummy.offering-3.classic.tagLine')
        .build())
        .withDummyIndication()
        .build();
    dummyOfferings.push(dummyOffering1, dummyOffering2, dummyOffering3);
    return dummyOfferings;
};
var createOverlappingDummyOfferingsDto = function () {
    var dummyOfferings = [];
    var dummyOffering1 = new src["CatalogOfferingDtoBuilder"]()
        .withType(src["OfferingType"].INDIVIDUAL)
        .withId('overlapping-offering-1')
        .withCategoryId(DUMMY_CATEGORY_1)
        .withScheduleHeader(new src["OfferingScheduleHeaderDtoBuilder"]().withDurationInMinutes(45).build())
        .withInfo(new src["OfferingInfoDtoBuilder"]()
        .withImages({
        fileName: 'e320d0_4270cd9b89284829855132e19c2d9736~mv2_d_4827_3620_s_4_2.jpg',
        height: 3620,
        relativeUri: 'e320d0_4270cd9b89284829855132e19c2d9736~mv2_d_4827_3620_s_4_2.jpg',
        width: 4827,
    })
        .withName('dummy.offering-1.overlapping.name')
        .withTagLine('dummy.offering-1.overlapping.tagLine')
        .build())
        .withPayment(new src["OfferingPaymentDtoBuilder"]().withPrice(60).build())
        .withDummyIndication()
        .build();
    var dummyOffering2 = new src["CatalogOfferingDtoBuilder"]()
        .withType(src["OfferingType"].INDIVIDUAL)
        .withId('overlapping-offering-2')
        .withCategoryId(DUMMY_CATEGORY_1)
        .withScheduleHeader(new src["OfferingScheduleHeaderDtoBuilder"]().withDurationInMinutes(90).build())
        .withInfo(new src["OfferingInfoDtoBuilder"]()
        .withImages({
        fileName: 'e320d0_732503d3ad6444a9853df7245430c2c3~mv2_d_3247_2598_s_4_2.jpg',
        height: 2598,
        relativeUri: 'e320d0_732503d3ad6444a9853df7245430c2c3~mv2_d_3247_2598_s_4_2.jpg',
        width: 3247,
    })
        .withName('dummy.offering-2.overlapping.name')
        .withTagLine('dummy.offering-2.overlapping.tagLine')
        .build())
        .withPayment(new src["OfferingPaymentDtoBuilder"]().withPrice(125).build())
        .withDummyIndication()
        .build();
    dummyOfferings.push(dummyOffering1, dummyOffering2);
    return dummyOfferings;
};
var createStripDummyOfferingsDto = function () {
    var dummyOfferings = [];
    var dummyOffering1 = new src["CatalogOfferingDtoBuilder"]()
        .withType(src["OfferingType"].INDIVIDUAL)
        .withId('strip-offering-1')
        .withCategoryId(DUMMY_CATEGORY_1)
        .withScheduleHeader(new src["OfferingScheduleHeaderDtoBuilder"]().withDurationInMinutes(60).build())
        .withPayment(new src["OfferingPaymentDtoBuilder"]().withPrice(75).build())
        .withInfo(new src["OfferingInfoDtoBuilder"]()
        .withName('dummy.offering-1.strip.name')
        .withTagLine('dummy.offering-1.strip.tagLine')
        .withImages({
        fileName: 'e320d0_29611b1016934f0db572caa6580f3e42~mv2_d_5651_4129_s_4_2.jpg',
        relativeUri: 'e320d0_29611b1016934f0db572caa6580f3e42~mv2_d_5651_4129_s_4_2.jpg',
        width: 5651,
        height: 4129,
    })
        .build())
        .withDummyIndication()
        .build();
    var dummyOffering2 = new src["CatalogOfferingDtoBuilder"]()
        .withType(src["OfferingType"].INDIVIDUAL)
        .withId('strip-offering-2')
        .withCategoryId(DUMMY_CATEGORY_1)
        .withScheduleHeader(new src["OfferingScheduleHeaderDtoBuilder"]().withDurationInMinutes(50).build())
        .withPayment(new src["OfferingPaymentDtoBuilder"]().withPrice(40).build())
        .withInfo(new src["OfferingInfoDtoBuilder"]()
        .withName('dummy.offering-2.strip.name')
        .withTagLine('dummy.offering-2.strip.tagLine')
        .withImages({
        fileName: 'e320d0_13daa3827adc40219d0c97bc2fb0a727~mv2_d_5651_4277_s_4_2.jpg',
        relativeUri: 'e320d0_13daa3827adc40219d0c97bc2fb0a727~mv2_d_5651_4277_s_4_2.jpg',
        width: 5651,
        height: 4277,
    })
        .build())
        .withDummyIndication()
        .build();
    var dummyOffering3 = new src["CatalogOfferingDtoBuilder"]()
        .withType(src["OfferingType"].INDIVIDUAL)
        .withId('strip-offering-3')
        .withCategoryId(DUMMY_CATEGORY_1)
        .withScheduleHeader(new src["OfferingScheduleHeaderDtoBuilder"]().withDurationInMinutes(90).build())
        .withPayment(new src["OfferingPaymentDtoBuilder"]().withPrice(130).build())
        .withInfo(new src["OfferingInfoDtoBuilder"]()
        .withName('dummy.offering-3.strip.name')
        .withTagLine('dummy.offering-3.strip.tagLine')
        .withImages({
        fileName: 'e320d0_8dc880b9d5d2460bbb8bbd03e0edd010~mv2_d_4820_3595_s_4_2.jpg',
        relativeUri: 'e320d0_8dc880b9d5d2460bbb8bbd03e0edd010~mv2_d_4820_3595_s_4_2.jpg',
        width: 4820,
        height: 3595,
    })
        .build())
        .withDummyIndication()
        .build();
    dummyOfferings.push(dummyOffering1, dummyOffering2, dummyOffering3);
    return dummyOfferings;
};
var createGridDummyOfferingsDto = function () {
    var dummyOfferings = [];
    var dummyOffering1 = new src["CatalogOfferingDtoBuilder"]()
        .withType(src["OfferingType"].INDIVIDUAL)
        .withId('grid-offering-1')
        .withCategoryId(DUMMY_CATEGORY_1)
        .withScheduleHeader(new src["OfferingScheduleHeaderDtoBuilder"]().withDurationInMinutes(30).build())
        .withPayment(new src["OfferingPaymentDtoBuilder"]().withPrice(25).build())
        .withInfo(new src["OfferingInfoDtoBuilder"]()
        .withImages({
        fileName: 'e320d0_25769c6286544ecbbd9a1219fb73ebcc~mv2_d_3549_2366_s_2.jpg',
        relativeUri: 'e320d0_25769c6286544ecbbd9a1219fb73ebcc~mv2_d_3549_2366_s_2.jpg',
        width: 3549,
        height: 2366,
    })
        .withName('dummy.offering-1.grid.name')
        .withTagLine('dummy.offering-1.grid.tagLine')
        .build())
        .withDummyIndication()
        .build();
    var dummyOffering2 = new src["CatalogOfferingDtoBuilder"]()
        .withType(src["OfferingType"].INDIVIDUAL)
        .withId('grid-offering-2')
        .withCategoryId(DUMMY_CATEGORY_1)
        .withScheduleHeader(new src["OfferingScheduleHeaderDtoBuilder"]().withDurationInMinutes(120).build())
        .withPayment(new src["OfferingPaymentDtoBuilder"]().withPrice(40).build())
        .withInfo(new src["OfferingInfoDtoBuilder"]()
        .withImages({
        fileName: 'e320d0_8eee9c23acfa496fb842bbb69c4fc988~mv2_d_5267_3511_s_4_2.jpg',
        relativeUri: 'e320d0_8eee9c23acfa496fb842bbb69c4fc988~mv2_d_5267_3511_s_4_2.jpg',
        width: 5267,
        height: 3511,
    })
        .withName('dummy.offering-2.grid.name')
        .withTagLine('dummy.offering-2.grid.tagLine')
        .build())
        .withDummyIndication()
        .build();
    var dummyOffering3 = new src["CatalogOfferingDtoBuilder"]()
        .withType(src["OfferingType"].INDIVIDUAL)
        .withId('grid-offering-3')
        .withCategoryId(DUMMY_CATEGORY_1)
        .withScheduleHeader(new src["OfferingScheduleHeaderDtoBuilder"]().withDurationInMinutes(30).build())
        .withPayment(new src["OfferingPaymentDtoBuilder"]().withPrice(20).build())
        .withInfo(new src["OfferingInfoDtoBuilder"]()
        .withImages({
        fileName: 'e320d0_49b1212e0cce4cbf8c6c524efa58ea63~mv2_d_5184_3456_s_4_2.jpg',
        relativeUri: 'e320d0_49b1212e0cce4cbf8c6c524efa58ea63~mv2_d_5184_3456_s_4_2.jpg',
        width: 5184,
        height: 3456,
    })
        .withName('dummy.offering-3.grid.name')
        .withTagLine('dummy.offering-3.grid.tagLine')
        .build())
        .withDummyIndication()
        .build();
    dummyOfferings.push(dummyOffering1, dummyOffering2, dummyOffering3);
    return dummyOfferings;
};
var createBookingsMainPageDummyOfferingsDto = function () {
    var dummyOfferings = [];
    var dummyOffering1 = createDummyOfferingForMainPage(DUMMY_CATEGORY_1, createImageDto('413707c67361480983896a2e55509f29.jpg', 4527, 3018));
    var dummyOffering2 = createDummyOfferingForMainPage(DUMMY_CATEGORY_1, createImageDto('2c2ed29dab6946dfb37072e57fd294a3.jpg', 3666, 2435));
    var dummyOffering3 = createDummyOfferingForMainPage(DUMMY_CATEGORY_1, createImageDto('6142ea7f91914d1c9bee8f8380110f78.jpg', 2607, 1738));
    var dummyOffering4 = createDummyOfferingForMainPage(DUMMY_CATEGORY_2, createImageDto('f656fb99b72847c7b66e01324d843074.jpg', 2144, 1432));
    var dummyOffering5 = createDummyOfferingForMainPage(DUMMY_CATEGORY_2, createImageDto('bfc7011abc1642358204a81111b9e72b.jpg', 1761, 1175));
    var dummyOffering6 = createDummyOfferingForMainPage(DUMMY_CATEGORY_2, createImageDto('e2d524c78f3842a1b74dc3b2f4827727.jpg', 1984, 1324));
    var dummyOffering7 = createDummyOfferingForMainPage(DUMMY_CATEGORY_3, createImageDto('a781e4805ee549c193112e17192b376c.jpg', 1592, 1061));
    var dummyOffering8 = createDummyOfferingForMainPage(DUMMY_CATEGORY_3, createImageDto('7f70fae2af3e444d9ab8c3b7698a6c1a.jpg', 4865, 3247));
    var dummyOffering9 = createDummyOfferingForMainPage(DUMMY_CATEGORY_3, createImageDto('d18f6586a05443c8a8d4b671cee5ea4c.jpg', 2401, 1500));
    dummyOfferings.push(dummyOffering1, dummyOffering2, dummyOffering3, dummyOffering4, dummyOffering5, dummyOffering6, dummyOffering7, dummyOffering8, dummyOffering9);
    return dummyOfferings;
};
var createDummyOfferingForMainPage = function (categoryId, image) {
    return new src["CatalogOfferingDtoBuilder"]()
        .withType(src["OfferingType"].INDIVIDUAL)
        .withId('main-page-offering-3')
        .withCategoryId(categoryId)
        .withPayment(new src["OfferingPaymentDtoBuilder"]().withPrice(45).build())
        .withScheduleHeader(new src["OfferingScheduleHeaderDtoBuilder"]().withDurationInMinutes(60).build())
        .withInfo(new src["OfferingInfoDtoBuilder"]()
        .withImages(image)
        .withName('dummy.offering.bookings.main.page.name')
        .withTagLine('')
        .build())
        .withDummyIndication()
        .build();
};
var createImageDto = function (url, width, height) {
    return new src["ImageDtoBuilder"]()
        .withFileName(url)
        .withRelativeUri(url)
        .withHeight(height)
        .withWidth(width)
        .build();
};

// EXTERNAL MODULE: ../node_modules/@wix/bookings-adapters-reporting/dist/src/fedops/fedops-adapter.js
var fedops_adapter = __webpack_require__(306);

// EXTERNAL MODULE: ../node_modules/@wix/bookings-adapters-reporting/dist/src/sentry/sentry-adapter.js
var sentry_adapter = __webpack_require__(128);

// EXTERNAL MODULE: ../node_modules/@wix/app-settings-client/dist/es/src/index.js + 9 modules
var es_src = __webpack_require__(45);

// CONCATENATED MODULE: ./WidgetApp/adapters/app-settings/app-client-adapter.ts

var app_client_adapter_AppClientAdapter = /** @class */ (function () {
    function AppClientAdapter(_a) {
        var appDefId = _a.appDefId, instanceId = _a.instanceId, externalId = _a.externalId;
        this.appDefId = appDefId;
        this.instanceId = instanceId;
        this.externalId = externalId;
    }
    AppClientAdapter.prototype.getAppDefId = function () {
        return this.appDefId;
    };
    AppClientAdapter.prototype.getInstanceId = function () {
        return this.instanceId;
    };
    AppClientAdapter.prototype.getExternalId = function () {
        return tslib_es6["__awaiter"](this, void 0, Promise, function () {
            return tslib_es6["__generator"](this, function (_a) {
                return [2 /*return*/, this.externalId];
            });
        });
    };
    AppClientAdapter.prototype.setExternalId = function (id) {
        return tslib_es6["__awaiter"](this, void 0, Promise, function () { return tslib_es6["__generator"](this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    AppClientAdapter.prototype.triggerSettingsUpdated = function (data, scope) { };
    AppClientAdapter.prototype.onSettingsUpdated = function (scope, cb) { };
    return AppClientAdapter;
}());


// EXTERNAL MODULE: ../node_modules/data-capsule/dist/src/index.js
var dist_src = __webpack_require__(148);

// EXTERNAL MODULE: ./WidgetApp/platform/navigation/navigation.const.ts
var navigation_const = __webpack_require__(25);

// CONCATENATED MODULE: ./WidgetApp/platform/navigation/navigation.ts





var WidgetDeepLinkConst;
(function (WidgetDeepLinkConst) {
    WidgetDeepLinkConst["REFRESH_APP"] = "widgetRefreshApp";
})(WidgetDeepLinkConst || (WidgetDeepLinkConst = {}));
var StorageConst;
(function (StorageConst) {
    StorageConst["DEEP_LINK"] = "deepLink";
})(StorageConst || (StorageConst = {}));
var ClientConst;
(function (ClientConst) {
    ClientConst["BOOKINGS_PAGE_ID"] = "bookingsPageId";
})(ClientConst || (ClientConst = {}));
var navigation_Navigation = /** @class */ (function () {
    function Navigation(wixSdkAdapter, compId) {
        this.wixSdkAdapter = wixSdkAdapter;
        this.compId = compId;
    }
    Navigation.prototype.navigateToApp = function (offering, intent) {
        return tslib_es6["__awaiter"](this, void 0, Promise, function () {
            return tslib_es6["__generator"](this, function (_a) {
                if (this.wixSdkAdapter.isRunningInIframe()) {
                    return [2 /*return*/, this.legacyNavigateToApp(offering, intent)];
                }
                return [2 /*return*/, this.ooiNavigateToApp(offering, intent)];
            });
        });
    };
    Navigation.prototype.ooiNavigateToApp = function (offering, intent) {
        return tslib_es6["__awaiter"](this, void 0, void 0, function () {
            var suffix;
            return tslib_es6["__generator"](this, function (_a) {
                suffix = "/" + offering.urlName + (this.shouldNavigateToCalendar(offering, intent) ? '/book' : '');
                return [2 /*return*/, this.wixSdkAdapter.navigateToBookingsWithSuffix(suffix)];
            });
        });
    };
    Navigation.prototype.shouldNavigateToCalendar = function (offering, intent) {
        return (intent === navigation_const["a" /* OfferingIntent */].BOOK_OFFERING &&
            offering.type !== src["OfferingType"].COURSE);
    };
    Navigation.prototype.legacyNavigateToApp = function (offering, intent) {
        return tslib_es6["__awaiter"](this, void 0, void 0, function () {
            var capsule, onNavigationBySectionIdFailed, isBookCheckoutInstalled;
            return tslib_es6["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.legacyStoreDataCapsule(offering, intent)];
                    case 1:
                        capsule = _a.sent();
                        onNavigationBySectionIdFailed = function () {
                            window.Wix.Utils.navigateToSection({});
                        };
                        return [4 /*yield*/, this.wixSdkAdapter.isBookCheckoutInstalled()];
                    case 2:
                        isBookCheckoutInstalled = _a.sent();
                        window.Wix.Utils.navigateToSection({
                            sectionId: isBookCheckoutInstalled
                                ? src["BOOKINGS_CHECKOUT_SECTION_ID"]
                                : src["BOOKINGS_SCHEDULER_SECTION_ID"],
                        }, onNavigationBySectionIdFailed);
                        return [2 /*return*/, this.shouldRefreshBookings(capsule).then(function (shouldRefresh) {
                                if (shouldRefresh) {
                                    window.Wix.PubSub.publish(WidgetDeepLinkConst.REFRESH_APP);
                                }
                            })];
                }
            });
        });
    };
    Navigation.prototype.legacyStoreDataCapsule = function (offering, intent) {
        return tslib_es6["__awaiter"](this, void 0, void 0, function () {
            var capsule, data;
            return tslib_es6["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        capsule = new dist_src["DataCapsule"]({
                            strategy: new dist_src["FrameStorageStrategy"](window.top, '*', this.compId, {}),
                            namespace: 'wix',
                        });
                        if (!!offering.dummy) return [3 /*break*/, 2];
                        data = {
                            serviceId: offering.id,
                            intent: intent,
                            timestamp: new Date().getTime(),
                        };
                        return [4 /*yield*/, capsule.setItem(StorageConst.DEEP_LINK, data)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, capsule];
                }
            });
        });
    };
    Navigation.prototype.shouldRefreshBookings = function (capsule) {
        return new Promise(function (resolve) {
            capsule
                .getItem(ClientConst.BOOKINGS_PAGE_ID)
                .then(function (bookingsPageId) {
                window.Wix.getCurrentPageId(function (currPageId) {
                    return resolve(bookingsPageId === currPageId);
                });
            })
                .catch(function () { return resolve(false); });
        });
    };
    return Navigation;
}());


// CONCATENATED MODULE: ./WidgetApp/platform/validation/booking-validations.ts



var OfferedAsType;
(function (OfferedAsType) {
    OfferedAsType["ONE_TIME"] = "ONE_TIME";
    OfferedAsType["PRICING_PLAN"] = "PRICING_PLAN";
})(OfferedAsType || (OfferedAsType = {}));
var pricingPlanConst;
(function (pricingPlanConst) {
    pricingPlanConst["PAGE_NOT_INSTALLED"] = "PageNotInstalled";
    pricingPlanConst["NO_PLANS_ASSIGNED_TO_OFFERING"] = "NoPlansAssignedToOffering";
})(pricingPlanConst || (pricingPlanConst = {}));
var booking_validations_BookingValidations = /** @class */ (function () {
    function BookingValidations(wixSdkAdapter) {
        this.wixSdkAdapter = wixSdkAdapter;
    }
    BookingValidations.prototype.shouldNavigate = function (offering, isGroupActiveFeature, intent) {
        return tslib_es6["__awaiter"](this, void 0, Promise, function () {
            return tslib_es6["__generator"](this, function (_a) {
                if (intent === navigation_const["a" /* OfferingIntent */].SHOW_DETAILS ||
                    this.wixSdkAdapter.isPreviewMode() ||
                    this.wixSdkAdapter.isDemoMode()) {
                    return [2 /*return*/, { canBook: true }];
                }
                return [2 /*return*/, this.canBook(offering, isGroupActiveFeature)];
            });
        });
    };
    BookingValidations.prototype.canBook = function (offering, isGroupActiveFeature) {
        var _this = this;
        return this.wixSdkAdapter
            .isPricingPlanInstalled()
            .then(function (isPricingPlanInstalled) {
            var couldBePremium = _this.couldBePremiumNavigate(offering, isGroupActiveFeature);
            var couldBePricingPlan = couldBePricingPlanNavigate(offering, isPricingPlanInstalled);
            return {
                canBook: couldBePremium && couldBePricingPlan.canBook,
                reason: {
                    premiumError: !couldBePremium,
                    pricingPlanError: !couldBePricingPlan.canBook,
                    isOfferingConnectedToPricingPlans: couldBePricingPlan.isOfferingConnectedToPricingPlans,
                    isPricingPlanInstalled: isPricingPlanInstalled,
                },
            };
        });
    };
    BookingValidations.prototype.couldBePremiumNavigate = function (offering, isGroupActiveFeature) {
        return (offering.type === src["OfferingType"].INDIVIDUAL ||
            offering.type === src["OfferingType"].COURSE ||
            isGroupActiveFeature);
    };
    return BookingValidations;
}());

function couldBePricingPlanNavigate(offering, isPricingPlanInstalled) {
    var isOfferingConnectedToPricingPlans = isOfferingConnectedToPricingPlan(offering);
    var offeringOfferedAsPricingPlan = isOfferingOfferedAsPricingPlan(offering, isPricingPlanInstalled);
    return {
        canBook: !offeringOfferedAsPricingPlan ||
            (isOfferingConnectedToPricingPlans && isPricingPlanInstalled),
        isOfferingConnectedToPricingPlans: isOfferingConnectedToPricingPlans,
    };
}
var isOfferingConnectedToPricingPlan = function (offering) {
    return !!(offering.pricingPlanInfo &&
        offering.pricingPlanInfo.pricingPlans &&
        offering.pricingPlanInfo.pricingPlans.length);
};
var isOfferingOfferedAsPricingPlan = function (offeringViewModel, isPricingPlanInstalled) {
    return getOfferedAs(offeringViewModel, isPricingPlanInstalled).indexOf(OfferedAsType.PRICING_PLAN) > -1;
};
var getOfferedAs = function (offering, isPricingPlanInstalled) {
    if (offering.offeredAs.indexOf(OfferedAsType.ONE_TIME) >= 0 &&
        offering.offeredAs.indexOf(OfferedAsType.PRICING_PLAN) >= 0) {
        if (offering.pricingPlanInfo.pricingPlans.length === 0) {
            return [OfferedAsType.ONE_TIME];
        }
        if (!isPricingPlanInstalled) {
            return [OfferedAsType.ONE_TIME];
        }
    }
    return offering.offeredAs;
};
var getNotifyPricingPlanRequest = function (offering, reason) {
    var reasons = [];
    if (!reason.isPricingPlanInstalled) {
        reasons.push(pricingPlanConst.PAGE_NOT_INSTALLED);
    }
    if (!reason.isOfferingConnectedToPricingPlans) {
        reasons.push(pricingPlanConst.NO_PLANS_ASSIGNED_TO_OFFERING);
    }
    var offeringId = offering.id;
    return { reasons: reasons, offeringId: offeringId };
};

// CONCATENATED MODULE: ./Server/domain/widget.ts
var FilterType;
(function (FilterType) {
    FilterType["SPECIFIC"] = "SPECIFIC";
    FilterType["ALL"] = "ALL";
})(FilterType || (FilterType = {}));

// CONCATENATED MODULE: ./Server/client-kit/shared-utils.ts

function getSelectedResources(settingsResponse) {
    return ((settingsResponse && settingsResponse.SELECTED_RESOURCES) || {
        filter: FilterType.ALL,
    });
}
function filterSelectedCatalogOfferings(catalogOfferings, selectedResources) {
    if (selectedResources) {
        return selectedResources.filter === FilterType.ALL
            ? catalogOfferings
            : catalogOfferings.filter(function (catalogOffering) {
                return selectedResources.offerings.includes(catalogOffering.id) ||
                    selectedResources.categories.includes(catalogOffering.categoryId);
            });
    }
    return catalogOfferings;
}
function filterOutEmptyCategories(catalogCategories, selectedCatalogOfferings) {
    var relevantCategoryIds = new Set(selectedCatalogOfferings.map(function (offering) { return offering.categoryId; }));
    return catalogCategories.filter(function (category) {
        return relevantCategoryIds.has(category.id);
    });
}
function filterResourcesByUserSettings(offerings, categories, settingsData) {
    var selectedResources = getSelectedResources(settingsData);
    var selectedOfferings = filterSelectedCatalogOfferings(offerings, selectedResources);
    var selectedCategories = filterOutEmptyCategories(categories, selectedOfferings);
    return {
        offerings: selectedOfferings,
        categories: selectedCategories,
    };
}

// CONCATENATED MODULE: ./WidgetApp/adapters/reporting/analytics-adapter/analytics-adapter.ts



var TrackingConst;
(function (TrackingConst) {
    TrackingConst["CLICK_PRODUCT"] = "ClickProduct";
    TrackingConst["INITIATE_CHECKOUT"] = "InitiateCheckout";
})(TrackingConst || (TrackingConst = {}));
var EVENT_ORIGIN_BOOKINGS = 'Bookings';
var track = function (eventId, payload, isEditorMode, trackEventFunc) {
    if (!isEditorMode) {
        trackEventFunc(eventId, tslib_es6["__assign"]({ origin: EVENT_ORIGIN_BOOKINGS, appDefId: src["BOOKINGS_APP_DEF_ID"] }, payload));
    }
};
var trackOfferingClickFromWidget = function (offering, position, isEditorMode, businessName, trackEventFunc) {
    trackOfferingClick(offering, position, 'Service Widget', isEditorMode, businessName, trackEventFunc);
};
var trackOfferingBookingClick = function (offering, businessName, isEditorMode, trackEventFunc) {
    track(TrackingConst.INITIATE_CHECKOUT, {
        contents: [getTrackingEventOfferingFromOffering(offering, businessName)],
    }, isEditorMode, trackEventFunc);
};
var getVariant = function (offeringType) {
    return offeringType === src["OfferingType"].INDIVIDUAL
        ? 'PRIVATE'
        : offeringType === src["OfferingType"].GROUP
            ? 'GROUP'
            : 'COURSE';
};
var getTrackingEventOfferingFromOffering = function (offering, businessName) { return ({
    id: offering.id,
    name: offering.name,
    brand: businessName,
    category: '',
    variant: getVariant(offering.type),
    price: offering.price,
    currency: offering.currency,
}); };
var trackOfferingClick = function (offering, position, viewSource, isEditorMode, businessName, trackEventFunc) {
    track(TrackingConst.CLICK_PRODUCT, {
        name: offering.name,
        id: offering.id,
        list: viewSource,
        brand: businessName,
        category: '',
        variant: getVariant(offering.type),
        position: position,
        price: offering.price,
        currency: offering.currency,
    }, isEditorMode, trackEventFunc);
};
var logToGoogleAnalytics = function (intent, businessName, offering, isEditorMode, trackEventFunc) {
    if (intent === navigation_const["a" /* OfferingIntent */].BOOK_OFFERING) {
        trackOfferingBookingClick(offering, businessName, isEditorMode, trackEventFunc);
    }
    else {
        trackOfferingClickFromWidget(offering, 0, isEditorMode, businessName, trackEventFunc);
    }
};

// EXTERNAL MODULE: ./WidgetApp/constants/bookings.const.ts
var bookings_const = __webpack_require__(65);

// CONCATENATED MODULE: ./WidgetApp/platform/bookingsConfiguration/main-page-additional-configuration.ts



var main_page_additional_configuration_MainPageAdditionalConfiguration = /** @class */ (function () {
    function MainPageAdditionalConfiguration() {
        var _this = this;
        this.getWidgetId = function () { return src["BOOKINGS_LIST_PAGE_ID"]; };
        this.getWidgetName = function () { return bookings_const["a" /* FEDOPS_MAIN_PAGE_NAME */]; };
        this.prePageReady = function (wixOOISDKAdapter) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
            var suffix;
            return tslib_es6["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!wixOOISDKAdapter.isRunningInIframe()) return [3 /*break*/, 4];
                        return [4 /*yield*/, wixOOISDKAdapter.getBookingsUrlSuffix()];
                    case 1:
                        suffix = _a.sent();
                        return [4 /*yield*/, shouldNavigateToBookCheckout(wixOOISDKAdapter, suffix)];
                    case 2:
                        if (!_a.sent()) return [3 /*break*/, 4];
                        return [4 /*yield*/, wixOOISDKAdapter.navigateToBookingsWithSuffix(suffix)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    }
    return MainPageAdditionalConfiguration;
}());

function shouldNavigateToBookCheckout(wixOOISDKAdapter, suffix) {
    return tslib_es6["__awaiter"](this, void 0, void 0, function () {
        var bookCheckoutInstalled;
        return tslib_es6["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, wixOOISDKAdapter.isBookCheckoutInstalled()];
                case 1:
                    bookCheckoutInstalled = _a.sent();
                    return [2 /*return*/, bookCheckoutInstalled && !!suffix];
            }
        });
    });
}

// CONCATENATED MODULE: ./WidgetApp/platform/bookingsConfiguration/offering-list-widget-additional-configuration.ts


var offering_list_widget_additional_configuration_OfferingListWidgetAdditionalConfiguration = /** @class */ (function () {
    function OfferingListWidgetAdditionalConfiguration() {
        this.getWidgetId = function () { return src["BOOKINGS_OFFERING_LIST_WIDGET_ID"]; };
        this.getWidgetName = function () { return bookings_const["b" /* FEDOPS_WIDGET_APP_NAME */]; };
        this.prePageReady = function () { return Promise.resolve(); };
    }
    return OfferingListWidgetAdditionalConfiguration;
}());


// EXTERNAL MODULE: ./Shared/utils.ts
var utils = __webpack_require__(32);

// CONCATENATED MODULE: ./WidgetApp/platform/offering-list-widget-controller.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMockedProps", function() { return getMockedProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createControllerFactory", function() { return createControllerFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOfferingListWidgetController", function() { return createOfferingListWidgetController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMainPageController", function() { return createMainPageController; });
var offering_list_widget_controller_this = undefined;


















function getMockedProps() {
    return {
        getBusinessId: function () { return ''; },
    };
}
function shouldShowDummyModeInPreviewMode(wixSdkAdapter) {
    return tslib_es6["__awaiter"](this, void 0, void 0, function () {
        return tslib_es6["__generator"](this, function (_a) {
            return [2 /*return*/, (wixSdkAdapter.isPreviewMode() && wixSdkAdapter.isBookCheckoutInstalled())];
        });
    });
}
function shouldShowDummyMode(offerings, wixSdkAdapter) {
    return tslib_es6["__awaiter"](this, void 0, void 0, function () {
        var hasOfferings;
        return tslib_es6["__generator"](this, function (_a) {
            hasOfferings = offerings && offerings.length > 0;
            return [2 /*return*/, (!hasOfferings &&
                    (wixSdkAdapter.isEditorMode() ||
                        shouldShowDummyModeInPreviewMode(wixSdkAdapter)))];
        });
    });
}
var initEventListeners = function (settings, setProps, originalWidgetData, wixSdkAdapter) {
    settings.onChange(function (settingsUserData) { return tslib_es6["__awaiter"](offering_list_widget_controller_this, void 0, void 0, function () {
        var newProps, _a, offerings, categories, _b, _c, _d;
        return tslib_es6["__generator"](this, function (_e) {
            switch (_e.label) {
                case 0:
                    newProps = { settingsUserData: settingsUserData };
                    if (originalWidgetData.offerings && originalWidgetData.offerings.length) {
                        _a = filterResourcesByUserSettings(originalWidgetData.offerings, originalWidgetData.categories, settingsUserData), offerings = _a.offerings, categories = _a.categories;
                        newProps.offerings = offerings;
                        newProps.categories = categories;
                    }
                    _b = setProps;
                    _c = [{}, newProps];
                    _d = {};
                    return [4 /*yield*/, wixSdkAdapter.getScale()];
                case 1:
                    _b.apply(void 0, [tslib_es6["__assign"].apply(void 0, _c.concat([(_d.scale = _e.sent(), _d)]))]);
                    return [2 /*return*/];
            }
        });
    }); });
    window.Wix.addEventListener('STYLE_PARAMS_CHANGE', function (data) { return tslib_es6["__awaiter"](offering_list_widget_controller_this, void 0, void 0, function () {
        var presetData, currentSettingsDefaultData, _a, siteColors, siteTextPresets;
        return tslib_es6["__generator"](this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Object(utils["b" /* getPresetId */])()];
                case 1:
                    presetData = _b.sent();
                    if (!(presetData && presetData.presetId)) {
                        return [2 /*return*/];
                    }
                    currentSettingsDefaultData = DefaultSettings["f" /* defaultSettingsDataMap */].get(presetData.presetId);
                    return [4 /*yield*/, Object(utils["a" /* getCurrentStyles */])()];
                case 2:
                    _a = _b.sent(), siteColors = _a[0], siteTextPresets = _a[1];
                    console.log('STYLE_PARAMS_CHANGE');
                    setProps({
                        style: {
                            siteTextPresets: siteTextPresets,
                            siteColors: siteColors,
                            styleParams: data,
                        },
                        settingsDefaultData: currentSettingsDefaultData,
                    });
                    return [2 /*return*/];
            }
        });
    }); });
};
var createSettings = function (_a) {
    var setProps = _a.setProps, appDefId = _a.appDefId, externalId = _a.externalId, originalWidgetData = _a.originalWidgetData, wixSdkAdapter = _a.wixSdkAdapter;
    var settings;
    if (wixSdkAdapter.isEditorMode()) {
        settings = Object(es_src["b" /* appClient */])({ scope: es_src["a" /* Scope */].COMPONENT });
        initEventListeners(settings, setProps, originalWidgetData, wixSdkAdapter);
    }
    else {
        settings = Object(es_src["b" /* appClient */])({
            scope: es_src["a" /* Scope */].COMPONENT,
            adapter: new app_client_adapter_AppClientAdapter({
                appDefId: appDefId,
                instanceId: wixSdkAdapter.getInstanceId(),
                externalId: externalId,
            }),
        });
    }
    return settings;
};
function initiateUserMessages(setProps) {
    var userMessage = {
        shouldDisplayMessage: false,
        closeMessage: function () {
            hideMessage();
        },
    };
    var showMessage = function () {
        userMessage.shouldDisplayMessage = true;
        setProps({
            userMessage: userMessage,
        });
    };
    var hideMessage = function () {
        userMessage.shouldDisplayMessage = false;
        setProps({
            userMessage: userMessage,
        });
    };
    return { userMessage: userMessage, showMessage: showMessage };
}
var createControllerFactory = function (bookingsAdditionalConfiguratio) { return function (_a) {
    var compId = _a.compId, type = _a.type, config = _a.config, $w = _a.$w, warmupData = _a.warmupData, setProps = _a.setProps, appParams = _a.appParams, platformAPIs = _a.platformAPIs, wixCodeApi = _a.wixCodeApi;
    return {
        pageReady: function () {
            return tslib_es6["__awaiter"](this, void 0, void 0, function () {
                var wixSdkAdapter, staticsBaseUrl, httpAdapter, locale, bookingsValidations, _a, widgetData, translations, settings, presetId, settingsDefaultData, getAllSettings, settingsUserData, _b, biLogger, fedopsAdapter, filteredResources, offerings, categories, isDummyMode, navigation, biLoggerDriver, _c, userMessage, showMessage, businessInfo, handleNavigation, navigationDriver, appLoadedCallback, setContainerHeight, setContainerWidth, setContainerDimensions, platformContext, _d, _e, _f;
                return tslib_es6["__generator"](this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            wixSdkAdapter = new WixOOISDKAdapter["WixOOISDKAdapter"](wixCodeApi, platformAPIs, appParams, compId);
                            return [4 /*yield*/, bookingsAdditionalConfiguratio.prePageReady(wixSdkAdapter)];
                        case 1:
                            _g.sent();
                            staticsBaseUrl = wixSdkAdapter.getServiceListStaticsBaseUrl();
                            httpAdapter = new bookingsAPI_BookingsAPI(appParams.instance, staticsBaseUrl, wixSdkAdapter.getServerBaseUrl(), wixSdkAdapter.getSiteRevision(), wixSdkAdapter.getCsrfToken());
                            locale = wixSdkAdapter.getCurrentLanguage();
                            bookingsValidations = new booking_validations_BookingValidations(wixSdkAdapter);
                            return [4 /*yield*/, Promise.all([
                                    httpAdapter.getWidgetData(config.externalId, true),
                                    httpAdapter.getTranslations(locale),
                                ])];
                        case 2:
                            _a = _g.sent(), widgetData = _a[0], translations = _a[1];
                            if (!(locale !== widgetData.config.locale)) return [3 /*break*/, 4];
                            wixSdkAdapter.setCurrentLanguage(widgetData.config.locale);
                            locale = wixSdkAdapter.getCurrentLanguage();
                            return [4 /*yield*/, httpAdapter.getTranslations(locale)];
                        case 3:
                            translations = _g.sent();
                            _g.label = 4;
                        case 4:
                            settings = createSettings({
                                setProps: setProps,
                                appDefId: appParams.appDefinitionId,
                                externalId: config.externalId,
                                originalWidgetData: widgetData,
                                wixSdkAdapter: wixSdkAdapter,
                            });
                            presetId = config.publicData.COMPONENT && config.publicData.COMPONENT.presetId
                                ? config.publicData.COMPONENT.presetId
                                : DefaultSettings["a" /* BOOKINGS_MAIN_PAGE_PRESET_ID */];
                            settingsDefaultData = DefaultSettings["f" /* defaultSettingsDataMap */].get(presetId);
                            getAllSettings = function () {
                                try {
                                    return settings.getAll();
                                }
                                catch (_a) {
                                    return {};
                                }
                            };
                            _b = widgetData.config.settings;
                            if (_b) return [3 /*break*/, 6];
                            return [4 /*yield*/, getAllSettings()];
                        case 5:
                            _b = (_g.sent());
                            _g.label = 6;
                        case 6:
                            settingsUserData = _b;
                            biLogger = new bi_logger_BiLogger(wixSdkAdapter, widgetData.config.experiments);
                            fedopsAdapter = new fedops_adapter["FedopsAdapter"](wixSdkAdapter, bookingsAdditionalConfiguratio.getWidgetName(), bookingsAdditionalConfiguratio.getWidgetId());
                            filteredResources = widgetData.config.resourcesFiltered && widgetData.config.settings
                                ? {
                                    offerings: widgetData.offerings,
                                    categories: widgetData.categories,
                                }
                                : filterResourcesByUserSettings(widgetData.offerings, widgetData.categories, settingsUserData);
                            offerings = filteredResources.offerings;
                            categories = filteredResources.categories;
                            return [4 /*yield*/, shouldShowDummyMode(offerings, wixSdkAdapter)];
                        case 7:
                            isDummyMode = _g.sent();
                            categories = isDummyMode
                                ? createDummyCategoriesDto(presetId)
                                : categories;
                            offerings = isDummyMode ? createDummyOfferingsDto(presetId) : offerings;
                            navigation = new navigation_Navigation(wixSdkAdapter, compId);
                            biLoggerDriver = {
                                sendViewerOpened: function (serviceId) { return biLogger.sendViewerOpened(serviceId); },
                                sendWidgetClick: function (serviceId, offeringType, referralInfo) {
                                    return biLogger.sendWidgetClick(serviceId, offeringType, referralInfo);
                                },
                            };
                            _c = initiateUserMessages(setProps), userMessage = _c.userMessage, showMessage = _c.showMessage;
                            businessInfo = widgetData.config.businessInfo;
                            handleNavigation = function (offering, intent) {
                                var isGroupActiveFeature = JSON.parse(widgetData.config.activeFeatures).groups;
                                bookingsValidations
                                    .shouldNavigate(offering, isGroupActiveFeature, intent)
                                    .then(function (_a) {
                                    var canBook = _a.canBook, reason = _a.reason;
                                    if (canBook) {
                                        logToGoogleAnalytics(intent, businessInfo.name, offering, wixSdkAdapter.isEditorMode(), function (trackEvid, payload) {
                                            return wixSdkAdapter.trackEvent(trackEvid, payload);
                                        });
                                        navigation.navigateToApp(offering, intent).catch(console.log);
                                    }
                                    else {
                                        if (reason) {
                                            if (reason.premiumError) {
                                                httpAdapter
                                                    .notifyOwnerNonPremiumEnrollmentAttempt()
                                                    .then(function () { return null; })
                                                    .catch(console.error);
                                            }
                                            else if (reason.pricingPlanError) {
                                                httpAdapter
                                                    .notifyOwnerNonPricingPlanEnrollmentAttempt(getNotifyPricingPlanRequest(offering, reason))
                                                    .then(function () { return null; })
                                                    .catch(console.error);
                                            }
                                        }
                                        biLogger.sendCantBookGroup().catch(console.log);
                                        showMessage();
                                    }
                                })
                                    .catch(console.log);
                            };
                            navigationDriver = {
                                navigateToApp: function (offering, intent) {
                                    handleNavigation(offering, intent);
                                },
                            };
                            appLoadedCallback = function () {
                                fedopsAdapter.logAppLoaded();
                            };
                            setContainerHeight = function (newHeight) {
                                wixSdkAdapter.setContainerHeight(newHeight);
                            };
                            setContainerWidth = function (width) {
                                if (wixSdkAdapter.isEditorMode()) {
                                    window.Wix.resizeComponent({
                                        width: width,
                                    });
                                }
                            };
                            setContainerDimensions = function (newWidth, newHeight) {
                                if (wixSdkAdapter.isEditorMode()) {
                                    wixSdkAdapter.setContainerDimensions(newWidth, newHeight);
                                }
                            };
                            platformContext = {
                                isDummyMode: isDummyMode,
                                isRTL: wixSdkAdapter.isViewDirectionRtl(),
                                isEditorMode: wixSdkAdapter.isEditorMode(),
                                isSSR: wixSdkAdapter.isSSR(),
                            };
                            if (wixSdkAdapter.isSSR()) {
                                fedopsAdapter.logAppLoaded();
                            }
                            _d = setProps;
                            _e = [{}, getMockedProps()];
                            _f = { locale: locale,
                                offerings: offerings,
                                categories: categories,
                                settingsDefaultData: settingsDefaultData,
                                settingsUserData: settingsUserData, cssBaseUrl: staticsBaseUrl, translations: translations,
                                biLoggerDriver: biLoggerDriver,
                                navigationDriver: navigationDriver,
                                setContainerHeight: setContainerHeight,
                                setContainerWidth: setContainerWidth,
                                setContainerDimensions: setContainerDimensions,
                                appLoadedCallback: appLoadedCallback, ravenUserContextOverrides: {
                                    id: Object(sentry_adapter["getRavenSessionIdForApp"])(appParams),
                                }, canReportLoading: !wixSdkAdapter.isSSR(), userMessage: userMessage,
                                platformContext: platformContext, isRTL: platformContext.isRTL, experiments: widgetData.config.experiments };
                            return [4 /*yield*/, wixSdkAdapter.getScale()];
                        case 8:
                            _d.apply(void 0, [tslib_es6["__assign"].apply(void 0, _e.concat([(_f.scale = _g.sent(), _f)]))]);
                            return [2 /*return*/];
                    }
                });
            });
        },
    };
}; };
var createOfferingListWidgetController = createControllerFactory(new offering_list_widget_additional_configuration_OfferingListWidgetAdditionalConfiguration());
var createMainPageController = createControllerFactory(new main_page_additional_configuration_MainPageAdditionalConfiguration());


/***/ }),

/***/ 81:
/*!*********************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/domains/price-domain.js ***!
  \*********************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var offering_dto_1 = __webpack_require__(/*! ../offerings/offering.dto */ 16);
var currencySymbolMap = __webpack_require__(/*! currency-symbol-map/map */ 168);
var price_dto_factory_1 = __webpack_require__(/*! ./price-dto-factory */ 89);
var currencyFixesOverrides = {
    KZT: '₸',
};
var fixedCurrencySymbolMap = __assign({}, currencySymbolMap, currencyFixesOverrides);
var PriceDomain = /** @class */ (function () {
    function PriceDomain(priceDto, offeredAs) {
        this.priceDto = priceDto;
        this.offeredAs = offeredAs;
    }
    Object.defineProperty(PriceDomain.prototype, "text", {
        get: function () {
            if (this.shouldShowPlanText()) {
                return this.priceDto.displayTextForPlan;
            }
            if (this.shouldShowOfferingPrice()) {
                var symbol = fixedCurrencySymbolMap[this.priceDto.currency];
                return "" + symbol + this.formattedPrice();
            }
            if (this.shouldShowFreeOfferingText()) {
                return this.priceDto.priceText;
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    PriceDomain.prototype.shouldShowPlanText = function () {
        return (this.offeredAs.indexOf(offering_dto_1.OfferedAsType.PRICING_PLAN) > -1 &&
            this.priceDto.displayTextForPlan);
    };
    PriceDomain.prototype.shouldShowOfferingPrice = function () {
        return (this.offeredAs.indexOf(offering_dto_1.OfferedAsType.ONE_TIME) > -1 &&
            this.offeredAs.indexOf(offering_dto_1.OfferedAsType.PRICING_PLAN) <= -1 &&
            !this.priceDto.isFree);
    };
    PriceDomain.prototype.shouldShowFreeOfferingText = function () {
        return (this.offeredAs.indexOf(offering_dto_1.OfferedAsType.ONE_TIME) > -1 &&
            this.offeredAs.indexOf(offering_dto_1.OfferedAsType.PRICING_PLAN) <= -1 &&
            this.priceDto.isFree);
    };
    PriceDomain.prototype.formattedPrice = function () {
        var price = Number(this.priceDto.price);
        return price.toFixed(price_dto_factory_1.PriceUtils.getFractionDigits(price));
    };
    return PriceDomain;
}());
exports.PriceDomain = PriceDomain;
//# sourceMappingURL=price-domain.js.map

/***/ }),

/***/ 82:
/*!************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/domains/duration-domain.js ***!
  \************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var offering_dto_1 = __webpack_require__(/*! ../offerings/offering.dto */ 16);
var moment = __webpack_require__(/*! moment */ 30);
var DurationDomain = /** @class */ (function () {
    function DurationDomain(offeringType, duration) {
        this.offeringType = offeringType;
        this.duration = duration;
    }
    DurationDomain.prototype.getTextByFormat = function (formatter) {
        return this.offeringType === offering_dto_1.OfferingType.COURSE
            ? this.getCourseDurationText(this.duration.startDate, formatter)
            : this.getGeneralDurationText(this.duration.durationInMinutes, formatter);
    };
    DurationDomain.prototype.getCourseDurationText = function (startDate, formatter) {
        var startDateAsMoment = moment(startDate);
        var isDateInCurrentYear = function (date) {
            var now = moment().startOf('day');
            return now.format('YYYY') === date.format('YYYY');
        };
        var isDateInThePast = function (date) {
            var now = moment().startOf('day');
            return date.isBefore(now);
        };
        var dateTranslationKey = isDateInCurrentYear(startDateAsMoment)
            ? isDateInThePast(startDateAsMoment)
                ? "offering-schedule-summary.course.passed.same-year"
                : "offering-schedule-summary.course.same-year"
            : isDateInThePast(startDateAsMoment)
                ? "offering-schedule-summary.course.passed.different-year"
                : "offering-schedule-summary.course.different-year";
        return startDateAsMoment.format(formatter(dateTranslationKey));
    };
    DurationDomain.prototype.getGeneralDurationText = function (durationInMinutes, formatter) {
        var duration = moment.duration(durationInMinutes, 'minutes');
        var hours = Math.floor(duration.asHours());
        var minutes = duration.minutes();
        var minutesText = minutes + " " + formatter('duration.units.minutes');
        return hours
            ? hours + " " + formatter('duration.units.hours') +
                (minutes ? " " + minutesText : '')
            : minutesText;
    };
    return DurationDomain;
}());
exports.DurationDomain = DurationDomain;
//# sourceMappingURL=duration-domain.js.map

/***/ }),

/***/ 83:
/*!**********************************!*\
  !*** ../node_modules/uuid/v4.js ***!
  \**********************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(/*! ./lib/rng */ 226);
var bytesToUuid = __webpack_require__(/*! ./lib/bytesToUuid */ 227);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),

/***/ 85:
/*!************************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/entities/offering-payment/offering-payment-type.js ***!
  \************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PaymentType;
(function (PaymentType) {
    PaymentType["ONLINE"] = "ONLINE";
    PaymentType["OFFLINE"] = "OFFLINE";
    PaymentType["BOTH"] = "BOTH";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
//# sourceMappingURL=offering-payment-type.js.map

/***/ }),

/***/ 86:
/*!*********************************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/entities/offering-location/offering-location.dto.builder.js ***!
  \*********************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var offering_location_dto_1 = __webpack_require__(/*! ./offering-location.dto */ 87);
var OfferingLocationDtoBuilder = /** @class */ (function () {
    function OfferingLocationDtoBuilder() {
        this.location = {
            type: offering_location_dto_1.OfferingLocationType.BUSINESS,
            locationText: 'location text',
        };
    }
    OfferingLocationDtoBuilder.prototype.withType = function (type) {
        this.location.type = type;
        return this;
    };
    OfferingLocationDtoBuilder.prototype.withLocationText = function (locationText) {
        this.location.locationText = locationText;
        return this;
    };
    OfferingLocationDtoBuilder.prototype.build = function () {
        return this.location;
    };
    return OfferingLocationDtoBuilder;
}());
exports.OfferingLocationDtoBuilder = OfferingLocationDtoBuilder;
//# sourceMappingURL=offering-location.dto.builder.js.map

/***/ }),

/***/ 87:
/*!*************************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/entities/offering-location/offering-location.dto.js ***!
  \*************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OfferingLocationType;
(function (OfferingLocationType) {
    OfferingLocationType["CUSTOMER"] = "CUSTOMER";
    OfferingLocationType["BUSINESS"] = "BUSINESS";
    OfferingLocationType["OTHER"] = "OTHER";
})(OfferingLocationType = exports.OfferingLocationType || (exports.OfferingLocationType = {}));
//# sourceMappingURL=offering-location.dto.js.map

/***/ }),

/***/ 88:
/*!***********************************************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/entities/offering-schedule-policy/offering-schedule-policy.dto.builder.js ***!
  \***********************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OfferingSchedulePolicyDtoBuilder = /** @class */ (function () {
    function OfferingSchedulePolicyDtoBuilder() {
        this.schedulePolicy = {
            bookUpToXMinutesBefore: 0,
            maxParticipantsPerOrder: 1,
            capacity: 1,
            uouHidden: false,
            displayOnlyNoBookFlow: false,
            futureBookingsPolicy: {
                shouldLimit: false,
                limitXMinutesToTheFuture: 60,
            },
        };
    }
    OfferingSchedulePolicyDtoBuilder.prototype.withMaxParticipantsPerOrder = function (maxParticipantsPerOrder) {
        this.schedulePolicy.maxParticipantsPerOrder = maxParticipantsPerOrder;
        return this;
    };
    OfferingSchedulePolicyDtoBuilder.prototype.withCapacity = function (capacity) {
        this.schedulePolicy.capacity = capacity;
        return this;
    };
    OfferingSchedulePolicyDtoBuilder.prototype.withUouHidden = function (uouHidden) {
        this.schedulePolicy.uouHidden = uouHidden;
        return this;
    };
    OfferingSchedulePolicyDtoBuilder.prototype.withFutureBookingsPolicy = function (futureBookingsPolicy) {
        this.schedulePolicy.futureBookingsPolicy = futureBookingsPolicy;
        return this;
    };
    OfferingSchedulePolicyDtoBuilder.prototype.withBookUpToXMinutesBefore = function (bookUpToXMinutesBefore) {
        this.schedulePolicy.bookUpToXMinutesBefore = bookUpToXMinutesBefore;
        return this;
    };
    OfferingSchedulePolicyDtoBuilder.prototype.withDisplayOnlyNoBookFlow = function (displayOnlyNoBookFlow) {
        this.schedulePolicy.displayOnlyNoBookFlow = displayOnlyNoBookFlow;
        return this;
    };
    OfferingSchedulePolicyDtoBuilder.prototype.build = function () {
        return this.schedulePolicy;
    };
    return OfferingSchedulePolicyDtoBuilder;
}());
exports.OfferingSchedulePolicyDtoBuilder = OfferingSchedulePolicyDtoBuilder;
//# sourceMappingURL=offering-schedule-policy.dto.builder.js.map

/***/ }),

/***/ 89:
/*!**************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/domains/price-dto-factory.js ***!
  \**************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PriceDtoFactory = /** @class */ (function () {
    function PriceDtoFactory() {
    }
    PriceDtoFactory.fromOfferingDto = function (offeringDto) {
        return {
            currency: offeringDto.payment.currency,
            price: offeringDto.payment.price,
            isFree: offeringDto.payment.isFree,
            priceText: offeringDto.payment.priceText,
            minCharge: offeringDto.payment.minCharge,
            paymentType: offeringDto.payment.paymentType,
            displayTextForPlan: offeringDto.pricingPlanInfo
                ? offeringDto.pricingPlanInfo.displayText
                : '',
        };
    };
    return PriceDtoFactory;
}());
exports.PriceDtoFactory = PriceDtoFactory;
var PriceUtils = /** @class */ (function () {
    function PriceUtils() {
    }
    PriceUtils.getFractionDigits = function (price) {
        return price % 1 === 0 ? 0 : 2;
    };
    return PriceUtils;
}());
exports.PriceUtils = PriceUtils;
//# sourceMappingURL=price-dto-factory.js.map

/***/ }),

/***/ 90:
/*!***************************************************************************************************************************!*\
  !*** ../node_modules/@wix/bookings-uou-domain/dist/src/entities/offering-schedule-header/offering-schedule-header.dto.js ***!
  \***************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var WeekDay;
(function (WeekDay) {
    WeekDay["MONDAY"] = "mon";
    WeekDay["TUESDAY"] = "tue";
    WeekDay["WEDNESDAY"] = "wed";
    WeekDay["THURSDAY"] = "thu";
    WeekDay["FRIDAY"] = "fri";
    WeekDay["SATURDAY"] = "sat";
    WeekDay["SUNDAY"] = "sun";
})(WeekDay = exports.WeekDay || (exports.WeekDay = {}));
//# sourceMappingURL=offering-schedule-header.dto.js.map

/***/ }),

/***/ 94:
/*!**************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/dist/es/src/conf.js ***!
  \**************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var FEDOPS_BI_ENDPOINT = exports.FEDOPS_BI_ENDPOINT = 'fed';
var PERFORMANCE_BI_ENPOINT = exports.PERFORMANCE_BI_ENPOINT = 'performance';
var SESSION_ID_STORAGE_KEY = exports.SESSION_ID_STORAGE_KEY = 'fedops.logger.sessionId';
var DEFAULT_APP_VERSION = exports.DEFAULT_APP_VERSION = '0.0.0';

/***/ }),

/***/ 95:
/*!************************************************************************************************!*\
  !*** ../node_modules/@wix/fedops-logger/node_modules/@wix/web-bi-logger/dist/src/constants.js ***!
  \************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Host = 'frog.wix.com';
exports.LoggerVersion = '2.0.270';
var PublishMethods;
(function (PublishMethods) {
    PublishMethods["Auto"] = "auto";
    PublishMethods["PostMessage"] = "postMessage";
})(PublishMethods = exports.PublishMethods || (exports.PublishMethods = {}));
var Errors;
(function (Errors) {
    Errors[Errors["Unsupported"] = 0] = "Unsupported";
})(Errors = exports.Errors || (exports.Errors = {}));
var EventContextMap;
(function (EventContextMap) {
    EventContextMap["msid"] = "_msid";
    EventContextMap["clientId"] = "_client_id";
    EventContextMap["uuid"] = "_uuid";
    EventContextMap["visitorId"] = "_visitorId";
    EventContextMap["siteMemberId"] = "_siteMemberId";
})(EventContextMap = exports.EventContextMap || (exports.EventContextMap = {}));
//# sourceMappingURL=constants.js.map

/***/ }),

/***/ 96:
/*!*********************************************************!*\
  !*** ../node_modules/message-channel/dist/src/utils.js ***!
  \*********************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseConnectionMessage = exports.constructConnectionMessage = exports.parseChannelMessage = exports.constructChannelMessage = undefined;

var _constants = __webpack_require__(/*! ./constants */ 134);

var constructChannelMessage = exports.constructChannelMessage = function constructChannelMessage(payload, id) {
  if (!id) {
    return payload;
  }

  return id + _constants.messageDelimiter + payload;
};

var parseChannelMessage = exports.parseChannelMessage = function parseChannelMessage(message) {
  var firstDelimiterIndex = message.indexOf(_constants.messageDelimiter);
  if (firstDelimiterIndex === -1) {
    return { id: null, payload: message };
  }

  var id = message.slice(0, firstDelimiterIndex);
  var payload = message.slice(firstDelimiterIndex + 1);
  return { id: id, payload: payload };
};

var constructConnectionMessage = exports.constructConnectionMessage = function constructConnectionMessage(scope) {
  return _constants.connectionRequestMsg + _constants.messageDelimiter + scope;
};

var parseConnectionMessage = exports.parseConnectionMessage = function parseConnectionMessage(message) {
  var firstDelimiterIndex = message.indexOf(_constants.messageDelimiter);
  if (firstDelimiterIndex === -1 || message.slice(0, firstDelimiterIndex) !== _constants.connectionRequestMsg) {
    throw new Error('Invalid connection message');
  }

  var scope = message.slice(firstDelimiterIndex + 1);
  return scope;
};

/***/ })

/******/ });
});
//# sourceMappingURL=offeringListWidgetController.bundle.js.map